// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./root.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/primeicons/primeicons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/iuvity-ui-components/dist/resources/phone.styles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --rsbs-backdrop-bg: rgba(0, 0, 0, 0.6);
  --rsbs-bg: var(--backgroundColor);
  --rsbs-handle-bg: var(--borderAndLineColor);
  --rsbs-max-w: auto;
  --rsbs-ml: env(safe-area-inset-left);
  --rsbs-mr: env(safe-area-inset-right);
  --rsbs-overlay-rounded: 16px;
}

.second-box__personal-data {
  margin-top: 1rem;
  font-family: var(--fontDosisSemiBold);
  font-size: var(--font-size-desktop-subtitle);
  color: var(--mainColor);
}
.second-box__location-data {
  margin-top: 1rem;
  font-family: var(--fontDosisSemiBold);
  font-size: var(--font-size-desktop-subtitle);
  color: var(--mainColor);
}
.second-box .dt-appr-c {
  justify-content: flex-start;
}
.second-box .dt-appr-c .dt-ap-col {
  width: 50%;
}

.boxTitle {
  margin-bottom: var(--padding-level-sixteen);
  font-family: var(--fontDosisSemiBold);
  font-size: var(--font-size-desktop-subtitle);
  color: var(--mainColor);
}

.custom-form-box-container .boxTitle,
.picklist-points--container__title .boxTitle,
.schedules-points--container__title .boxTitle,
.picklist-points--view__title .boxTitle {
  margin-bottom: 0px;
}

.sk-appr-c {
  padding: 0 10%;
  margin-bottom: 1rem !important;
}

.dt-appr-c {
  align-items: flex-start;
  display: flex;
  justify-content: center;
  padding: 1.5rem 3rem;
  gap: 4rem;
}
.dt-appr-c .dt-ap-col {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}
.dt-appr-c .dt-ap-col .dt-ap-item {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 2rem;
}
.dt-appr-c .dt-ap-col .dt-ap-item:last-of-type {
  margin-bottom: 0;
}
.dt-appr-c .dt-ap-col .dt-ap-item .item-title {
  align-self: flex-start;
  color: var(--labelsAndTextColor);
  font-family: var(--fontBarlowRegular);
  font-size: var(--font-size-sm);
  margin-bottom: 0.5rem;
}
.dt-appr-c .dt-ap-col .dt-ap-item .item-value {
  align-self: flex-start;
  color: var(--textsAndComponentTitleColor);
  font-family: var(--fontBarlowMedium);
  font-size: var(--font-size-md);
}

.flow-badge {
  background: var(--cardBackgroundColorTwo) 0% 0% no-repeat padding-box !important;
  border-radius: 0.25rem !important;
  display: inline-block;
  padding: 0.5rem !important;
  width: fit-content;
  background: var(--cardBackgroundColorTwo);
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 700;
  padding: 0.25rem 0.5rem;
  height: auto;
  font-family: var(--fontBarlowBold);
}
.flow-badge.ACTIVE {
  color: var(--successColor) !important;
}
.flow-badge.INACTIVE {
  color: var(--errorColor) !important;
}
.flow-badge.true {
  color: var(--successColor) !important;
}
.flow-badge.false {
  color: var(--errorColor) !important;
}

.confirmdialog-cancel.p-confirm-dialog {
  max-width: 25rem;
  width: 25rem;
  height: auto;
}
.confirmdialog-cancel.p-confirm-dialog .p-dialog-content {
  text-align: left;
  overflow-x: hidden !important;
}
.confirmdialog-cancel.p-confirm-dialog .p-dialog-content::-webkit-scrollbar {
  width: 0.5rem !important;
}
.confirmdialog-cancel.p-confirm-dialog .p-dialog-content::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey !important;
}
.confirmdialog-cancel.p-confirm-dialog .p-dialog-content::-webkit-scrollbar-thumb {
  background: grey !important;
}
.confirmdialog-cancel.p-confirm-dialog .p-dialog-footer {
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: flex-end;
  padding: 1.375rem;
}
.confirmdialog-cancel.p-confirm-dialog .p-dialog-footer .p-button-label {
  display: inline-block !important;
  width: fit-content !important;
}
.confirmdialog-cancel.p-confirm-dialog .p-dialog-footer .p-button {
  padding: 1rem 2rem;
}

.trx-m-f {
  background-color: white;
}
.trx-m-f .p-dialog-content {
  overflow-x: hidden !important;
  margin-right: 0.5rem !important;
}
.trx-m-f .p-dialog-content::-webkit-scrollbar {
  width: 0.5rem !important;
}
.trx-m-f .p-dialog-content::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px grey !important;
}
.trx-m-f .p-dialog-content::-webkit-scrollbar-thumb {
  background: grey !important;
}

.dialog-form {
  background-color: #ffffff;
  overflow: hidden !important;
}
.dialog-form .p-dialog-content {
  margin-right: 0.5rem !important;
  overflow-x: hidden !important;
}

#im-type-dropdown {
  z-index: 2000 !important;
}

.inactivity-reject-button {
  visibility: hidden;
}

.p-dialog-mask.body-mask-black {
  background: black !important;
}

.app-item {
  align-items: center;
  border-bottom: 1px solid var(--cardBackgroundColorOneShade10);
  cursor: pointer;
  display: flex;
  font-size: var(--font-size-lg);
  padding: 1.5rem 2rem;
  transition: background-color 0.3s ease-in;
}
.app-item:last-of-type {
  border-bottom: none;
}
.app-item:hover {
  background-color: rgb(231, 231, 231);
}

.pt {
  padding-top: 0.5rem !important;
}

.st-btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0.5rem 0rem !important;
  height: fit-content !important;
}
.st-btn .p-button-icon {
  font-size: 2rem !important;
}
.st-btn:focus-visible, .st-btn:focus {
  outline: none !important;
  box-shadow: none !important;
}

.st-label {
  color: white;
  font-family: var(--fontBarlowRegular);
  font-size: var(--font-size-xs);
}

.t-subheader-content {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  justify-content: center;
  margin: 1rem 3.75rem 0 1.5rem;
}

.form-container .form.md .pointsofattention-fields #input-label-name,
.form-container .form.md .pointsofattention-fields #input-label-code,
.form-container .form.md .pointsofattention-fields #input-label-pointServiceImage,
.form-container .form.md .agents-fields #input-label-name,
.form-container .form.md .agents-fields #input-label-code,
.form-container .form.md .agents-fields #input-label-pointServiceImage,
.form-container .form.md .app-fields #input-label-name,
.form-container .form.md .app-fields #input-label-code,
.form-container .form.md .app-fields #input-label-pointServiceImage,
.form-container .form.md .translation-fields #input-label-name,
.form-container .form.md .translation-fields #input-label-code,
.form-container .form.md .translation-fields #input-label-pointServiceImage {
  width: 20rem !important;
  max-width: 100% !important;
}
.form-container .form.md .pointsofattention-fields #input-label-description,
.form-container .form.md .pointsofattention-fields #input-label-url,
.form-container .form.md .pointsofattention-fields #input-label-publickey,
.form-container .form.md .pointsofattention-fields #input-label-version,
.form-container .form.md .agents-fields #input-label-description,
.form-container .form.md .agents-fields #input-label-url,
.form-container .form.md .agents-fields #input-label-publickey,
.form-container .form.md .agents-fields #input-label-version,
.form-container .form.md .app-fields #input-label-description,
.form-container .form.md .app-fields #input-label-url,
.form-container .form.md .app-fields #input-label-publickey,
.form-container .form.md .app-fields #input-label-version,
.form-container .form.md .translation-fields #input-label-description,
.form-container .form.md .translation-fields #input-label-url,
.form-container .form.md .translation-fields #input-label-publickey,
.form-container .form.md .translation-fields #input-label-version {
  width: 100% !important;
}
.form-container .form.md .pointsofattention-fields #dropdown-pointServiceType,
.form-container .form.md .pointsofattention-fields #dropdown-version,
.form-container .form.md .pointsofattention-fields #dropdown-status,
.form-container .form.md .agents-fields #dropdown-pointServiceType,
.form-container .form.md .agents-fields #dropdown-version,
.form-container .form.md .agents-fields #dropdown-status,
.form-container .form.md .app-fields #dropdown-pointServiceType,
.form-container .form.md .app-fields #dropdown-version,
.form-container .form.md .app-fields #dropdown-status,
.form-container .form.md .translation-fields #dropdown-pointServiceType,
.form-container .form.md .translation-fields #dropdown-version,
.form-container .form.md .translation-fields #dropdown-status {
  max-width: 90% !important;
}
.form-container .form.md .pointsofattention-fields #dropdown-tenantid,
.form-container .form.md .pointsofattention-fields #dropdown-segment,
.form-container .form.md .pointsofattention-fields #dropdown-currentversion,
.form-container .form.md .pointsofattention-fields #dropdown-installedversion,
.form-container .form.md .agents-fields #dropdown-tenantid,
.form-container .form.md .agents-fields #dropdown-segment,
.form-container .form.md .agents-fields #dropdown-currentversion,
.form-container .form.md .agents-fields #dropdown-installedversion,
.form-container .form.md .app-fields #dropdown-tenantid,
.form-container .form.md .app-fields #dropdown-segment,
.form-container .form.md .app-fields #dropdown-currentversion,
.form-container .form.md .app-fields #dropdown-installedversion,
.form-container .form.md .translation-fields #dropdown-tenantid,
.form-container .form.md .translation-fields #dropdown-segment,
.form-container .form.md .translation-fields #dropdown-currentversion,
.form-container .form.md .translation-fields #dropdown-installedversion {
  max-width: 90% !important;
}
.form-container .form.md .pointsofattention-fields #input-label-key,
.form-container .form.md .pointsofattention-fields #input-label-translationvalue,
.form-container .form.md .pointsofattention-fields #dropdown-type,
.form-container .form.md .pointsofattention-fields #dropdown-translationlanguage,
.form-container .form.md .pointsofattention-fields #multiselect-functionality,
.form-container .form.md .agents-fields #input-label-key,
.form-container .form.md .agents-fields #input-label-translationvalue,
.form-container .form.md .agents-fields #dropdown-type,
.form-container .form.md .agents-fields #dropdown-translationlanguage,
.form-container .form.md .agents-fields #multiselect-functionality,
.form-container .form.md .app-fields #input-label-key,
.form-container .form.md .app-fields #input-label-translationvalue,
.form-container .form.md .app-fields #dropdown-type,
.form-container .form.md .app-fields #dropdown-translationlanguage,
.form-container .form.md .app-fields #multiselect-functionality,
.form-container .form.md .translation-fields #input-label-key,
.form-container .form.md .translation-fields #input-label-translationvalue,
.form-container .form.md .translation-fields #dropdown-type,
.form-container .form.md .translation-fields #dropdown-translationlanguage,
.form-container .form.md .translation-fields #multiselect-functionality {
  width: 20rem !important;
  max-width: 100% !important;
}
.form-container .form.md .app-fields .label-container button {
  margin-left: 0 !important;
}

.form {
  align-items: flex-start;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  justify-content: center;
  width: 25rem;
}
.form .p-inputtext,
.form .ui-dropdown-wrapper,
.form .p-multiselect {
  max-width: 20rem !important;
  width: 20rem !important;
}
.form .p-input-icon:last-of-type {
  margin-bottom: 0 !important;
}
.form.sm {
  width: 20rem;
}
.form.md {
  width: 30rem;
}
.form.md .p-inputtext,
.form.md .p-dropdown,
.form.md .p-multiselect {
  width: 25rem !important;
  max-width: 25rem !important;
}
.form.lg {
  width: 35rem;
}
.form.lg .p-inputtext,
.form.lg .p-dropdown,
.form.lg .p-multiselect {
  width: 30rem !important;
  max-width: 30rem !important;
}
.form.left {
  align-items: flex-start;
}
.form.center {
  align-items: center;
}
.form .rd-only {
  border: none !important;
}

.lb {
  width: fit-content !important;
}

.p-sidebar {
  box-shadow: none !important;
  width: 20.25rem;
}
.p-sidebar .p-sidebar-header {
  background-color: var(--mainColor) !important;
  border: none !important;
}
.p-sidebar .p-sidebar-content {
  padding: 1.25rem !important;
}
.p-sidebar .p-sidebar-content .p-panelmenu .p-toggleable-content .p-panelmenu-content {
  background-color: var(--mainColorShade10);
}
.p-sidebar .p-sidebar-content .p-panelmenu .p-toggleable-content .p-panelmenu-content .p-submenu-list {
  padding-left: 0;
}
.p-sidebar .p-sidebar-content .p-panelmenu .p-toggleable-content .p-panelmenu-content .p-submenu-list:first-child {
  margin-top: var(--padding-level-eight);
}
.p-sidebar .p-sidebar-content .p-panelmenu .p-toggleable-content .p-panelmenu-content .p-submenu-list .p-menuitem {
  margin-bottom: var(--padding-level-eight);
}
.p-sidebar .p-sidebar-content .p-panelmenu .p-toggleable-content .p-panelmenu-content .p-submenu-list .p-menuitem .p-menuitem-link {
  padding: 0.625rem 1rem 0.625rem var(--padding-level-forty);
}
.p-sidebar .p-sidebar-content .p-panelmenu .p-toggleable-content .p-panelmenu-content .p-submenu-list .p-menuitem .p-menuitem-link .p-menuitem-text {
  font-family: var(--fontBarlowMedium) !important;
  line-height: 1.5;
}
.p-sidebar .p-sidebar-content .p-panelmenu .p-toggleable-content .p-panelmenu-content .p-submenu-list .p-menuitem .p-menuitem-link:has(.pi-angle-down) {
  background-color: var(--mainColorShade30);
}
.p-sidebar .p-sidebar-content .p-panelmenu .p-toggleable-content .p-panelmenu-content .p-submenu-list .p-menuitem .p-toggleable-content .p-submenu-list .p-menuitem-link {
  padding-left: var(--padding-level-sixty-four);
}
.p-sidebar .p-sidebar-content .p-panelmenu .p-toggleable-content .p-panelmenu-content .p-submenu-list .p-menuitem .p-toggleable-content .p-submenu-list .p-menuitem-link .p-menuitem-text {
  line-height: 1.5;
}
.p-sidebar .p-sidebar-content .p-panelmenu .p-menuitem-text {
  line-height: 1.5;
}
.p-sidebar .p-sidebar-content .p-panelmenu.p-component {
  height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
}
.p-sidebar .p-sidebar-content .p-panelmenu.p-component .p-panelmenu-panel {
  background-color: var(--mainColor);
  margin-bottom: var(--padding-level-sixteen);
}
.p-sidebar .p-sidebar-content .p-panelmenu.p-component .p-panelmenu-panel:last-of-type .p-component.p-panelmenu-header .p-panelmenu-header-link {
  margin-bottom: 0 !important;
}
.p-sidebar .p-sidebar-content.one-child .p-panelmenu-panel:nth-last-child(2) {
  margin-bottom: auto;
}
.p-sidebar .p-sidebar-content.two-childs .p-panelmenu-panel:nth-last-child(3) {
  margin-bottom: auto;
}
.p-sidebar .p-sidebar-content.three-childs .p-panelmenu-panel:nth-last-child(4) {
  margin-bottom: auto;
}

.sb-header-logo {
  height: 1.5rem;
  width: auto;
}

.sb-header-btn {
  align-items: center;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  outline: none;
  width: 100%;
  background-color: var(--mainColor);
  color: var(--cardBackgroundColorOne) !important;
}

.sb-header-text-c {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  justify-content: center;
  margin-left: 0.5rem;
  text-align: start;
}

.sidepanel__close-icon-container {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidepanel__close-icon-container .sb-header-icon {
  color: var(--cardBackgroundColorOne) !important;
  font-weight: bold !important;
}
.sidepanel__close-icon-container:hover {
  background-color: var(--backgroundHoverButtonHeader);
  border-radius: 50%;
}

.sb-header-title {
  color: var(--mainColor);
  font: var(--fontBarlowExtraBold);
  font-size: var(--font-size-md);
  font-weight: bold;
}

.sb-header-subtitle {
  color: var(--mainColor);
  font: var(--fontBarlowMedium);
  font-size: var(--font-size-md);
}

.dash-c {
  align-items: stretch;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-basis: 0;
  justify-content: center;
  height: 100%;
  width: 100%;
  z-index: 1;
}

.dash-content-c {
  display: grid;
  width: auto;
}

.dash-c-header {
  align-items: center;
  display: flex;
  gap: 2.5rem;
  justify-content: space-between;
  padding: 2.5rem 0 2rem;
  width: 100%;
}
.dash-c-header .title {
  padding-top: 0;
}

.dash-c-header-welcome .title {
  color: var(--mainColor) !important;
  font-family: var(--fontDosisBold);
  font-size: 1.25rem !important;
}
.dash-c-header-welcome .subtitle {
  font-family: var(--fontDosisSemiBold);
  font-size: 1.75rem !important;
  color: #333;
}

.dash-c-header-us-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.dash-c-header-us-info p {
  font-size: 0.875rem !important;
  color: #666;
}

.dash-c-header-extras {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: center;
}
.dash-c-header-extras .dash-extra-tools {
  align-items: center;
  display: flex;
  gap: 3rem;
  justify-content: center;
  top: 121px;
  left: 768px;
  width: 253px;
  height: 87px;
  /* UI Properties */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px rgba(204, 204, 204, 0.5019607843);
  border-radius: 8px;
  opacity: 1;
}
.dash-c-header-extras .dash-extra-tools .btn-tool {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  justify-content: center;
}
.dash-c-header-extras .dash-extra-tools .btn-tool .info-text {
  color: var(--mainColor) !important;
  font: var(--fontDosisRegular) !important;
  font-size: 0.875rem !important;
  font-weight: bold !important;
}
.dash-c-header-extras .dash-extra-tools .btn-tool .tool-icon {
  height: 1.7rem !important;
}
.dash-c-header-extras .dash-extra-more-info {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
  top: 121px;
  left: 1037px;
  width: 126px;
  height: 87px;
  /* UI Properties */
  border: 1px dashed var(---666666);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border: 1px dashed #666666;
  border-radius: 6px;
  opacity: 1;
}
.dash-c-header-extras .dash-extra-more-info .info-icon {
  color: var(--mainColor) !important;
  font-size: 1.2rem;
  font-weight: bold !important;
}
.dash-c-header-extras .dash-extra-more-info .info-text {
  color: var(--mainColor) !important;
  font: var(--fontDosisRegular) !important;
  font-size: 0.875rem !important;
  font-weight: bold !important;
}

.dash-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 2.5rem;
  justify-self: center;
}
.dash-content .title {
  color: var(--mainColor) !important;
  font: var(--fontDosisBold) !important;
  font-size: 1.375rem !important;
  font-weight: bold !important;
}
.dash-content .title:hover {
  cursor: auto;
}
.dash-content .card-container {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-start;
  margin-top: 1rem;
}
.dash-content .card-container .card-dash {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem !important;
  justify-content: center;
  top: 352px;
  left: 364px;
  width: 247px;
  height: 243px;
  /* UI Properties */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px rgba(204, 204, 204, 0.5019607843);
  border-radius: 8px;
  opacity: 1;
}
.dash-content .card-container .card-dash .p-card-body {
  height: 100% !important;
}
.dash-content .card-container .card-dash .p-card-body .p-card-content {
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
}
.dash-content .card-container .card-dash .p-card-body .p-card-content .iu-icon-right {
  align-self: flex-end;
}
.dash-content .card-container .card-dash .dash-card-title {
  color: var(--mainColor) !important;
  font: var(--fontBarlowBold) !important;
  font-size: 1.25rem !important;
  margin-top: 1.5rem !important;
}
.dash-content .card-container .card-dash .dash-card-title:hover {
  cursor: pointer;
  text-decoration: underline;
}
.dash-content .card-container .card-dash .dash-card-content {
  font: var(--fontBarlowRegular) !important;
  margin-bottom: auto !important;
  margin-top: 1rem !important;
  font-size: 14px !important;
}
.dash-content .card-container .card-dash:hover {
  cursor: pointer;
}

.form-container {
  align-items: center;
  background-color: var(--cardBackgroundColorTwo);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 35rem;
}
.form-container.md {
  width: 40rem;
}
.form-container.lg {
  width: 45rem;
}
.form-container.left {
  align-items: flex-start;
}
.form-container.center {
  align-items: center;
}

.form-btngroup-footer {
  align-items: center;
  align-self: flex-end;
  display: flex;
  justify-content: center;
}

.p-mask-sidebar.active {
  position: absolute !important;
  top: -80px;
  height: calc(100vh + 80px);
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 2;
}

p.us-info-time-ip {
  color: var(--cardBackgroundColorOneShade80) !important;
}

.dt-header-icon {
  font-size: 1.5rem !important;
}
.dt-header-icon.active {
  color: var(--mainColor);
}

.dt-c {
  box-shadow: 0px 3px 6px var(--shadow);
}
.dt-c h3,
.dt-c .p-column-title {
  font-weight: bold !important;
}

.act-btn {
  align-items: center !important;
  display: flex;
  height: 1.75rem !important;
  justify-content: center !important;
  padding: 0.75rem 0 !important;
  width: 1.75rem !important;
}

.act-icon {
  font-size: 0.875rem;
}
.act-icon.detail {
  color: var(--successColor);
}
.act-icon.edit {
  color: var(--infoColor);
}
.act-icon.error {
  color: var(--errorColor);
}
.act-icon.clone {
  color: var(--errorColor);
}
.act-icon.import {
  color: var(--errorColor);
}
.act-icon.export {
  color: var(--errorColor);
}

.tablefilter-mc {
  display: flex;
  justify-content: flex-start;
  column-gap: 2rem;
  margin-inline: auto;
  width: 100%;
}
.tablefilter-mc .p-button {
  background-color: transparent !important;
  border: none !important;
  color: var(--mainColor);
  padding: 0.5rem !important;
  transition: background-color 0.3s ease-in !important;
}
.tablefilter-mc .p-button:hover {
  background-color: rgba(241, 240, 240, 0.8) !important;
  color: var(--mainColor);
}

.multiactions-c .access-button {
  max-width: 10rem !important;
}

.subheader-buttons {
  display: flex;
  justify-content: flex-end;
  column-gap: 2rem;
  margin-inline: auto;
  width: 100%;
}
.subheader-buttons .subheaderactions-module_actions__otXOo {
  margin: 0 !important;
  padding: 0 !important;
}
.subheader-buttons .hover:hover {
  background-color: rgba(241, 240, 240, 0.8) !important;
  color: var(--mainColor);
}

.subheader-buttons-roles {
  display: flex;
  justify-content: flex-end;
  column-gap: 2rem;
  margin-inline: auto;
  width: 100%;
}
.subheader-buttons-roles .access-button {
  max-width: 18rem !important;
}
.subheader-buttons-roles .subheaderactions-module_actions__otXOo {
  margin: 0 !important;
  padding: 0 !important;
}
.subheader-buttons-roles .hover:hover {
  background-color: rgba(241, 240, 240, 0.8) !important;
  color: var(--mainColor);
}

.tablefilter-mc2 {
  display: flex;
  justify-content: space-between;
  column-gap: 2rem;
  margin-inline: auto;
  width: 100%;
}
.tablefilter-mc2 .p-button {
  background-color: transparent !important;
  border: none !important;
  color: var(--mainColor);
  padding: 0.5rem !important;
  transition: background-color 0.3s ease-in !important;
}
.tablefilter-mc2 .p-button .subheaderactions-module_actions__otXOo {
  margin: 0 !important;
  padding: 0 !important;
}
.tablefilter-mc2 .hover:hover {
  background-color: rgba(241, 240, 240, 0.8) !important;
  color: var(--mainColor);
}

@media screen and (max-width: 30rem) {
  .p-datatable .p-datatable-header {
    height: 4.75rem !important;
  }
}
.p-datatable .p-datatable-header:hover {
  cursor: auto;
}
.p-datatable .p-datatable-header #iconRefresh:hover {
  color: var(--secondaryColorShade30) !important;
  cursor: pointer;
}
.p-datatable .p-datatable-header #iconColumns {
  color: initial !important;
}
.p-datatable .p-datatable-header #iconColumns:hover {
  color: var(--secondaryColorShade30) !important;
  cursor: pointer;
}

@media screen and (max-width: 30rem) {
  .subheaderactions-module_actions__otXOo .p-button-vertical {
    flex-direction: row !important;
  }
  .subheaderactions-module_actions__otXOo .p-button .p-button-icon-top {
    margin-right: 0.5rem !important;
    margin-bottom: 0 !important;
  }
  .subheaderactions-module_actions__otXOo .access-button.p-button-vertical {
    max-width: 10rem !important;
  }
}

.p-column-filter-overlay .p-multiselect-token-label {
  max-width: 185px;
  white-space: initial;
  overflow: hidden;
  text-overflow: ellipsis;
}

#userpagetabview-applications-datatable .p-datatable-wrapper table thead .p-frozen-column,
.userpagetabview-roles-datatable .p-datatable-wrapper table thead .p-frozen-column {
  width: 0 !important;
  min-width: 0 !important;
  max-width: 0 !important;
}
#userpagetabview-applications-datatable .p-datatable-wrapper table thead th:last-of-type,
.userpagetabview-roles-datatable .p-datatable-wrapper table thead th:last-of-type {
  width: 130px !important;
  min-width: 130px !important;
  max-width: 130px !important;
}
#userpagetabview-applications-datatable .p-datatable-wrapper table thead th:last-of-type .p-column-header-content,
.userpagetabview-roles-datatable .p-datatable-wrapper table thead th:last-of-type .p-column-header-content {
  transform: translate(-25px);
}
#userpagetabview-applications-datatable .p-datatable-wrapper table tbody tr .p-frozen-column,
.userpagetabview-roles-datatable .p-datatable-wrapper table tbody tr .p-frozen-column {
  padding-right: 0 !important;
  justify-self: flex-end !important;
}
#userpagetabview-applications-datatable .p-datatable-wrapper table tbody tr .p-frozen-column .general-actions-datatable,
.userpagetabview-roles-datatable .p-datatable-wrapper table tbody tr .p-frozen-column .general-actions-datatable {
  height: 32px;
  width: 32px;
}
#userpagetabview-applications-datatable .p-datatable-wrapper table tbody tr .p-frozen-column .general-actions-datatable button,
.userpagetabview-roles-datatable .p-datatable-wrapper table tbody tr .p-frozen-column .general-actions-datatable button {
  height: 100% !important;
  width: 100% !important;
  transform: translate(8.5px);
}
#userpagetabview-applications-datatable .p-datatable-wrapper table tbody tr td:last-of-type,
.userpagetabview-roles-datatable .p-datatable-wrapper table tbody tr td:last-of-type {
  padding-left: 0 !important;
}

#text-and-messages-front-datatable .p-datatable-wrapper .p-datatable-table .p-datatable-tbody .p-datatable-emptymessage #align-box-empty-template {
  width: calc(100vw - 304px) !important;
}

.big-screen #text-and-messages-front-datatable .p-datatable-wrapper .p-datatable-table .p-datatable-tbody .p-datatable-emptymessage #align-box-empty-template {
  width: calc(100vw - 700px) !important;
}

#admin-tenants-empty-box {
  width: calc(100vw - 304px) !important;
}

.big-screen #admin-tenants-empty-box {
  width: calc(100vw - 700px) !important;
}

.inputlabel.h4 {
  font-family: var(--fontDosisSemiBold);
  font-size: var(--font-size-desktop-subtitle);
  color: var(--mainColor);
}
.inputlabel.h4.text-upper {
  text-transform: uppercase;
}
.inputlabel.title {
  font-family: var(--fontDosisBold);
  font-size: 1.5rem;
  color: var(--mainColor);
  text-transform: uppercase;
}
.inputlabel.subtitle {
  font-family: var(--fontBarlowRegular);
  font-size: var(--font-size-sm);
  color: var(--labelsAndTextColor);
}
.inputlabel.subtitle_userdetail {
  font-family: var(--fontDosisSemiBold);
  font-size: var(--font-size-desktop-subtitle);
  color: var(--mainColor);
}
.inputlabel.label {
  align-self: center;
  font-family: var(--fontBarlowRegular);
  font-size: var(--font-size-xs);
  color: var(--labelsAndTextColor);
}

.background-input {
  background-color: var(--backgroundColor) !important;
  padding: 0 !important;
}

.p-inputnumber-input.p-inputtext {
  background: var(--cardBackgroundColorOne) !important;
}

.p-dropdown-label.p-placeholder {
  color: var(--placeholderColor) !important;
}

.schedules-days-container {
  margin-bottom: var(--space-xxl);
}
.schedules-days-container .p-selectbutton {
  flex-direction: row !important;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0 !important;
}
.schedules-days-container .p-selectbutton .p-button {
  min-width: 2rem;
  border-radius: 0 !important;
  padding: 1rem !important;
}
.schedules-days-container .p-buttonset .p-button:first-of-type {
  border-radius: 10px 0px 0 10px !important;
}
.schedules-days-container .p-buttonset .p-button:last-of-type {
  border-radius: 0px 10px 10px 0 !important;
}
.schedules-days-container .p-selectbutton.p-buttonset.p-component .p-button.p-component.p-highlight {
  background-color: var(--cardBackgroundColorOneShade10) !important;
}
.schedules-scrollbar {
  display: flex;
  justify-content: center;
  height: 80%;
}

.schedules-points--container-box-one #SelectScheduleContainer {
  display: flex;
  flex-direction: column;
}
.schedules-points--container-box-one #SelectScheduleContainer .points-subtitle {
  padding-left: var(--space-xl) !important;
}
.schedules-points--container-box-one #SelectScheduleContainer .dropdowns-container {
  width: 55%;
  align-self: center;
  margin-top: var(--space-s);
}
.schedules-points--container-box-one #SelectScheduleContainer .dropdowns-container .skeleton-global-points {
  width: 70%;
  padding: var(--space-xxl);
}
.schedules-points--container-box-one #SelectScheduleContainer .schedules-load-button {
  width: 50%;
  align-self: center;
}
.schedules-points--container-box-one #SelectScheduleContainer .schedules-load-button .button-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.schedules-points--container-box-two #SelectScheduleContainer {
  display: flex;
  flex-direction: column;
}
.schedules-points--container-box-two #SelectScheduleContainer .points-subtitle {
  padding-left: var(--space-xl) !important;
}
.schedules-points--view-box-two {
  display: flex;
  justify-content: center;
  height: calc(var(--breakpoint-xs) + var(--space-l));
}
.schedules-points--view-box-two__selectdays {
  max-width: var(--breakpoint-sm);
}
.schedules-points--view-box-two__selectdays #SelectScheduleContainer {
  height: 100%;
}
.schedules-points--view-box-two__selectdays #SelectScheduleContainer .scrollbar-container.ps.ps--active-y {
  height: 90% !important;
}
.schedules-points--view-box-two__selectdays #SelectScheduleContainer .points-subtitle {
  padding-left: var(--space-xl) !important;
}

.custom-form-box-container .fields-main-container {
  display: flex;
  justify-content: center;
}
.custom-form-box-container .fields-main-container .fields-box {
  max-width: 75%;
  justify-content: space-between;
}

.custom-form-box__protocols-actions .custom-form-box-container .fields-main-container .fields-box {
  width: 100%;
}
.custom-form-box__protocols-actions .custom-form-box-container .fields-main-container .fields-box div:first-child small,
.custom-form-box__protocols-actions .custom-form-box-container .fields-main-container .fields-box div:last-child small {
  margin-bottom: 0 !important;
}
.custom-form-box__protocols-actions .custom-form-box-container .fields-main-container .fields-box div:nth-child(2) .ibp-inputtextarea-field + small {
  margin-bottom: 0 !important;
}

.custom-form-box__protocols-actions-clone .custom-form-box-container .fields-main-container {
  padding-bottom: 0 !important;
}
.custom-form-box__protocols-actions-clone .custom-form-box-container .fields-main-container .fields-box {
  width: 100%;
}
.custom-form-box__protocols-actions-clone .custom-form-box-container .fields-main-container .fields-box div:nth-child(2) .ibp-inputtextarea-field + small {
  margin-bottom: 0 !important;
}
.custom-form-box__protocols-actions-clone .custom-form-box-container .fields-main-container .fields-box div:nth-child(3) {
  position: relative;
  top: -30px;
  margin-bottom: 0 !important;
}
.custom-form-box__protocols-actions-clone .custom-form-box-container .fields-main-container .fields-box div:nth-child(3) > small {
  margin-bottom: 0 !important;
}

.roles-management-main-section .roles-page-title__detail--text {
  margin-top: var(--space-l);
  text-transform: none;
  font-family: var(--fontBarlowMedium);
  font-size: var(--font-size-md);
  color: var(--cardBackgroundColorOneShade80);
}
.roles-management-main-section .roles-actions-boxfull .tablefilter-mc2 {
  justify-content: flex-end;
}
.roles-management-main-section .form-section .boxfull-module_boxFullContainer__9jypm {
  margin: 0 !important;
}
.roles-management-main-section .form-section .boxfull-module_boxFullContainer__9jypm > div:first-of-type {
  padding-top: 0 !important;
  padding-left: 0;
  padding-right: 0;
}
.roles-management-main-section .form-section .boxfull-module_boxFullContainer__9jypm .text-area-readonly:hover,
.roles-management-main-section .form-section .boxfull-module_boxFullContainer__9jypm .text-area-readonly:enabled:focus {
  border-color: var(--borderAndLineColor);
}
.roles-management-main-section .actions-roles-description-box__container--title .boxTitle--roles {
  margin-bottom: var(--padding-level-twenty-four);
  margin-left: var(--padding-level-thirty-two);
}
.roles-management-main-section .admin-roles-tabview .p-tabview-nav-container {
  display: none;
}
.roles-management-main-section .admin-roles-tabview .p-tabview-panels {
  padding-top: 0;
}
.roles-management-main-section .admin-roles-tabview .p-tabview-panels .p-accordion.p-component .p-accordion-tab {
  margin-bottom: var(--space-base);
}
.roles-management-main-section .roles-management-buttons__button-container {
  margin: 0 128px var(--padding-level-thirty-two) !important;
}
.roles-management-main-section .boxfull-module_boxFullContainer__9jypm .new-reactive-button {
  padding: var(--padding-level-eight);
  margin: 8px 0;
}
.roles-management-main-section .boxfull-module_boxFullContainer__9jypm .new-reactive-button button {
  height: 34px !important;
  width: 34px !important;
  padding: 0 !important;
  border-radius: 50%;
  border: var(--infoColor) 1px solid !important;
  background-color: white !important;
}
.roles-management-main-section .boxfull-module_boxFullContainer__9jypm .new-reactive-button:hover {
  text-decoration: underline var(--mainColor);
}
.roles-management-main-section .boxfull-module_boxFullContainer__9jypm .new-reactive-button:hover button {
  background-color: var(--mainColorTint90) !important;
}
.roles-management-main-section #functionalities-accordion-multiple .p-accordion-content .p-datatable .p-column-header-content .ibp-checkbox-field {
  margin-top: 5px;
}

.role-actions-datatable div:first-of-type {
  gap: 1rem !important;
}

#adminRolesContainer .p-tree-container .p-treenode-content.role-card-selected.p-treenode-selectable {
  background: var(--mainColor) !important;
  color: var(--cardBackgroundColorOne) !important;
}
#adminRolesContainer .p-tree-container .p-treenode-content .p-treenode-label {
  color: var(--cardBackgroundColorOneShade80);
}
#adminRolesContainer .p-tree-container .role-card-selected .p-treenode-content .p-treenode-label {
  color: var(--cardBackgroundColorOne);
}

#roles-tooltip-box .help-name-application {
  color: var(--successColor);
  font-size: 1.5rem;
}

.transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 {
  max-width: 100% !important;
  margin: 0 128px !important;
}
.transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 .subheadertitle-module_subheaderTitle__7cmNY .subheadertitle-module_title__nczSu > div {
  position: relative;
  left: -20px;
}
.transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 .t-subheader-content span {
  position: relative;
  left: 15px;
}

.subheaderactions-module_actions__otXOo {
  max-width: 100% !important;
  margin: 0 128px !important;
  padding-left: 0;
  padding-right: 0;
}

.boxfull-module_boxFullContainer__9jypm {
  max-width: 100% !important;
  margin: 0 128px !important;
}
.boxfull-module_boxFullContainer__9jypm > div {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.boxfull-module_boxFullContainer__9jypm .boxfull-module_content__8-IMh .p-tabview .p-tabview-panels .p-tabview-panel .boxfull-module_boxFullContainer__9jypm {
  margin: 0 !important;
}
.boxfull-module_boxFullContainer__9jypm .boxfull-module_content__8-IMh .p-tabview .p-tabview-panels .p-tabview-panel .boxfull-module_boxFullContainer__9jypm .subheaderactions-module_actions__otXOo {
  margin: 0 !important;
}
.boxfull-module_boxFullContainer__9jypm .boxfull-module_content__8-IMh .p-tabview .p-tabview-panels .p-tabview-panel .subheaderactions-module_actions__otXOo {
  margin: 0 !important;
}

.big-screen {
  height: 0;
}
.big-screen .transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 {
  margin-left: 480px !important;
}
.big-screen .multiactions-c {
  margin-left: 480px !important;
}
.big-screen .multiactions-c + .boxfull-module_boxFullContainer__9jypm {
  margin-left: 480px !important;
}
.big-screen .transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 + .subheaderactions-module_actions__otXOo {
  margin-left: 480px !important;
}
.big-screen .transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 + .subheaderactions-module_actions__otXOo + .boxfull-module_boxFullContainer__9jypm {
  margin-left: 480px !important;
}
.big-screen .transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 + .subheaderactions-module_actions__otXOo + .boxfull-module_boxFullContainer__9jypm + .boxfull-module_boxFullContainer__9jypm {
  margin-left: 480px !important;
}
.big-screen .transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 + .boxfull-module_boxFullContainer__9jypm,
.big-screen .layout-pagedescription-box + .boxfull-module_boxFullContainer__9jypm {
  margin-left: 480px !important;
}
.big-screen .custom-form-box-container {
  margin-left: 352px;
}
.big-screen .action-page-description {
  margin-left: 480px !important;
}
.big-screen .footer-container {
  padding-left: 320px !important;
}
.big-screen .dashboard-external-container,
.big-screen .section_detail_audit_report {
  margin-left: 325px;
}
.big-screen .dashboard-internal-container,
.big-screen #wrapper-auditory-report {
  margin-left: 325px;
}
.big-screen .role-main-container {
  margin-left: 480px !important;
}
.big-screen #wrapper-applications,
.big-screen #wrapper-applications-export,
.big-screen #wrapper-applications-import,
.big-screen #margin-fixed-bgscreen {
  margin-left: 480px !important;
}

.role-selector-container {
  cursor: pointer;
}
.role-selector-container .rol-icon-box .iu.iu-icon-user {
  color: var(--cardBackgroundColorOne);
}
.role-selector-container .rol-icon-box .iu.iu-icon-user::before {
  font-size: 20px;
}
.role-selector-container .rol-icon-box .iu.iu-icon-down,
.role-selector-container .rol-icon-box .iu.iu-icon-up {
  color: var(--cardBackgroundColorOne);
}
.role-selector-container .rol-icon-box .iu.iu-icon-down::before,
.role-selector-container .rol-icon-box .iu.iu-icon-up::before {
  font-size: 12px;
}
.role-selector-container .role-text-container .label-container {
  padding-bottom: 4px;
}
.role-selector-container .role-text-container .label-container label,
.role-selector-container .role-text-container span {
  color: var(--cardBackgroundColorOne);
}

#overlay_panel_role_selector {
  z-index: 1003 !important;
  transform-origin: 0 !important;
  transform: translate(55px) !important;
  margin-top: 25px;
  --overlayArrowLeft: 271px !important;
}
#overlay_panel_role_selector .p-overlaypanel-content {
  padding-left: 0;
  padding-right: 0;
}
#overlay_panel_role_selector .p-overlaypanel-content .overlay-content-box__role-selector-title {
  color: var(--cardBackgroundColorOneShade80);
  padding-left: var(--padding-level-twenty-four);
  padding-right: var(--padding-level-twenty-four);
}
#overlay_panel_role_selector .p-overlaypanel-content .overlay-content-box .p-divider {
  width: calc(100% - var(--padding-level-forty-eight));
  margin-left: var(--padding-level-twenty-four);
}
#overlay_panel_role_selector .p-overlaypanel-content .overlay-content-box .p-component.p-panelmenu-header {
  background-color: var(--cardBackgroundColorOne);
}
#overlay_panel_role_selector .p-overlaypanel-content .overlay-content-box .p-component.p-panelmenu-header .p-panelmenu-header-link {
  border-radius: 0;
  background-color: var(--cardBackgroundColorOne);
  padding-left: var(--padding-level-twenty-four);
  padding-top: var(--padding-level-sixteen);
  padding-bottom: var(--padding-level-sixteen);
}
#overlay_panel_role_selector .p-overlaypanel-content .overlay-content-box .p-component.p-panelmenu-header .p-panelmenu-header-link .p-menuitem-text {
  color: var(--cardBackgroundColorOneShade80);
  text-align: start;
}
#overlay_panel_role_selector .p-overlaypanel-content .overlay-content-box .p-component.p-panelmenu-header .p-panelmenu-header-link:hover {
  background-color: var(--cardBackgroundColorTwo);
}
#overlay_panel_role_selector .p-overlaypanel-content .overlay-content-box .role-selector-items .p-panelmenu-panel .p-toggleable-content .p-panelmenu-content {
  background: var(--cardBackgroundColorOne);
}

.create-labels-form-box .boxfull-module_boxFullContainer__9jypm {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.new-product-page-dialog:has(.create-labels-form-box) #pr_id_1_content,
.new-property-component-dialog:has(.create-labels-form-box) #pr_id_1_content,
.new-functionality-component-dialog:has(.create-labels-form-box) #pr_id_1_content,
.edit-property-page-dialog:has(.create-labels-form-box) #pr_id_1_content,
.new-transactions-page-dialog:has(.create-labels-form-box) #pr_id_1_content,
.new-mappedfield-page-dialog:has(.create-labels-form-box) #pr_id_1_content,
.new-quicklinks-page-dialog:has(.create-labels-form-box) #pr_id_1_content {
  padding-left: 0;
  padding-right: 0;
}
.new-product-page-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt,
.new-property-component-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt,
.new-functionality-component-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt,
.edit-property-page-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt,
.new-transactions-page-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt,
.new-mappedfield-page-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt,
.new-quicklinks-page-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt {
  padding: 0 !important;
}
.new-product-page-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt .form-container .form > div:first-of-type,
.new-property-component-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt .form-container .form > div:first-of-type,
.new-functionality-component-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt .form-container .form > div:first-of-type,
.edit-property-page-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt .form-container .form > div:first-of-type,
.new-transactions-page-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt .form-container .form > div:first-of-type,
.new-mappedfield-page-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt .form-container .form > div:first-of-type,
.new-quicklinks-page-dialog .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt .form-container .form > div:first-of-type {
  justify-content: center !important;
}

:root {
  --dividerColor: #EAEAEA;
}

#root {
  height: 100%;
}

* {
  -webkit-user-select: none !important;
          user-select: none !important;
}

header {
  position: fixed;
  width: 100vw;
  top: 0;
  z-index: 1001;
}

.p-sidebar {
  margin-left: -22rem;
  position: fixed !important;
  z-index: 1000 !important;
  min-height: calc(100vh - 80px);
  top: 80px;
}
.p-sidebar.active {
  margin-left: 0;
  top: 80px;
}
.p-sidebar.transition {
  transition: all ease 1s;
}

.p-sidebar .p-sidebar-header {
  padding: 2rem 2rem 1.5rem !important;
}

.p-sidebar .p-sidebar-content {
  padding: 0rem 1.5rem !important;
}

.p-sidebar .p-sidebar-content .p-panelmenu .p-panelmenu-panel:last-child {
  padding-bottom: 0;
}

.p-sidebar + .boxfull-module_boxFullContainer__9jypm,
.p-sidebar + .transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 {
  margin-top: 80px !important;
}

body:has(#environment-messages-alert-show) .p-sidebar + .boxfull-module_boxFullContainer__9jypm,
body:has(#environment-messages-alert-show) .p-sidebar + .transactionalsubheader-module_transactionalSubheaderContainer__MgCB8,
body:has(#environment-messages-alert-show) .dashboard-internal-container,
body:has(#environment-messages-alert-show) main {
  margin-top: 147px !important;
}

#environment-messages-alert-show {
  z-index: 1000;
}

body:has(#environment-messages-alert-hide) .p-sidebar + .boxfull-module_boxFullContainer__9jypm,
body:has(#environment-messages-alert-hide) .p-sidebar + .transactionalsubheader-module_transactionalSubheaderContainer__MgCB8,
body:has(#environment-messages-alert-hide) .dashboard-external-container,
body:has(#environment-messages-alert-hide) .dashboard-internal-container {
  margin-top: 80px !important;
}

.p-menuitem-text {
  font-family: var(--fontBarlowSemiBold) !important;
}

.role-selector-items .p-menuitem-text {
  font-family: var(--fontBarlowMedium) !important;
}

.p-panelmenu-panel:first-of-type {
  display: none;
}

.p-dialog-mask:has(.mandatory-changepwd-dialog, .dialog-form) {
  z-index: 1000 !important;
}

.loading-container {
  z-index: 1200;
}

.footer a {
  color: var(--labelsAndTextColor);
}

.fade-in {
  animation: fadeIn 0.3s;
  -webkit-animation: fadeIn 0.3s;
  -moz-animation: fadeIn 0.3s;
  -o-animation: fadeIn 0.3s;
  -ms-animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.grecaptcha-badge {
  bottom: 40vh !important;
  z-index: 3 !important;
}

.p-inputtext[type=password]::placeholder {
  font-family: var(--fontBarlowMedium);
  letter-spacing: 0;
}

@media screen and (max-width: 48rem) {
  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: 10rem !important;
  }
}
@media screen and (max-width: 30rem) {
  .speeddial-container {
    z-index: -1;
  }
  .p-toast-top-right {
    margin: 0 auto;
    left: 0;
    right: 0;
  }
}
[data-rsbs-scroll] {
  overflow: hidden !important;
}

.speeddial:focus {
  outline: none;
  border: 2px solid var(--focusColor);
}

.header-logo {
  height: 2rem;
  width: 12.125rem;
}

.lan-btn {
  padding: 0.25rem;
  font-family: var(--fontBarlowMedium) !important;
  color: var(--cardBackgroundColorOneShade80);
}

.p-accordion-content {
  padding: 0 !important;
}

.ui-input-password .p-password.input-password .pi-eye,
.ui-input-password .p-password.input-password .pi-eye-slash {
  cursor: pointer;
  right: 0.5rem;
  top: 1rem !important;
}

.ui-input-password .p-password.input-password {
  padding-top: 0 !important;
}

.ui-input-password .p-password.input-password input {
  padding-top: 0.5rem !important;
}

.label-container {
  margin-bottom: 0 !important;
}

.iu-icon-success {
  color: var(--successColor) !important;
  font-size: 3rem !important;
  margin-bottom: 1rem !important;
}

.iu-icon-informative {
  color: var(--infoColor) !important;
  font-size: 3rem !important;
  margin-bottom: 1rem !important;
}

.iu-icon-dashboard {
  color: var(--secondaryColor) !important;
  font-size: 1.25rem !important;
}

.iu-icon-dashboard-arrow {
  color: var(--secondaryColor) !important;
  font-size: 1.25rem !important;
  font-weight: 600;
  float: right;
}

.mafy {
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}

.p-toast-top-right {
  top: 107px !important;
  right: 32px !important;
  z-index: 5000 !important;
}

.p-checkbox .p-checkbox-box.p-highlight,
.p-checkbox .p-checkbox-box.p-highlight:not(.p-disabled):hover {
  background: var(--secondaryColor) !important;
  border-color: var(--secondaryColor) !important;
}

.p-multiselect.p-multiselect-chip .p-multiselect-token {
  background-color: lightgray !important;
  color: black !important;
}

input[type=color] {
  border: none;
}

.approvers-c {
  align-items: center !important;
  display: flex !important;
  gap: 1.5rem !important;
  flex-wrap: wrap !important;
  justify-content: center !important;
  height: auto !important;
}

.approvers-card {
  flex-direction: 1 0 30% !important;
  height: 14.563rem !important;
  width: 19.375rem !important;
  position: relative !important;
}
.approvers-card .p-card-subtitle {
  font-weight: bold !important;
  text-transform: uppercase !important;
}
.approvers-card * span {
  font-family: var(--fontBarlowRegular);
  font-size: var(--font-size-sm);
  color: var(--labelsAndTextColor);
  padding: 0;
}

.ap-button {
  background: transparent !important;
  border-radius: 50% !important;
  height: 2rem !important;
  padding: 0.75rem 0 !important;
  position: absolute !important;
  right: 1.5rem !important;
  width: 2rem !important;
  top: 1.5rem !important;
}
.ap-button.ap-button:enabled {
  border-color: var(--successColor) !important;
  color: var(--successColor) !important;
}
.ap-button.ap-button:disabled {
  background: transparent !important;
  border-color: #99e5b8 !important;
  color: #99e5b8 !important;
}
.ap-button.ap-button:focus {
  outline: none !important;
  box-shadow: none !important;
}
.ap-button.ap-button:hover {
  background-color: transparent !important;
}

.ap-selector-btn-c {
  align-items: center !important;
  display: flex !important;
  justify-content: flex-end !important;
}
.ap-selector-btn-c__cancel {
  margin-right: 1.5rem;
}

.chips-c {
  display: flex !important;
  flex-direction: column !important;
}
.chips-c * {
  margin: 0.75rem 0rem !important;
  width: fit-content !important;
}
.chips-c *:first-of-type {
  margin-top: 0 !important;
}
.chips-c *:last-of-type {
  margin-bottom: 0 !important;
}

.p-chip-text {
  padding-right: 0.75rem !important;
}

.ap-chip {
  width: fit-content !important;
}

.p-picklist-list-wrapper {
  width: 18.75rem !important;
}

.profile-container {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0rem 1.5rem;
  height: 100% !important;
  width: fit-content !important;
  cursor: pointer;
}
.profile-container .p_header_title h2,
.profile-container .p_header_title h6 {
  text-align: right;
}
.profile-container .p-avatar {
  background-color: var(--cardBackgroundColorOne);
  border-radius: var(--space-s);
}
.profile-container .p-avatar img {
  width: 65%;
  height: 65%;
}
.profile-container .p-avatar:hover {
  opacity: 1;
  background-color: var(--cardBackgroundColorOne);
}
@media screen and (min-width: 992px) {
  .profile-container {
    margin-right: 0.5rem !important;
  }
}

.op_panelmenu * {
  font-family: var(--fontDosisSemiBold) !important;
}
.op_panelmenu .p-panelmenu-header-link {
  background-color: transparent !important;
  color: var(--labelsAndTextColor) !important;
  padding: 0.5rem !important;
}
.op_panelmenu .p-panelmenu-content {
  background-color: transparent !important;
}
.op_panelmenu .p-menuitem-link {
  padding: 0.5rem !important;
}
.op_panelmenu .p-menuitem-link:hover {
  background-color: rgb(232, 232, 232) !important;
}
.op_panelmenu .p-menuitem-text {
  color: var(--labelsAndTextColor) !important;
}

.p-picklist-list {
  height: 15.625rem !important;
  margin-right: 0.75rem !important;
}
.p-picklist-list::-webkit-scrollbar {
  width: 0.5rem !important;
}
.p-picklist-list::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey !important;
}
.p-picklist-list::-webkit-scrollbar-thumb {
  background: grey !important;
}

.p-multiselect-label {
  gap: 0.25rem;
}

.p-multiselect-items-wrapper::-webkit-scrollbar,
.p-dropdown-items-wrapper::-webkit-scrollbar,
.p-dialog-content::-webkit-scrollbar {
  width: 0.75rem !important;
}
.p-multiselect-items-wrapper::-webkit-scrollbar-track,
.p-dropdown-items-wrapper::-webkit-scrollbar-track,
.p-dialog-content::-webkit-scrollbar-track {
  box-shadow: inset 0 0 4px grey !important;
}
.p-multiselect-items-wrapper::-webkit-scrollbar-thumb,
.p-dropdown-items-wrapper::-webkit-scrollbar-thumb,
.p-dialog-content::-webkit-scrollbar-thumb {
  background: grey !important;
}

.p-multiselect-label {
  display: flex !important;
  flex-wrap: wrap !important;
}

.sc-menu-btn:hover {
  background-color: rgb(232, 232, 232);
  cursor: pointer;
}

.p-dropdown-panel {
  z-index: 2300 !important;
}

#DetailBackButton,
#PageBackButton {
  font-size: var(--font-size-tablet-title);
}

.p-multiselect .p-multiselect-label.p-placeholder {
  color: var(--placeholderColor) !important;
  padding-left: 0 !important;
  font-family: var(--fontBarlowMedium) !important;
  padding: 0.5rem 0rem !important;
}

.p-menunavbar {
  left: 0 !important;
}

#dialogScroll1 {
  z-index: 1101 !important;
}

.upload-container {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 95%;
}
.upload-container .upload-input-container {
  align-items: center;
  background-color: lightgray;
  border-radius: 0.25rem !important;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0rem 1rem;
  width: 100%;
}
.upload-container .upload-input {
  background-color: white !important;
  border-color: lightgray;
  border-radius: 0.25rem !important;
  margin: 0.5rem !important;
  padding: 0.25rem 0.5rem !important;
  height: 40px;
  max-width: none !important;
  width: 25rem !important;
  box-shadow: none !important;
  outline: 0 none !important;
  outline-offset: 0 !important;
  pointer-events: none !important;
  -webkit-user-select: none !important;
          user-select: none !important;
}
.upload-container .upload-wrapper .p-fileupload .p-button {
  background: var(--mainColor) !important;
  border-color: var(--mainColor) !important;
  border-radius: 0.5rem !important;
  color: var(--cardBackgroundColorOne) !important;
}
.upload-container .upload-wrapper .p-fileupload .p-button.p-disabled {
  background-color: var(--mainColorTint60) !important;
  border-color: var(--mainColorTint60) !important;
}
.upload-container .upload-wrapper .p-fileupload .p-button.p-disabled .p-button-icon {
  display: none !important;
}

.p-multiselect {
  background: transparent !important;
  border: none !important;
  border-bottom: 1px solid #ced4da !important;
  border-radius: 0 !important;
}
.p-multiselect:hover {
  border-bottom: var(--border-size-s) solid var(--secondaryColor) !important;
}
.p-multiselect:not(.p-disabled).p-focus {
  border-bottom: var(--border-size-s) solid var(--secondaryColor) !important;
}

.upload-tabview .p-tabview,
.upload-tabview .p-tabview-nav,
.upload-tabview .p-tabview-nav-container,
.upload-tabview .p-tabview-nav-link,
.upload-tabview .p-tabview-panels {
  background: transparent !important;
}
.upload-tabview .p-tabview-nav .p-tabview-title {
  font-size: 1.375rem !important;
}
.upload-tabview .p-tabview-nav.p-unselectable-text {
  margin-right: 1rem !important;
}
.upload-tabview .p-tabview-nav * {
  border-radius: 0 !important;
}
.upload-tabview .p-tabview-panels {
  padding: 0 !important;
}
.upload-tabview .p-tabview-nav-link:focus {
  box-shadow: none !important;
}

.p-multiselect:not(.p-disabled).p-focus {
  box-shadow: none !important;
}

.ntd {
  font-family: var(--fontBarlowSemiBold) !important;
  font-weight: 400 !important;
  margin: 0 !important;
  text-decoration: none !important;
}

.p-multiselect-filter {
  color: var(--textsAndComponentTitleColor) !important;
  font-size: var(--font-size-sm) !important;
  padding: 0rem 0.5rem !important;
}

.rd-only {
  border: none !important;
}

.p-datatable .p-column-filter.p-fluid.p-column-filter-menu > button {
  margin-left: 0.5rem !important;
}

.btn-filter-clear {
  background-color: transparent !important;
  border: none !important;
  font-weight: 400 !important;
  color: var(--mainColor) !important;
}

@media screen and (max-width: 30rem) {
  .subheadertitle-module_title__nczSu > div {
    left: -1.2rem !important;
  }
}
.subheadertitle-module_title__nczSu > div .pr-3 {
  padding-right: 0.5rem !important;
}

@media screen and (max-width: 30rem) {
  .t-subheader-content {
    width: 100% !important;
    margin: 0 !important;
  }
}

@media screen and (max-width: 30rem) {
  .boxfull-module_boxFullContainer__9jypm {
    margin: 0 0.3rem !important;
  }
}

@media screen and (max-width: 30rem) {
  .p-tabview .p-tabview-nav .p-unselectable-text {
    margin-right: 1.5rem !important;
  }
}

.points__tabdescription {
  margin-top: var(--space-m);
}

.points-subtitle {
  padding: 0 var(--space-base) var(--space-base) !important;
}

.p-selectbutton {
  display: flex !important;
  flex-direction: column !important;
  gap: 1rem !important;
  padding: 10px;
}
.p-selectbutton .p-focus {
  outline: none !important;
}

.p-selectbutton .p-button.p-highlight {
  color: gray;
}

.p-selectbutton .p-button {
  padding: 1.8rem !important;
  border-radius: 0.5rem !important;
  background-color: transparent;
}

.p-buttonset .p-button {
  box-shadow: 0 3px 6px var(--shadow) !important;
}

.p-buttonset .p-button:hover,
.p-buttonset .p-button:focus,
.p-buttonset .p-button::after {
  background-color: transparent !important;
}

.p-buttonset .p-button:not(:focus) {
  background-color: transparent !important;
}

.p-buttonset .p-button:not(:last-child)::after {
  border: 2px solid var(--borderAndLineColor) !important;
}

.scrollbar-container {
  height: 80% !important;
}

.p-select-card-label {
  color: var(--textsAndComponentTitleColor) !important;
  font-family: var(--fontBarlowSemiBold);
  font-size: 1rem;
  font-weight: 900 !important;
}

#SelectScheduleContainer {
  padding: 2rem 0 !important;
}
#SelectScheduleContainer #deleted-button-selectcard .p-button-icon.p-c.iu.iu-icon-delete::before {
  font-size: var(--font-size-tablet-title);
}

.container-treeboxes .treeboxes-child .treeboxes-item {
  min-height: var(--breakpoint-xs) !important;
}

.box-hours {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  padding: 0 1rem;
}

.schedule-card-selected.p-treenode-selectable {
  background-color: var(--mainColor) !important;
  color: var(--cardBackgroundColorOne) !important;
}

.subheaderactions-module_actions__otXOo .access-button {
  max-width: 16rem !important;
}

#uploadNewFiles,
#downloadTemplate,
#downloadGeneral {
  max-width: 12rem !important;
}

.pointsofattention-fields .upload-wrapper .p-fileupload .p-disabled .p-button-icon {
  display: none;
}

.picklist-points {
  width: 100% !important;
  display: flex;
  justify-content: center;
}
.picklist-points--container {
  max-width: 80rem !important;
  padding-left: var(--space-xl);
  padding-right: var(--space-xl);
  width: 100% !important;
}
.picklist-points--container__title {
  padding-left: 4rem;
}
.picklist-points--container__component {
  padding-left: var(--space-base);
  padding-right: var(--space-base);
}
.picklist-points--container__component .p-picklist-source-wrapper .p-picklist-source,
.picklist-points--container__component .p-picklist-source-wrapper .p-picklist-target,
.picklist-points--container__component .p-picklist-target-wrapper .p-picklist-source,
.picklist-points--container__component .p-picklist-target-wrapper .p-picklist-target {
  width: 100% !important;
}

.schedules-points {
  width: 100% !important;
  display: flex;
  justify-content: center;
}
.schedules-points--container {
  max-width: 80rem !important;
  padding-left: var(--space-xl);
  padding-right: var(--space-xl);
  width: 100% !important;
}
.schedules-points--container__title {
  padding-left: 4rem;
}
.schedules-points--fileupload {
  display: flex;
  justify-content: center;
  width: 100%;
}
.schedules-points--fileupload-container {
  max-width: 80rem !important;
  width: 100%;
}
.schedules-points--fileupload-container .card {
  padding-left: var(--padding-level-thirty-two);
  padding-right: var(--padding-level-thirty-two);
}
.schedules-points--fileupload-container .card .p-fileupload-content {
  height: calc(var(--breakpoint-xss) / 2);
}
.schedules-points--fileupload-container .card .p-fileupload-content .p-fileupload-files {
  position: relative;
  top: -12px;
}

.coordinates_title {
  margin: var(--space-m) 0 !important;
  font-size: 1.375rem !important;
  color: var(--mainColor);
  font-family: var(--fontDosisSemiBold);
  font-weight: 400;
}

.env_title {
  font-size: 1.375rem !important;
  color: var(--mainColor);
  font-family: var(--fontDosisSemiBold);
  font-weight: 400;
}

.colors_title,
.logotype_title {
  margin: var(--space-m) 2rem !important;
  font-size: 1.375rem !important;
  color: var(--mainColor);
  font-family: var(--fontDosisSemiBold);
  font-weight: 400;
}

.info_osp_title {
  font-size: 1.375rem !important;
  color: var(--mainColor);
  font-family: var(--fontDosisSemiBold);
  font-weight: 400;
  padding: 0 3rem;
}

.map {
  width: 100% !important;
  height: 100vh !important;
}

#firstHeadingMap {
  font-size: var(--font-size-md);
  font-family: var(--fontBarlowSemiBold);
  font-weight: 400;
  margin-bottom: 1rem;
}

#bodyContentMap {
  width: 295px;
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0 !important;
}
#bodyContentMap p {
  width: 100%;
  text-align: left;
  font-size: var(--font-size-sm);
  font-family: var(--fontBarlowRegular);
}

.myBtn {
  background: transparent;
  border: transparent;
  color: #389bab;
  color: var(--mainColor);
  padding: 0.5rem 0 0.5rem 0;
  cursor: pointer;
  font-size: var(--font-size-md);
  font-family: var(--fontBarlowSemiBold);
  font-weight: 400;
  margin-right: var(--space-m);
}

.gm-style-iw {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px rgba(204, 204, 204, 0.5019607843);
  border: 1px solid #CCCCCC;
  border-radius: 8px;
  opacity: 1;
}

.gm-style-iw-tc {
  display: none;
}

.gm-style .gm-style-iw-c {
  top: 30px;
  left: 10px;
}

.create-points-buttons {
  display: flex;
  justify-content: center;
  width: 100%;
}
.create-points-buttons__button-container {
  max-width: 80rem;
  width: 100%;
}
.create-points-buttons__button-container .p-button.p-component:last-of-type {
  margin-right: var(--padding-level-thirty-two);
}

.table-header-title h3 {
  font-size: 1.25rem;
  font-family: var(--fontBarlowSemiBold);
  color: #333333;
}

#phoneId-phone,
#phoneId- {
  margin-bottom: 0 !important;
}

.p-button.p-component.selectButtonColor {
  background-color: var(--cardBackgroundColorOne) !important;
}

.p-button.p-component.p-highlight {
  border: 2px solid var(--mainColor) !important;
}

.p-breadcrumb ul li.p-disabled .p-menuitem-link .p-menuitem-text {
  color: var(--mainColor) !important;
}

#tenant-colorPicker {
  height: 27px;
}
#tenant-colorPicker > input {
  max-width: 40px !important;
  border-bottom: none;
  height: 100%;
}
#tenant-colorPicker > input:hover {
  cursor: auto;
}

#input-primarycolor,
#input-secondarycolor {
  width: 16.4rem !important;
}
#input-primarycolor--edit,
#input-secondarycolor--edit {
  width: 14.75rem !important;
}

#input-tenant-id,
#input-tenant-name,
#input-tenant-alias,
#input-tenant-shortname,
#input-tenant-tenantcode {
  width: 20.4rem !important;
}
#input-tenant-id--edit,
#input-tenant-name--edit,
#input-tenant-alias--edit,
#input-tenant-shortname--edit,
#input-tenant-tenantcode--edit {
  width: 14.75rem !important;
}

#dropdown-tenant-status,
#dropdown-tenant-parentid {
  width: 20.4rem !important;
}
#dropdown-tenant-status--edit,
#dropdown-tenant-parentid--edit {
  width: 14.75rem !important;
}

.input-tenant .block {
  margin: 0 0.25rem 0.5rem 0 !important;
}

.section_edit_app_env .subheaderactions-module_actions__otXOo,
.section_edit_app_env .boxfull-module_boxFullContainer__9jypm {
  margin: 0 0 !important;
}

.tenant-tooltip {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.5rem;
}

#overlay_panel {
  transform: translate(0, 10px) !important;
}
#overlay_panel .p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link span.p-panelmenu-icon:first-child {
  color: var(--labelsAndTextColor);
}
#overlay_panel .change-lang-link {
  cursor: pointer;
  padding: 0.5rem var(--padding-level-twenty-four);
}
#overlay_panel .change-lang-link p {
  padding: 0 !important;
}
#overlay_panel .change-lang-link:hover {
  background-color: rgb(232, 232, 232);
}

.p-divider-vertical::before {
  border-left-color: var(--dividerColor) !important;
}

.p-invalid {
  color: var(--errorColor) !important;
}

.style-calendar button {
  margin-left: -49px !important;
}

.roles-management-boxfull .p-datatable .p-sortable-column .p-sortable-column-badge {
  display: none;
}
.roles-management-boxfull .p-datatable .p-sortable-column.p-highlight {
  background-color: var(--backgroundColor);
}

.text-area-scroll {
  overflow-y: auto !important;
  height: 89px !important;
}

.app-card-selected.p-treenode-selectable {
  background-color: var(--mainColor) !important;
  color: var(--cardBackgroundColorOne) !important;
}

#SelectAppContainer {
  padding: 2rem 0 !important;
}
#SelectAppContainer .scrollbar-container {
  height: 100% !important;
}
#SelectAppContainer .scrollbar-container .p-panelmenu-icon.pi.pi-chevron-right::before {
  content: "\\e90d" !important;
}
#SelectAppContainer .scrollbar-container .segments-items .p-panelmenu .p-panelmenu-header > a .p-panelmenu-icon.pi.pi-chevron-down:before {
  content: "\\e90e" !important;
}

.tag-tenant-name {
  position: absolute;
  margin-top: 4px;
  margin-left: 17px;
  color: black;
  width: max-content;
  text-transform: none;
}

.select-tenant .p-treeselect-items-wrapper .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {
  color: inherit;
  display: flex;
}

.select-tenant .p-treeselect-items-wrapper .p-tree {
  width: 100%;
}

.select-tenant .p-treeselect-items-wrapper .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:focus {
  box-shadow: none;
  background-color: transparent;
}

.select-tenant .p-treeselect-items-wrapper .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:enabled:hover {
  background: none;
  border-color: transparent;
  color: #343a40;
}

.select-tenant .p-treeselect-items-wrapper .p-tree .p-tree-container .p-treenode .p-treenode-content {
  box-shadow: none !important;
  border-radius: 0px;
  padding: 0;
}

.select-tenant .p-treeselect-items-wrapper .p-tree .p-tree-container .p-treenode {
  max-width: 100%;
  padding-bottom: 0px;
}

.select-tenant.p-connected-overlay-enter-done > div.p-treeselect-items-wrapper {
  border-radius: 0 0 8px 8px;
}

.select-tenant.p-connected-overlay-enter-done > div.p-treeselect-header {
  border-radius: 0px;
}

#input-tenant-parentid {
  background: none;
  border-radius: var(--border-radius-none);
  border: var(--border-size-none);
  border-bottom: var(--border-size-s) solid var(--borderAndLineColor);
  padding: var(--padding-level-zero) var(--padding-level-zero) var(--padding-level-eight);
}

#input-tenant-parentid > div.p-treeselect-label-container > div {
  padding: 0px;
}

#input-tenant-parentid:focus,
#input-tenant-parentid:hover {
  border-bottom: var(--border-size-s) solid var(--secondaryColor);
}

#location-points .fields-box {
  width: 100% !important;
}
#location-points .fields-box div {
  align-items: flex-start !important;
}

#input-tenant-parent-read-only {
  border-bottom: none;
}

.tooltip-inputtexttenantcode,
.tooltip-inputtextparentid {
  margin-top: -9px;
  margin-left: 0px !important;
}

.tooltip-inputtextparentid i.icon-tooltip-icon,
.tooltip-dropdownparentid i.icon-tooltip-icon {
  font-size: 1rem !important;
}

.app-selector-subtitle {
  font-family: var(--fontDosisSemiBold), sans-serif;
  color: var(--mainColor);
  font-size: 1.375rem;
  margin-bottom: 1rem;
}

.settings-container {
  display: flex;
  flex-direction: column;
}
.settings-container .title {
  font-family: var(--fontDosisSemiBold) !important;
  color: var(--mainColor) !important;
  font-size: 1.375rem !important;
  margin-bottom: 1.5rem !important;
  align-self: flex-start;
  text-transform: uppercase;
  padding-top: 0;
}
.settings-container .title:hover {
  cursor: auto;
}
.settings-container .card-container {
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  padding: 1rem 1.5rem;
  /* UI Properties */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px rgba(204, 204, 204, 0.5019607843);
  border-radius: 8px;
  opacity: 1;
}
.settings-container .card-container .card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-decoration: none;
}
.settings-container .card-container .card-content .access-button.p-button-vertical {
  max-width: 6.1rem !important;
}
.settings-container .card-container .card-content .access-button.p-button-vertical .p-button-label.p-c {
  width: 100px !important;
}
.settings-container .card-container .card-content:hover {
  cursor: pointer;
}

.last-changes-container .title {
  font-family: var(--fontDosisSemiBold) !important;
  color: var(--mainColor) !important;
  font-size: 1.375rem !important;
  margin-bottom: 1.5rem !important;
  text-transform: uppercase;
  padding-top: 0;
}
.last-changes-container .title:hover {
  cursor: auto;
}
.last-changes-container .table-container {
  width: 100%;
  background-color: var(--cardBackgroundColorOne) !important;
  border: 1px solid #CCCCCC;
  border-radius: 8px;
}
.last-changes-container .table-container .p-datatable-thead tr th {
  background-color: var(--cardBackgroundColorOne) !important;
  padding: 1.5rem 0.5rem !important;
}
.last-changes-container .table-container .p-datatable-thead tr th .p-column-header-content {
  font-family: var(--fontBarlowSemiBold) !important;
  color: var(--labelsAndTextColor);
}

#overlay_panel .p-overlaypanel-content {
  padding-left: 0;
  padding-right: 0;
}
#overlay_panel .p-overlaypanel-content div > h2,
#overlay_panel .p-overlaypanel-content div p,
#overlay_panel .p-overlaypanel-content div button {
  padding-left: var(--padding-level-twenty-four);
  padding-right: var(--padding-level-twenty-four);
  color: #333;
}
#overlay_panel .p-overlaypanel-content div .p-divider {
  width: calc(100% - var(--padding-level-forty-eight));
  margin-left: var(--padding-level-twenty-four);
}
#overlay_panel .p-overlaypanel-content .overlay-language-box > div:first-of-type {
  color: var(--cardBackgroundColorOneShade80);
  padding-left: var(--padding-level-twenty-four);
  padding-right: var(--padding-level-twenty-four);
}
#overlay_panel .p-overlaypanel-content .overlay-language-box .overlay-language-box__lang-selector-title {
  padding-left: 0;
  font-family: var(--fontBarlowSemiBold);
  font-size: var(--font-size-xl);
}
#overlay_panel .p-overlaypanel-content .overlay-language-box .p-divider {
  width: calc(100% - var(--padding-level-forty-eight));
  margin-left: var(--padding-level-twenty-four);
}
#overlay_panel .p-overlaypanel-content .overlay-language-box .p-panelmenu .p-panelmenu-header > a {
  padding: 1rem;
  margin-top: 0px;
}
#overlay_panel .p-overlaypanel-content .overlay-language-box .p-panelmenu-panel {
  background-color: var(--mainColorShade10);
}
#overlay_panel .p-overlaypanel-content .overlay-language-box .p-panelmenu-panel.lang-item {
  background-color: var(--cardBackgroundColorOne);
  margin-bottom: 0px;
}
#overlay_panel .p-overlaypanel-content .overlay-language-box .p-panelmenu-panel.lang-item a {
  background-color: var(--cardBackgroundColorOne);
  padding-left: var(--padding-level-twenty-four);
  padding-right: var(--padding-level-twenty-four);
  border-radius: 0;
}
#overlay_panel .p-overlaypanel-content .overlay-language-box .p-panelmenu-panel.lang-item a:hover {
  background-color: rgb(232, 232, 232) !important;
}
#overlay_panel .p-overlaypanel-content .overlay-language-box .p-panelmenu-panel.lang-item a span {
  color: var(--cardBackgroundColorOneShade80);
  flex: none !important;
}

body:has(.overlaypanel-demo) .profile-container.p-myprofile {
  background-color: var(--mainColorShade30);
  box-shadow: 0 0 0 8px var(--mainColorShade30);
}

body:has(#overlay_panel_role_selector) .role-selector-container {
  background-color: var(--mainColorShade30);
  box-shadow: 0 0 0 13px var(--mainColorShade30);
}

.client-list-main .title {
  max-width: 100% !important;
  margin: 0 128px !important;
  font-family: var(--fontDosisSemiBold) !important;
  color: var(--mainColor) !important;
  font-size: 1.375rem !important;
  margin-bottom: 1rem !important;
  align-self: flex-start;
  text-transform: uppercase;
  padding-top: 0;
}
.client-list-main .title:hover {
  cursor: auto;
}
.client-list-main .client-list-container {
  background-color: var(--cardBackgroundColorTwo) !important;
  padding: 2rem 0;
}
.client-list-main .client-list-container .client-list-content {
  max-width: 100% !important;
  margin: 0 128px !important;
}
.client-list-main .client-list-container .client-list-content .client-list-box {
  display: flex;
}
.client-list-main .client-list-container .client-list-content .client-list-box .card-content-divider {
  width: 0;
  height: 139px;
  border: 0.9px solid #707070;
  opacity: 1;
  margin: 0 1rem;
}
.client-list-main .client-list-container .client-list-content .client-list-actions {
  width: 100%;
  display: flex;
  justify-content: space-between;
  column-gap: 2rem;
  margin-bottom: 1rem;
}
.client-list-main .client-list-container .client-list-content .client-list-actions .subheaderactions-module_actions__otXOo {
  margin: 0 !important;
  padding: 0 !important;
}
.client-list-main .client-list-container .client-list-content .client-list-actions .p-togglebutton.p-button {
  border-radius: 0.5rem;
  min-width: 0;
}
.client-list-main .client-list-container .client-list-content .swiper {
  padding: 0 0 0.5rem;
  margin-left: 0;
}
.client-list-main .client-list-container .client-list-content .swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 1.5rem !important;
  background-color: var(--mainColor) !important;
  border-radius: 0.25rem !important;
}
.client-list-main .client-list-container .client-list-content .swiper-wrapper {
  width: 100% !important;
}
.client-list-main .client-list-container .client-list-content .swiper-wrapper .swiper-slide {
  display: flex;
  width: 168px !important;
  height: 139px !important;
  margin-right: 1.5rem !important;
}
.client-list-main .client-list-container .client-list-content .swiper-wrapper .swiper-slide .card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
}
.client-list-main .client-list-container .client-list-content .swiper-wrapper .swiper-slide .card-content img {
  width: 48px !important;
  height: 48px !important;
}
.client-list-main .client-list-container .client-list-content .swiper-wrapper .swiper-slide .card-content .p-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
.client-list-main .client-list-container .client-list-content .swiper-wrapper .swiper-slide .card-content .p-card-content .card-title {
  text-align: center;
  color: #333;
}
.client-list-main .client-list-container .client-list-content .swiper-wrapper .swiper-slide .card-content .p-card-content .card-title:hover {
  cursor: pointer;
  text-decoration: underline;
}
.client-list-main .client-list-container .client-list-content .card-content-c {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
}
.client-list-main .client-list-container .client-list-content .card-content-c a {
  text-decoration: none;
}
.client-list-main .client-list-container .client-list-content .card-content-c .card-content {
  width: 168px;
  height: 139px;
  cursor: pointer;
}
.client-list-main .client-list-container .client-list-content .card-content-c .card-content .p-card-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.client-list-main .client-list-container .client-list-content .card-content-c .card-content .p-card-content .card-icon {
  display: flex;
  justify-content: center;
  color: var(--secondaryColor);
}
.client-list-main .client-list-container .client-list-content .card-content-c .card-content .p-card-content .card-icon i {
  font-size: 2.5rem !important;
}
.client-list-main .client-list-container .client-list-content .card-content-c .card-content .p-card-content .card-title {
  text-align: center;
}
.client-list-main .client-list-container .client-list-content .card-content-c .card-content .p-card-content .card-title:hover {
  cursor: pointer;
  text-decoration: underline;
}
.client-list-main .client-list-container .client-list-content .card-content-c .card-content .p-card-content img {
  width: 48px !important;
  height: 48px !important;
}
.client-list-main .client-list-container .client-list-content .card-content-c .card-content .p-card-body {
  padding: 1rem 1.5rem;
  height: 100%;
}
.client-list-main .client-list-container .client-list-content .card-content-app .p-card-body {
  width: 168px;
  height: 139px;
  padding: 1rem;
}
.client-list-main .client-list-container .client-list-content .card-content-app .card-content {
  width: 168px;
  cursor: pointer;
}
.client-list-main .client-list-container .client-list-content .card-content-app .card-content .p-card-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.client-list-main .client-list-container .client-list-content .card-content-app .card-content .p-card-content .card-title {
  text-align: center;
  color: #333;
}
.client-list-main .client-list-container .client-list-content .card-content-app .card-content .p-card-content .card-title:hover {
  cursor: pointer;
  text-decoration: underline;
}
.client-list-main .client-list-container .client-list-content .card-content-app .card-content .p-card-content img {
  width: 48px !important;
  height: 48px !important;
}
.client-list-main .client-list-container .client-list-content .card-content-app .card-content .p-card {
  padding: 1rem 1.5rem;
  height: 100%;
}

.base-role-list-container .subheaderactions-module_actions__otXOo {
  margin: 0 !important;
  padding: 0 !important;
}
.base-role-list-container .title {
  font-family: var(--fontDosisSemiBold) !important;
  color: var(--mainColor) !important;
  font-size: 1.375rem !important;
  margin-bottom: 1rem !important;
  text-transform: uppercase;
  padding-top: 0;
}
.base-role-list-container .title:hover {
  cursor: auto;
}
.base-role-list-container .role-list {
  height: 93px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: var(--cardBackgroundColorOne) !important;
  border: 1px solid #CCCCCC;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
  cursor: pointer;
}
.base-role-list-container .role-list .role-title {
  color: #333;
  font-family: var(--fontBarlowSemiBold) !important;
}
.base-role-list-container .role-list .role-subtitle {
  font-family: var(--fontDosis) !important;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 0.875rem;
  color: #333;
}
.base-role-list-container .role-list .role-status {
  flex-direction: column;
  justify-content: flex-start;
}
.base-role-list-container .see-more {
  display: flex;
  justify-content: flex-end;
}
.base-role-list-container #see-more-icon::before {
  content: "\\e90b";
}

#iconname-icon::before {
  content: "\\e90b";
  font-size: 1.5rem !important;
  color: var(--text-color-333333);
}

.config-grid-3 {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  column-gap: 4rem;
  row-gap: 2.5rem;
  box-sizing: border-box;
  margin: 2.5rem 0 1.5rem;
}
.config-grid-3 .settings-container {
  grid-column: 2/3;
  grid-row: 1/2;
}
.config-grid-3 .base-role-list-container {
  grid-column: 1/1;
  grid-row: 1/3;
}
.config-grid-3 .last-changes-container {
  grid-column: 2/3;
  grid-row: 2/3;
}

.config-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  column-gap: 5rem;
  row-gap: 2.5rem;
  box-sizing: border-box;
  margin: 2.5rem 0 1.5rem;
}
.config-grid-2 .base-role-list-container {
  grid-column: 1/2;
  grid-row: 1/3;
}
.config-grid-2 .last-changes-container {
  grid-column: 2/3;
  grid-row: 1/2;
}

.config-grid-1 {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  column-gap: 5rem;
  row-gap: 2.5rem;
  box-sizing: border-box;
  margin: 2.5rem 0 1.5rem;
}

.config-grid-dash {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  column-gap: 5rem;
  row-gap: 2.5rem;
  box-sizing: border-box;
  margin: 2.5rem 0;
}

.texts-messages-container {
  display: flex;
  flex-direction: column;
}
.texts-messages-container .title {
  font-family: var(--fontDosisSemiBold) !important;
  color: var(--mainColor) !important;
  font-size: 1.375rem !important;
  margin-bottom: 1.5rem !important;
  align-self: flex-start;
  text-transform: uppercase;
  padding-top: 0;
}
.texts-messages-container .title:hover {
  cursor: auto;
}
.texts-messages-container .card-container {
  display: flex;
  gap: 1rem;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 1rem 1.5rem;
  /* UI Properties */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px rgba(204, 204, 204, 0.5019607843);
  border-radius: 8px;
  opacity: 1;
}
.texts-messages-container .card-container .card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.texts-messages-container .card-container .card-content .access-button.p-button-vertical {
  max-width: 6.1rem !important;
}
.texts-messages-container .card-container .card-content .access-button.p-button-vertical .p-button-label.p-c {
  width: 100px !important;
}
.texts-messages-container .card-container .card-content:hover {
  cursor: pointer;
}
.texts-messages-container .card-container .card-content-divider {
  width: 0px;
  height: 55px;
  border: 1px solid #B2B2B2;
  opacity: 1;
}
.texts-messages-container .card-container .card-content-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-left: #333333;
}
.texts-messages-container .card-container .card-content-btn .access-button.p-button-vertical {
  max-width: 100% !important;
}
.texts-messages-container .card-container .card-content-btn .access-button.p-button-vertical .p-button-label.p-c {
  width: 150px !important;
}
.texts-messages-container .card-container .card-content-btn:hover {
  cursor: pointer;
}

.digital-channel-container {
  display: flex;
  flex-direction: column;
}
.digital-channel-container .title {
  font-family: var(--fontDosisSemiBold) !important;
  color: var(--mainColor) !important;
  font-size: 1.375rem !important;
  margin-bottom: 1.5rem !important;
  align-self: flex-start;
  text-transform: uppercase;
  padding-top: 0;
}
.digital-channel-container .title:hover {
  cursor: auto;
}
.digital-channel-container .card-container {
  display: flex;
  justify-content: center;
  gap: 1rem 1.75rem;
  flex-wrap: wrap;
}
.digital-channel-container .card-container .card-content {
  width: 180px;
  height: 110px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #CCCCCC;
  border-radius: 16px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 1.5rem 2.5rem;
}
.digital-channel-container .card-container .card-content .card-title {
  text-align: center;
  font-family: var(--fontBarlowRegular) !important;
  color: #333;
  font-size: 0.875rem !important;
}
.digital-channel-container .card-container .card-content .card-value {
  text-align: center;
  font-family: var(--fontBarlowSemiBold) !important;
  color: #333;
  font-size: 1.25rem !important;
  margin-top: 0.25rem;
}
.digital-channel-container .card-container .card-content:last-child {
  background-color: transparent;
  border: 1px dashed #999999;
  border-radius: 16px;
  opacity: 1;
}
.digital-channel-container .card-container .card-content:last-child .card-value {
  text-align: center;
  font-family: var(--fontBarlowRegular) !important;
  color: var(--text-color-333333);
  font-size: 0.875rem !important;
}

.config-grid-dash-menu {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  column-gap: 5rem;
  row-gap: 2.5rem;
  box-sizing: border-box;
  margin: 2.5rem 0;
}
.config-grid-dash-menu .digital-channel-container {
  grid-column: 1/2;
  grid-row: 2/3;
}
.config-grid-dash-menu .settings-container {
  grid-column: 2/3;
  grid-row: 1/2;
}
.config-grid-dash-menu .texts-messages-container {
  grid-column: 1/2;
  grid-row: 1/2;
}
.config-grid-dash-menu .last-changes-container {
  grid-column: 2/3;
  grid-row: 2/2;
}

.config-grid-dash-menu-3 {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  column-gap: 5rem;
  row-gap: 2.5rem;
  box-sizing: border-box;
  margin: 2.5rem 0;
}
.config-grid-dash-menu-3 .digital-channel-container {
  grid-column: 1/2;
  grid-row: 2/3;
}
.config-grid-dash-menu-3 .texts-messages-container {
  grid-column: 1/2;
  grid-row: 1/2;
}
.config-grid-dash-menu-3 .last-changes-container {
  grid-column: 2/3;
  grid-row: 1/3;
}

.config-grid-dash-menu-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  column-gap: 5rem;
  row-gap: 2.5rem;
  box-sizing: border-box;
  margin: 2.5rem 0;
}
.config-grid-dash-menu-2 .digital-channel-container {
  grid-column: 2/3;
  grid-row: 1/2;
}
.config-grid-dash-menu-2 .texts-messages-container {
  grid-column: 1/2;
  grid-row: 1/2;
}

.p-breadcrumb .p-menuitem-text {
  font-family: inherit !important;
}

.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-panelmenu-icon.pi.pi-fw.pi-angle-right:before {
  content: "\\e90d" !important;
}
.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-panelmenu-icon.pi.pi-fw.pi-angle-down:before {
  content: "\\e90e" !important;
}

.environment-messages-alert {
  border-radius: 0 0 8px 8px;
}
.environment-messages-alert .p-message {
  background-color: var(--warningColor);
  width: 100vw;
  max-width: none;
  margin-top: auto;
  position: relative;
  margin-bottom: 0;
  border-width: 0;
  border-radius: 0 0 8px 8px;
}
.environment-messages-alert .p-message .p-message-wrapper {
  min-height: auto;
  padding-top: 6px;
  padding-bottom: 6px;
}
.environment-messages-alert .p-message .p-message-wrapper .p-message-icon {
  height: 40px;
  margin-bottom: 15px;
}
.environment-messages-alert .p-message .p-message-wrapper .p-message-icon::before {
  font-size: 40px;
  color: var(--cardBackgroundColorOneShade80);
}
.environment-messages-alert .p-message .p-message-wrapper .p-message-detail {
  color: var(--cardBackgroundColorOneShade80);
}

.segments-items .p-panelmenu .p-panelmenu-panel {
  border-radius: 0.5rem !important;
  margin: 0 2rem 1rem !important;
  background: transparent !important;
}
.segments-items .p-panelmenu .p-panelmenu-panel .p-panelmenu-content {
  background: transparent !important;
}
.segments-items .p-panelmenu .p-panelmenu-panel .p-panelmenu-content .p-menuitem .p-menuitem-link {
  background-color: var(--cardBackgroundColorOne);
  box-shadow: 0 3px 6px var(--shadow);
  padding: 0.65rem !important;
  margin-top: 10px;
  border-radius: 0.5rem !important;
  color: var(--textsAndComponentTitleColor);
}
.segments-items .p-panelmenu .p-panelmenu-panel .p-panelmenu-content .p-menuitem .p-menuitem-link:hover {
  background-color: var(--cardBackgroundColorOne);
}
.segments-items .p-panelmenu .p-panelmenu-panel .p-panelmenu-content .p-menuitem .p-menuitem-link .p-menuitem-text {
  color: #333;
}
.segments-items .p-panelmenu .p-panelmenu-panel .p-menuitem-text {
  padding: 0.1rem 0 !important;
}
.segments-items .p-panelmenu .p-panelmenu-panel .p-component.p-panelmenu-header a.p-panelmenu-header-link,
.segments-items .p-panelmenu .p-panelmenu-panel .p-component.p-panelmenu-header a.p-panelmenu-header-link,
.segments-items .p-panelmenu .p-panelmenu-panel .p-component.p-panelmenu-header a.p-panelmenu-header-link {
  padding: 0.65rem 1rem !important;
}
.segments-items .p-panelmenu .p-panelmenu-panel:not(:first-child) .p-panelmenu-header > a {
  border-radius: 8px;
}
.segments-items .p-panelmenu .p-panelmenu-header > a {
  background-color: var(--cardBackgroundColorOne) !important;
  color: #333;
}
.segments-items .p-panelmenu .p-panelmenu-header > a:hover {
  background-color: var(--cardBackgroundColorOne) !important;
  color: #333 !important;
}
.segments-items .p-panelmenu .p-panelmenu-header > a .p-panelmenu-icon.pi.pi-chevron-right:before {
  content: "\\e90e" !important;
}
.segments-items .p-panelmenu .p-panelmenu-header > a .p-panelmenu-icon.pi.pi-chevron-down:before {
  content: "\\e90f" !important;
}

.segment-item-selected .p-menuitem-link {
  background-color: var(--mainColor) !important;
}
.segment-item-selected .p-menuitem-link .p-menuitem-text {
  color: var(--cardBackgroundColorOne) !important;
}

.segment-item-main-selected .p-component.p-panelmenu-header.p-highlight a.p-panelmenu-header-link,
.segment-item-main-selected .p-component.p-panelmenu-header.p-highlight a.p-panelmenu-header-link,
.segment-item-main-selected .p-component.p-panelmenu-header.p-highlight a.p-panelmenu-header-link {
  background-color: var(--mainColor) !important;
  color: var(--cardBackgroundColorOne) !important;
}
.segment-item-main-selected .p-component.p-panelmenu-header a.p-panelmenu-header-link,
.segment-item-main-selected .p-component.p-panelmenu-header a.p-panelmenu-header-link,
.segment-item-main-selected .p-component.p-panelmenu-header a.p-panelmenu-header-link {
  background-color: var(--mainColor) !important;
  color: var(--cardBackgroundColorOne) !important;
}
.segment-item-main-selected .p-toggleable-content .p-menuitem-link {
  margin-top: 1rem !important;
}

.segment-item-1 .p-component.p-panelmenu-header .p-panelmenu-header-link .p-panelmenu-icon.pi.pi-chevron-right:before {
  content: "" !important;
}
.segment-item-1 .p-component.p-panelmenu-header .p-panelmenu-header-link .p-panelmenu-icon.pi.pi-chevron-down:before {
  content: "" !important;
}

#icon-close-message {
  position: relative;
  right: 72px;
  align-self: center;
  font-size: 25px;
  cursor: pointer;
}

.main-content {
  padding-bottom: 73px;
  min-height: 100vh !important;
  position: relative;
}
.main-content .footer-container {
  width: 100%;
  height: 73px;
  background-color: var(--cardBackgroundColorTwo) !important;
  display: grid;
  grid-template-columns: repeat(3, minmax(100px, 1fr));
  position: absolute;
  bottom: 0;
}
.main-content .footer-container .section-1 {
  display: flex;
  grid-column: 2/3;
  grid-row: 1/2;
  justify-content: center;
  align-items: center;
  column-gap: 2.5rem;
  width: 100%;
}
.main-content .footer-container .section-1 .custom-link {
  font-family: var(--fontBarlowBold) !important;
  font-size: var(--font-size-sm) !important;
  color: var(--labelsAndTextColor) !important;
  width: 150px;
  text-decoration: underline;
  text-align: center;
}
.main-content .footer-container .section-2 {
  display: grid;
  grid-column: 3/4;
  grid-row: 1/2;
  align-content: center;
  justify-content: flex-end;
  row-gap: 0.5rem !important;
}
.main-content .footer-container .section-2 div {
  display: flex;
  align-items: center;
  font-family: var(--fontBarlowMedium) !important;
  font-size: 0.625rem !important;
  color: var(--labelsAndTextColor) !important;
}
.main-content .footer-container .section-2 div img {
  height: 12px;
  margin-left: 0.2rem;
  margin-top: 0.17rem;
}

#SelectAppContainer {
  width: 100%;
  position: relative;
  min-height: 15.75rem !important;
}
#SelectAppContainer .envs-items {
  margin: 0 2rem !important;
}
#SelectAppContainer .envs-items .p-tree {
  margin: 0 !important;
  box-sizing: content-box;
  width: 100%;
}
#SelectAppContainer .envs-items .p-tree .p-tree-container {
  width: 100% !important;
}
#SelectAppContainer .envs-items .p-tree .p-tree-container .p-treenode {
  max-width: none !important;
}
#SelectAppContainer .envs-items .p-tree .p-tree-container .p-treenode .p-treenode-content {
  min-width: auto !important;
}

.client-title {
  font-family: var(--fontDosisSemiBold);
  font-size: 1.375rem;
  color: var(--mainColor);
  text-transform: uppercase;
  display: block;
  padding: 2.5rem 0 0;
  transition: color 0.5s;
}

.client-subtitle,
.selectapp-subtitle {
  color: #333;
}

.selectapp-title {
  margin-top: 2.5rem;
}

.show-pagination {
  padding: 0 0 2rem !important;
}

.skeleton-clients-container {
  background-color: var(--cardBackgroundColorTwo);
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 0;
}
.skeleton-clients-container .card-actions {
  max-width: 100%;
  margin: 0 128px;
  display: flex;
  margin-bottom: 1rem;
}
.skeleton-clients-container .card-actions .actions {
  width: 312px;
  height: 38px;
  background-color: #fff;
}
.skeleton-clients-container .skeleton {
  max-width: 100%;
  margin: 0 128px;
  display: flex;
}
.skeleton-clients-container .skeleton .card-skeleton {
  width: 168px;
  height: 139px;
  margin-right: 1.5rem;
}

.skeleton-menu-container {
  background-color: var(--cardBackgroundColorTwo);
  height: 203px;
  display: flex;
  align-items: center;
  padding: 2rem 0;
  margin-top: 2.5rem;
}
.skeleton-menu-container .skeleton {
  width: 100%;
  margin: 0 128px;
  display: flex;
  justify-content: center;
}
.skeleton-menu-container .skeleton .card-skeleton {
  width: 168px;
  height: 139px;
  margin-right: 1.5rem;
}

.skeleton-widgets-container {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  column-gap: 4rem;
  row-gap: 2.5rem;
  box-sizing: border-box;
  height: 356px;
  max-width: 100%;
  margin: 2.5rem 128px 1.5rem;
}
.skeleton-widgets-container .card-1,
.skeleton-widgets-container .card-2 {
  width: 100%;
  background-color: var(--cardBackgroundColorTwo);
  border-radius: 0.5rem;
}

.skeleton-items-container {
  height: 40px;
  border-radius: 0.5rem;
  margin: 0 2rem 1rem;
  background: #fff;
}

.select-role-description {
  margin: auto 2rem;
  text-align: center;
  font-family: var(--fontBarlowMedium);
  color: #333;
}

.p-sidebar-content .p-panelmenu.p-component .p-panelmenu-panel .p-panelmenu-header > a {
  padding: 0.625rem 1rem;
}

#labelNewApplication {
  color: #333;
  font: "normal normal normal 16px/24px Barlow";
  margin-bottom: 1.5rem;
}

#objetiveApplicationLabel {
  margin-bottom: 1.5rem;
}

div.wrapper-form-application {
  margin-left: 2rem;
}
div.wrapper-form-application .form-container .form {
  display: flow-root;
}
div.wrapper-form-application p.subtitle {
  margin-top: 2rem;
  margin-left: 2rem;
  font-family: var(--fontDosisSemiBold);
  font-size: 1.375rem;
  color: var(--mainColor) !important;
  font-weight: normal;
  display: inline-flex;
}
div.wrapper-form-application p.subtitle i {
  cursor: pointer;
  margin-left: 10px;
  font-size: 1.25rem;
}
div.wrapper-form-application .help-name-application {
  color: var(--mainColor) !important;
  font-size: 1.5rem;
}
div.wrapper-form-application p.text-description-name {
  color: var(--labelsAndTextColor);
  font-family: var(--fontBarlowRegular);
  font-size: 0.875rem;
  line-height: 1.3125rem;
}

#HelpAppNameText {
  color: #333 !important;
  line-height: 1.3125rem;
  font-family: var(--fontBarlowMedium);
  font-size: 1rem;
}

.container-buttons-app {
  margin-right: 0px !important;
}

#wrapper-applications {
  padding-left: 3rem !important;
  margin-bottom: 1rem !important;
}

.section_edit_app_env {
  margin-left: 2.375rem;
}

.wrapper-environment-button {
  padding-bottom: 1rem;
}

.description-delete-app {
  line-height: 1.5rem;
  font-family: var(--fontBarlowRegular);
  color: #333;
}

.description-new-environment {
  line-height: 1.5rem;
  font-family: var(--fontBarlowMedium);
  color: #333;
}

#input-clonename,
.input-clone-fields,
#input-name-env {
  width: 18.4375rem !important;
}

.p-sidebar .p-sidebar-content .p-panelmenu .p-panelmenu-panel .p-panelmenu-header > a .p-panelmenu-icon.pi.pi-chevron-right:before {
  content: "\\e90d" !important;
  font-size: 0.75rem;
}

.p-sidebar .p-sidebar-content .p-panelmenu .p-panelmenu-panel .p-panelmenu-header > a .p-panelmenu-icon.pi.pi-chevron-down:before {
  content: "\\e90e" !important;
  font-size: 0.75rem;
}

.p-paginator .p-paginator-current {
  margin-left: 0;
  order: 3;
  font-family: var(--fontBarlowRegular);
  font-size: var(--font-size-sm);
}

.p-dropdown.p-component.p-inputwrapper.p-inputwrapper-filled {
  order: 2;
}

.p-paginator-right-content {
  margin-left: 0;
  margin-right: 8px;
  order: 1;
  font-family: var(--fontBarlowRegular);
  font-size: var(--font-size-sm);
}

.user-title-info {
  margin-left: 4rem;
}
.user-title-info .title {
  font-family: var(--fontDosisSemiBold) !important;
  color: var(--mainColor) !important;
  font-size: 1.375rem !important;
  align-self: flex-start;
  text-transform: uppercase;
  padding-top: 0;
}

.tenant-accordions .p-resizable-column.p-align-left:first-child {
  max-width: 65px !important;
}
.tenant-accordions .p-selectable-row .p-align-left:first-child {
  max-width: 65px !important;
}
.tenant-accordions .p-accordion-content .p-datatable {
  padding: 1.5rem !important;
}
.tenant-accordions #iconColumns {
  display: none;
}

.application-roles-table .application-roles-title {
  margin-bottom: 1rem !important;
  font-family: var(--fontBarlowSemiBold);
  font-size: var(--font-size-md);
  color: #333;
}
.application-roles-table .boxfull-module_content__8-IMh.boxfull-module_primary__eCXMZ {
  margin: 0 0 !important;
  padding: 0 0 !important;
}
.application-roles-table .boxfull-module_content__8-IMh.boxfull-module_primary__eCXMZ .p-datatable {
  padding: 0 !important;
  padding-left: 1.5rem !important;
}
.application-roles-table .p-datatable-header {
  display: none;
}
.application-roles-table .p-selectable-row .p-editable-column.p-align-left .p-row-editor-init.p-link {
  position: absolute;
  left: 1040px !important;
  color: var(--warningColor);
  border: 1px solid;
  border-radius: 2rem;
  background-color: transparent;
  width: 1.75rem;
  height: 1.75rem;
}
.application-roles-table .p-selectable-row .p-editable-column.p-cell-editing.p-align-left .p-row-editor-save.p-link {
  position: absolute;
  left: 1000px !important;
  background-color: var(--cardBackgroundColorOne);
  color: var(--successColor);
  border: 1px solid;
  border-radius: 2rem;
  width: 1.75rem;
  height: 1.75rem;
}
.application-roles-table .p-selectable-row .p-editable-column.p-cell-editing.p-align-left .p-row-editor-cancel.p-link {
  position: absolute;
  left: 1040px !important;
  background-color: var(--cardBackgroundColorOne);
  color: var(--errorColor);
  border: 1px solid;
  border-radius: 2rem;
  width: 1.75rem;
  height: 1.75rem;
}

.roles-row-disabled .p-datatable-thead tr th:first-child {
  cursor: default !important;
  pointer-events: none !important;
  opacity: 0.6;
}

.management-roles-table .p-selectable-row .p-editable-column.p-align-left .p-row-editor-init.p-link {
  position: absolute;
  left: 1110px !important;
  color: var(--warningColor);
  border: 1px solid;
  border-radius: 2rem;
  background-color: transparent;
  width: 1.75rem;
  height: 1.75rem;
}
.management-roles-table .p-selectable-row .p-editable-column.p-cell-editing.p-align-left .p-row-editor-save.p-link {
  position: absolute;
  left: 1070px !important;
  background-color: var(--cardBackgroundColorOne);
  color: var(--successColor);
  border: 1px solid;
  border-radius: 2rem;
  width: 1.75rem;
  height: 1.75rem;
}
.management-roles-table .p-selectable-row .p-editable-column.p-cell-editing.p-align-left .p-row-editor-cancel.p-link {
  position: absolute;
  left: 1110px !important;
  background-color: var(--cardBackgroundColorOne);
  color: var(--errorColor);
  border: 1px solid;
  border-radius: 2rem;
  width: 1.75rem;
  height: 1.75rem;
}

strong {
  font-family: var(--fontBarlowSemiBold);
}

.p-toast-detail {
  word-break: break-word;
}

.p-inputtext.p-component.block.p-invalid.p-invalid-delete {
  margin-top: 0.5rem !important;
}

.p-multiselect-panel.p-component.p-connected-overlay-enter-done {
  height: 265px;
  z-index: 1999 !important;
}

.roles-column.p-align-left div:first-child:not(.p-column-header-content),
.general-content-column.p-align-left div:first-child:not(.p-column-header-content) {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.basic-table-style .p-datatable-tbody > tr > td {
  background: none !important;
}
.basic-table-style .basic-table-row-background {
  background-color: var(--backgroundColor) !important;
}
.basic-table-style .datatable-original-background {
  background-color: var(--cardBackgroundColorOne) !important;
}

.p-datatable-tbody > tr > .general-actions-column .general-actions-datatable {
  background: var(--cardBackgroundColorOne);
  box-shadow: var(--cardBackgroundColorOne) 0px 0px 0px 500px;
}

.p-row-editor-init {
  color: var(--warningColor) !important;
  background-color: transparent !important;
  border: 1px solid !important;
}

.p-row-editor-init-icon:before {
  content: \\e936 !important;
}

.p-row-editor-save {
  color: var(--successColor) !important;
  background-color: transparent !important;
  border: 1px solid !important;
}

.p-row-editor-cancel {
  color: var(--errorColor) !important;
  background-color: transparent !important;
  border: 1px solid !important;
}

.wrapper-title-new-user,
.wrapper-form {
  margin: 0px !important;
}

.tooltip-dropdown-styles::before {
  font-size: var(--font-size-md);
  color: var(--successColor);
}

#overlay_panel_datatable::-webkit-scrollbar {
  display: none;
}

#input-label-esvalue-readonly:hover,
#input-label-esvalue-readonly:enabled:focus,
#input-label-envalue-readonly:hover,
#input-label-envalue-readonly:enabled:focus {
  border-color: var(--borderAndLineColor);
}

div:has(.overlay-createlabelsbutton) {
  z-index: 1001 !important;
}

div.tableroles > div.p-datatable-wrapper > table > thead > tr > th:nth-child(1) {
  display: none;
}

#validate-labels-table {
  margin: 0 !important;
  width: 100% !important;
}

.tenant-accordions .p-accordion:not(:first-of-type) {
  padding-left: var(--padding-level-forty);
}

#align-box-empty-template {
  width: 100% !important;
}

#permissions-customformcomponent,
#functionalities-customformcomponent,
#agents-customformcomponent {
  margin: 0 128px !important;
}

#margin-fixed-bgscreen {
  margin: 0 128px;
}
#margin-fixed-bgscreen .boxfull-module_boxFullContainer__9jypm {
  margin: 0 !important;
}
#margin-fixed-bgscreen .boxfull-module_boxFullContainer__9jypm .boxfull-module_boxFullContainer__9jypm {
  margin: 0 128px !important;
}

#copy-button-admin-add {
  transform: translate(0, -15px);
}

.audit-report-multiselect-class .p-multiselect-label-container .p-multiselect-label {
  padding-left: 0px;
}`, "",{"version":3,"sources":["webpack://./src/sass/base/reset.scss","webpack://./src/sass/styles.scss","webpack://./src/sass/components/boxfull.scss","webpack://./src/sass/components/crud.scss","webpack://./src/sass/components/dialog.scss","webpack://./src/sass/components/dashboard.scss","webpack://./src/sass/components/datatable.scss","webpack://./src/sass/components/input.scss","webpack://./src/sass/components/schedulesBox.scss","webpack://./src/sass/components/skeleton-global.scss","webpack://./src/sass/components/custom-form-box.scss","webpack://./src/sass/components/roles-pages.scss","webpack://./src/sass/components/layout-pages.scss","webpack://./src/sass/components/role-selector.scss","webpack://./src/sass/components/create-labels-form-box.scss","webpack://./src/sass/components/new-custom-dialog.scss"],"names":[],"mappings":"AAAA;EACE,sCAAA;EACA,iCAAA;EACA,2CAAA;EACA,kBAAA;EACA,oCAAA;EACA,qCAAA;EACA,4BAAA;ACIF;;ACVI;EACI,gBAAA;EACA,qCAAA;EACA,4CAAA;EACA,uBAAA;ADaR;ACVI;EACI,gBAAA;EACA,qCAAA;EACA,4CAAA;EACA,uBAAA;ADYR;ACTI;EACI,2BAAA;ADWR;ACTQ;EACI,UAAA;ADWZ;;ACNA;EACI,2CAAA;EACA,qCAAA;EACA,4CAAA;EACA,uBAAA;ADSJ;;ACFI;;;;EACI,kBAAA;ADQR;;AE5CA;EACE,cAAA;EACA,8BAAA;AF+CF;;AE5CA;EACE,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,SAAA;AF+CF;AE7CE;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;AF+CJ;AE7CI;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;AF+CN;AE7CM;EACE,gBAAA;AF+CR;AE5CM;EACE,sBAAA;EACA,gCAAA;EACA,qCAAA;EACA,8BAAA;EACA,qBAAA;AF8CR;AE3CM;EACE,sBAAA;EACA,yCAAA;EACA,oCAAA;EACA,8BAAA;AF6CR;;AEvCA;EACE,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,0BAAA;EACA,kBAAA;EACA,yCAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,kCAAA;AF0CF;AExCE;EACE,qCAAA;AF0CJ;AEvCE;EACE,mCAAA;AFyCJ;AEtCE;EACE,qCAAA;AFwCJ;AErCE;EACE,mCAAA;AFuCJ;;AG/GE;EACE,gBAAA;EACA,YAAA;EACA,YAAA;AHkHJ;AGhHI;EACE,gBAAA;EACA,6BAAA;AHkHN;AGhHM;EACE,wBAAA;AHkHR;AG/GM;EACE,yCAAA;AHiHR;AG9GM;EACE,2BAAA;AHgHR;AG5GI;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;AH8GN;AG5GM;EACE,gCAAA;EACA,6BAAA;AH8GR;AG3GM;EACE,kBAAA;AH6GR;;AGvGA;EACE,uBAAA;AH0GF;AGzGE;EACE,6BAAA;EACA,+BAAA;AH2GJ;AGzGI;EACE,wBAAA;AH2GN;AGxGI;EACE,yCAAA;AH0GN;AGvGI;EACE,2BAAA;AHyGN;;AGpGA;EACE,yBAAA;EACA,2BAAA;AHuGF;AGrGE;EACE,+BAAA;EACA,6BAAA;AHuGJ;;AGnGA;EACE,wBAAA;AHsGF;;AGnGA;EACE,kBAAA;AHsGF;;AGnGA;EACE,4BAAA;AHsGF;;AIxLA;EACE,mBAAA;EACA,6DAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,yCAAA;AJ2LF;AIzLE;EACE,mBAAA;AJ2LJ;AIxLE;EACE,oCAAA;AJ0LJ;;AItLA;EACE,8BAAA;AJyLF;;AItLA;EACE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,+BAAA;EACA,8BAAA;AJyLF;AIvLE;EACE,0BAAA;AJyLJ;AItLE;EAEE,wBAAA;EACA,2BAAA;AJuLJ;;AInLA;EACE,YAAA;EACA,qCAAA;EACA,8BAAA;AJsLF;;AInLA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,6BAAA;AJsLF;;AI1KQ;;;;;;;;;;;;EAGE,uBAAA;EACA,0BAAA;AJsLV;AInLQ;;;;;;;;;;;;;;;;EAIE,sBAAA;AJiMV;AI9LQ;;;;;;;;;;;;EAGE,yBAAA;AJyMV;AItMQ;;;;;;;;;;;;;;;;EAIE,yBAAA;AJoNV;AIjNQ;;;;;;;;;;;;;;;;;;;;EAKE,uBAAA;EACA,0BAAA;AJkOV;AI5NU;EACE,yBAAA;AJ8NZ;;AItNA;EACE,uBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AJyNF;AIvNE;;;EAGE,2BAAA;EACA,uBAAA;AJyNJ;AIrNI;EACE,2BAAA;AJuNN;AInNE;EACE,YAAA;AJqNJ;AIlNE;EACE,YAAA;AJoNJ;AIlNI;;;EAGE,uBAAA;EACA,2BAAA;AJoNN;AIhNE;EACE,YAAA;AJkNJ;AIhNI;;;EAGE,uBAAA;EACA,2BAAA;AJkNN;AI9ME;EACE,uBAAA;AJgNJ;AI7ME;EACE,mBAAA;AJ+MJ;AI5ME;EACE,uBAAA;AJ8MJ;;AI1MA;EACE,6BAAA;AJ6MF;;AI1MA;EACE,2BAAA;EACA,eAAA;AJ6MF;AI3ME;EACE,6CAAA;EACA,uBAAA;AJ6MJ;AI1ME;EACE,2BAAA;AJ4MJ;AIzMM;EACE,yCAAA;AJ2MR;AIzMQ;EACE,eAAA;AJ2MV;AIzMU;EACE,sCAAA;AJ2MZ;AIxMU;EACE,yCAAA;AJ0MZ;AIxMY;EACE,0DAAA;AJ0Md;AIxMc;EACE,+CAAA;EACA,gBAAA;AJ0MhB;AIvMc;EACE,yCAAA;AJyMhB;AInMgB;EACE,6CAAA;AJqMlB;AInMkB;EACE,gBAAA;AJqMpB;AI3LI;EACE,gBAAA;AJ6LN;AI1LI;EACE,2BAAA;EACA,aAAA;EACA,sBAAA;AJ4LN;AI1LM;EACE,kCAAA;EACA,2CAAA;AJ4LR;AIxLY;EACE,2BAAA;AJ0Ld;AIlLM;EACE,mBAAA;AJoLR;AI/KM;EACE,mBAAA;AJiLR;AI5KM;EACE,mBAAA;AJ8KR;;AIxKA;EACE,cAAA;EACA,WAAA;AJ2KF;;AIxKA;EACE,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACA,kCAAA;EACA,+CAAA;AJ2KF;;AIxKA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AJ2KF;;AIxKA;EACE,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AJ2KF;AIzKE;EACE,+CAAA;EACA,4BAAA;AJ2KJ;AIxKE;EACE,oDAAA;EACA,kBAAA;AJ0KJ;;AItKA;EACE,uBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iBAAA;AJyKF;;AItKA;EACE,uBAAA;EACA,6BAAA;EACA,8BAAA;AJyKF;;AItKA;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AJyKF;;AItKA;EAEE,aAAA;EAGA,WAAA;AJsKF;;AInKA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;EACA,sBAAA;EACA,WAAA;AJsKF;AIpKE;EACE,cAAA;AJsKJ;;AIjKE;EACE,kCAAA;EACA,iCAAA;EACA,6BAAA;AJoKJ;AIlKE;EACE,qCAAA;EACA,6BAAA;EACA,WAAA;AJoKJ;;AIhKA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;AJmKF;AIjKE;EACE,8BAAA;EACA,WAAA;AJmKJ;;AI/JA;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;AJkKF;AIhKE;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,+CAAA;EACA,yDAAA;EACA,kBAAA;EACA,UAAA;AJkKJ;AIhKI;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;AJkKN;AIhKM;EACE,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,4BAAA;AJkKR;AI/JM;EACE,yBAAA;AJiKR;AI5JE;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,mDAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;AJ8JJ;AI5JI;EACE,kCAAA;EACA,iBAAA;EACA,4BAAA;AJ8JN;AI3JI;EACE,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,4BAAA;AJ6JN;;AIxJA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;AJ2JF;AIzJE;EACE,kCAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;AJ2JJ;AIzJI;EACE,YAAA;AJ2JN;AIvJE;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;AJyJJ;AIvJI;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,+CAAA;EACA,yDAAA;EACA,kBAAA;EACA,UAAA;AJyJN;AIvJM;EACE,uBAAA;AJyJR;AIvJQ;EACE,uBAAA;EACA,wBAAA;EACA,iCAAA;EACA,yCAAA;AJyJV;AIvJU;EACE,oBAAA;AJyJZ;AIpJM;EACE,kCAAA;EACA,sCAAA;EACA,6BAAA;EACA,6BAAA;AJsJR;AIpJQ;EACE,eAAA;EACA,0BAAA;AJsJV;AIlJM;EACE,yCAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;AJoJR;AIjJM;EACE,eAAA;AJmJR;;AI1HA;EACE,mBAAA;EACA,+CAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AJ6HF;AI3HE;EACE,YAAA;AJ6HJ;AI1HE;EACE,YAAA;AJ4HJ;AIzHE;EACE,uBAAA;AJ2HJ;AIxHE;EACE,mBAAA;AJ0HJ;;AItHA;EACE,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;AJyHF;;AItHA;EACE,6BAAA;EACA,UAAA;EACA,0BAAA;EACA,YAAA;EACA,qCAAA;EACA,UAAA;AJyHF;;AItHA;EACE,sDAAA;AJyHF;;AKztBA;EACE,4BAAA;AL4tBF;AK1tBE;EACE,uBAAA;AL4tBJ;;AKxtBA;EACE,qCAAA;AL2tBF;AKztBE;;EAEE,4BAAA;AL2tBJ;;AKvtBA;EACE,8BAAA;EACA,aAAA;EACA,0BAAA;EACA,kCAAA;EACA,6BAAA;EACA,yBAAA;AL0tBF;;AKvtBA;EACE,mBAAA;AL0tBF;AKxtBE;EACE,0BAAA;AL0tBJ;AKvtBE;EACE,uBAAA;ALytBJ;AKttBE;EACE,wBAAA;ALwtBJ;AKrtBE;EACE,wBAAA;ALutBJ;AKptBE;EACE,wBAAA;ALstBJ;AKntBE;EACE,wBAAA;ALqtBJ;;AKjtBA;EACE,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;ALotBF;AKltBE;EACE,wCAAA;EACA,uBAAA;EACA,uBAAA;EACA,0BAAA;EACA,oDAAA;ALotBJ;AKltBI;EACE,qDAAA;EACA,uBAAA;ALotBN;;AK9sBE;EACE,2BAAA;ALitBJ;;AK7sBA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;ALgtBF;AK9sBE;EACE,oBAAA;EACA,qBAAA;ALgtBJ;AK5sBI;EACE,qDAAA;EACA,uBAAA;AL8sBN;;AKzsBA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AL4sBF;AK1sBE;EACE,2BAAA;AL4sBJ;AKzsBE;EACE,oBAAA;EACA,qBAAA;AL2sBJ;AKvsBI;EACE,qDAAA;EACA,uBAAA;ALysBN;;AKpsBA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;ALusBF;AKrsBE;EACE,wCAAA;EACA,uBAAA;EACA,uBAAA;EACA,0BAAA;EACA,oDAAA;ALusBJ;AKrsBI;EACE,oBAAA;EACA,qBAAA;ALusBN;AKlsBI;EACE,qDAAA;EACA,uBAAA;ALosBN;;AK9rBE;EADF;IAEI,0BAAA;ELksBF;AACF;AKhsBE;EACE,YAAA;ALksBJ;AK9rBI;EACE,8CAAA;EACA,eAAA;ALgsBN;AK5rBE;EACE,yBAAA;AL8rBJ;AK7rBI;EACE,8CAAA;EACA,eAAA;AL+rBN;;AKzrBI;EACE;IACE,8BAAA;EL4rBN;EK1rBI;IACE,+BAAA;IACA,2BAAA;EL4rBN;EK1rBI;IACE,2BAAA;EL4rBN;AACF;;AKvrBE;EACE,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;AL0rBJ;;AKjrBQ;;EACE,mBAAA;EACA,uBAAA;EACA,uBAAA;ALqrBV;AKlrBQ;;EACE,uBAAA;EACA,2BAAA;EACA,2BAAA;ALqrBV;AKnrBU;;EACE,2BAAA;ALsrBZ;AK/qBU;;EACI,2BAAA;EACA,iCAAA;ALkrBd;AKhrBU;;EACI,YAAA;EACA,WAAA;ALmrBd;AKjrBc;;EACE,uBAAA;EACA,sBAAA;EACA,2BAAA;ALorBhB;AK/qBU;;EACE,0BAAA;ALkrBZ;;AKrqBU;EACE,qCAAA;ALwqBZ;;AK1pBY;EACE,qCAAA;AL6pBd;;AKjpBA;EACE,qCAAA;ALopBF;;AKhpBE;EACE,qCAAA;ALmpBJ;;AMn7BI;EAIE,qCAAA;EACA,4CAAA;EACA,uBAAA;ANm7BN;AMx7BM;EACE,yBAAA;AN07BR;AMn7BI;EACE,iCAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;ANq7BN;AMl7BI;EACE,qCAAA;EACA,8BAAA;EACA,gCAAA;ANo7BN;AMj7BI;EACE,qCAAA;EACA,4CAAA;EACA,uBAAA;ANm7BN;AMh7BI;EACE,kBAAA;EACA,qCAAA;EACA,8BAAA;EACA,gCAAA;ANk7BN;;AM96BA;EACI,mDAAA;EACA,qBAAA;ANi7BJ;;AM96BA;EACI,oDAAA;ANi7BJ;;AM96BA;EACE,yCAAA;ANi7BF;;AO/9BI;EACI,+BAAA;APk+BR;AOh+BQ;EACI,8BAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;APk+BZ;AOh+BY;EACI,eAAA;EACA,2BAAA;EACA,wBAAA;APk+BhB;AO99BQ;EACI,yCAAA;APg+BZ;AO79BQ;EACI,yCAAA;AP+9BZ;AO39BY;EACI,iEAAA;AP69BhB;AOx9BI;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AP09BR;;AQ3/BY;EACI,aAAA;EACA,sBAAA;AR8/BhB;AQ5/BgB;EACI,wCAAA;AR8/BpB;AQ3/BgB;EACI,UAAA;EACA,kBAAA;EACA,0BAAA;AR6/BpB;AQ3/BoB;EACI,UAAA;EACA,yBAAA;AR6/BxB;AQz/BgB;EACI,UAAA;EACA,kBAAA;AR2/BpB;AQz/BoB;EACI,aAAA;EACA,yBAAA;EACA,WAAA;AR2/BxB;AQp/BY;EACI,aAAA;EACA,sBAAA;ARs/BhB;AQp/BgB;EACI,wCAAA;ARs/BpB;AQ/+BQ;EACI,aAAA;EACA,uBAAA;EACA,mDAAA;ARi/BZ;AQ/+BY;EACI,+BAAA;ARi/BhB;AQ/+BgB;EACI,YAAA;ARi/BpB;AQ/+BoB;EACI,sBAAA;ARi/BxB;AQ9+BoB;EACI,wCAAA;ARg/BxB;;AS/iCI;EACI,aAAA;EACA,uBAAA;ATkjCR;ASjjCQ;EACI,cAAA;EACA,8BAAA;ATmjCZ;;AS1iCY;EACI,WAAA;AT6iChB;ASziCoB;;EACI,2BAAA;AT4iCxB;ASviCoB;EACI,2BAAA;ATyiCxB;;AS9hCQ;EACI,4BAAA;ATiiCZ;AS/hCY;EACI,WAAA;ATiiChB;AS9hCoB;EACI,2BAAA;ATgiCxB;AS5hCgB;EACI,kBAAA;EACA,UAAA;EACA,2BAAA;AT8hCpB;AS5hCoB;EACI,2BAAA;AT8hCxB;;AUnlCY;EACI,0BAAA;EACA,oBAAA;EACA,oCAAA;EACA,8BAAA;EACA,2CAAA;AVslChB;AUhlCQ;EACI,yBAAA;AVklCZ;AU7kCQ;EACI,oBAAA;AV+kCZ;AU7kCY;EACI,yBAAA;EACA,eAAA;EACA,gBAAA;AV+kChB;AU5kCY;;EAEI,uCAAA;AV8kChB;AUrkCgB;EACI,+CAAA;EACA,4CAAA;AVukCpB;AUhkCQ;EACI,aAAA;AVkkCZ;AU/jCQ;EACI,cAAA;AVikCZ;AU9jCgB;EACI,gCAAA;AVgkCpB;AUzjCQ;EACI,0DAAA;AV2jCZ;AUtjCQ;EACI,mCAAA;EACA,aAAA;AVwjCZ;AUtjCY;EACI,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,6CAAA;EACA,kCAAA;AVwjChB;AUrjCY;EACI,2CAAA;AVujChB;AUrjCgB;EACI,mDAAA;AVujCpB;AU7iCoB;EACI,eAAA;AV+iCxB;;AUtiCI;EACI,oBAAA;AVyiCR;;AUniCQ;EACI,uCAAA;EACA,+CAAA;AVsiCZ;AUniCQ;EACI,2CAAA;AVqiCZ;AUliCQ;EACI,oCAAA;AVoiCZ;;AU9hCI;EACI,0BAAA;EACA,iBAAA;AViiCR;;AWtqCA;EACI,0BAAA;EACA,0BAAA;AXyqCJ;AWtqCQ;EACI,kBAAA;EACA,WAAA;AXwqCZ;AWnqCQ;EACI,kBAAA;EACA,UAAA;AXqqCZ;;AWhqCA;EACI,0BAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AXmqCJ;;AWhqCA;EACI,0BAAA;EACA,0BAAA;AXmqCJ;AWjqCI;EACI,yBAAA;EACA,0BAAA;AXmqCR;AW5pCoB;EACI,oBAAA;AX8pCxB;AW5pCwB;EACI,oBAAA;AX8pC5B;AW1pCoB;EACI,oBAAA;AX4pCxB;;AW7oCA;EACI,SAAA;AXgpCJ;AW9oCI;EACI,6BAAA;AXgpCR;AW7oCI;EACI,6BAAA;AX+oCR;AW5oCI;EACI,6BAAA;AX8oCR;AW3oCI;EACI,6BAAA;AX6oCR;AW3oCQ;EACI,6BAAA;AX6oCZ;AW3oCY;EACI,6BAAA;AX6oChB;AWxoCI;;EAEI,6BAAA;AX0oCR;AWvoCI;EACI,kBAAA;AXyoCR;AWtoCI;EACI,6BAAA;AXwoCR;AWroCI;EACI,8BAAA;AXuoCR;AWpoCI;;EAEI,kBAAA;AXsoCR;AWnoCI;;EAEI,kBAAA;AXqoCR;AWloCI;EACI,6BAAA;AXooCR;AWjoCI;;;;EAII,6BAAA;AXmoCR;;AYhwCA;EACI,eAAA;AZmwCJ;AYhwCQ;EACI,oCAAA;AZkwCZ;AYhwCY;EACI,eAAA;AZkwChB;AY9vCQ;;EAEI,oCAAA;AZgwCZ;AY9vCY;;EACI,eAAA;AZiwChB;AY3vCQ;EACI,mBAAA;AZ6vCZ;AY1vCQ;;EAEI,oCAAA;AZ4vCZ;;AYvvCA;EACI,wBAAA;EACA,8BAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AZ0vCJ;AYxvCI;EACI,eAAA;EACA,gBAAA;AZ0vCR;AYvvCY;EACI,2CAAA;EACA,8CAAA;EACA,+CAAA;AZyvChB;AYtvCY;EACI,oDAAA;EACA,6CAAA;AZwvChB;AYpvCY;EACQ,+CAAA;AZsvCpB;AYpvCgB;EACI,gBAAA;EACA,+CAAA;EACA,8CAAA;EACA,yCAAA;EACA,4CAAA;AZsvCpB;AYpvCoB;EACI,2CAAA;EACA,iBAAA;AZsvCxB;AYnvCoB;EACI,+CAAA;AZqvCxB;AY7uCwB;EACI,yCAAA;AZ+uC5B;;Aaj0CI;EACI,yBAAA;EACA,0BAAA;Abo0CR;;Ac/zCQ;;;;;;;EACI,eAAA;EACA,gBAAA;Adw0CZ;Acp0CI;;;;;;;EACI,qBAAA;Ad40CR;Acx0CgB;;;;;;;EACI,kCAAA;Adg1CpB;;AAh1CA;EACE,uBAAA;AAm1CF;;AAh1CA;EACE,YAAA;AAm1CF;;AAh1CA;EACE,oCAAA;UAAA,4BAAA;AAm1CF;;AAh1CA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;AAm1CF;;AAh1CA;EACE,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,SAAA;AAm1CF;AAj1CE;EACE,cAAA;EACA,SAAA;AAm1CJ;AAh1CE;EACE,uBAAA;AAk1CJ;;AA90CA;EACE,oCAAA;AAi1CF;;AA90CA;EACE,+BAAA;AAi1CF;;AA90CA;EACE,iBAAA;AAi1CF;;AA90CA;;EAEE,2BAAA;AAi1CF;;AA50CE;;;;EAIE,4BAAA;AA+0CJ;;AA30CA;EACE,aAAA;AA80CF;;AAz0CE;;;;EAIE,2BAAA;AA40CJ;;AAx0CA;EACE,iDAAA;AA20CF;;AAv0CE;EACE,+CAAA;AA00CJ;;AAr0CE;EACE,aAAA;AAw0CJ;;AAp0CA;EACE,wBAAA;AAu0CF;;AAp0CA;EACE,aAAA;AAu0CF;;AAp0CA;EACE,gCAAA;AAu0CF;;AAp0CA;EACE,sBAAA;EACA,8BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;AAu0CF;;AAp0CA;EACE;IACE,UAAA;EAu0CF;EAp0CA;IACE,UAAA;EAs0CF;AACF;AA3xCA;EACE,uBAAA;EACA,qBAAA;AA6zCF;;AA1zCA;EACE,oCAAA;EACA,iBAAA;AA6zCF;;AA1zCA;EAEE;;;;IAIE,wBAAA;EA4zCF;AACF;AAzzCA;EACE;IACE,WAAA;EA2zCF;EAxzCA;IACE,cAAA;IACA,OAAA;IACA,QAAA;EA0zCF;AACF;AAvzCA;EACE,2BAAA;AAyzCF;;AAtzCA;EACE,aAAA;EACA,mCAAA;AAyzCF;;AAtzCA;EACE,YAAA;EACA,gBAAA;AAyzCF;;AAtzCA;EACE,gBAAA;EACA,+CAAA;EACA,2CAAA;AAyzCF;;AAtzCA;EACE,qBAAA;AAyzCF;;AArzCA;;EAEE,eAAA;EACA,aAAA;EACA,oBAAA;AAwzCF;;AArzCA;EACE,yBAAA;AAwzCF;;AApzCE;EACE,8BAAA;AAuzCJ;;AAnzCA;EACE,2BAAA;AAszCF;;AAnzCA;EACE,qCAAA;EACA,0BAAA;EACA,8BAAA;AAszCF;;AAnzCA;EACE,kCAAA;EACA,0BAAA;EACA,8BAAA;AAszCF;;AAnzCA;EACE,uCAAA;EACA,6BAAA;AAszCF;;AAnzCA;EACE,uCAAA;EACA,6BAAA;EACA,gBAAA;EACA,YAAA;AAszCF;;AAnzCA;EACE,6BAAA;EACA,gCAAA;AAszCF;;AAnzCA;EACE,qBAAA;EACA,sBAAA;EACA,wBAAA;AAszCF;;AAnzCA;;EAEE,4CAAA;EACA,8CAAA;AAszCF;;AAnzCA;EACE,sCAAA;EACA,uBAAA;AAszCF;;AAnzCA;EACE,YAAA;AAszCF;;AAnzCA;EACE,8BAAA;EACA,wBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kCAAA;EACA,uBAAA;AAszCF;;AAnzCA;EACE,kCAAA;EACA,4BAAA;EACA,2BAAA;EACA,6BAAA;AAszCF;AApzCE;EACE,4BAAA;EACA,oCAAA;AAszCJ;AAlzCI;EACE,qCAAA;EACA,8BAAA;EACA,gCAAA;EACA,UAAA;AAozCN;;AA/yCA;EACE,kCAAA;EACA,6BAAA;EACA,uBAAA;EACA,6BAAA;EACA,6BAAA;EACA,wBAAA;EACA,sBAAA;EACA,sBAAA;AAkzCF;AAhzCE;EACE,4CAAA;EACA,qCAAA;AAkzCJ;AA/yCE;EACE,kCAAA;EACA,gCAAA;EACA,yBAAA;AAizCJ;AA9yCE;EACE,wBAAA;EACA,2BAAA;AAgzCJ;AA7yCE;EACE,wCAAA;AA+yCJ;;AA3yCA;EACE,8BAAA;EACA,wBAAA;EACA,oCAAA;AA8yCF;AA5yCE;EACE,oBAAA;AA8yCJ;;AA1yCA;EACE,wBAAA;EACA,iCAAA;AA6yCF;AA3yCE;EACE,+BAAA;EACA,6BAAA;AA6yCJ;AA1yCE;EACE,wBAAA;AA4yCJ;AAzyCE;EACE,2BAAA;AA2yCJ;;AAvyCA;EACE,iCAAA;AA0yCF;;AAvyCA;EACE,6BAAA;AA0yCF;;AAvyCA;EACE,0BAAA;AA0yCF;;AAvyCA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;EACA,6BAAA;EACA,eAAA;AA0yCF;AAtyCI;;EAEE,iBAAA;AAwyCN;AApyCE;EACE,+CAAA;EACA,6BAAA;AAsyCJ;AApyCI;EACE,UAAA;EACA,WAAA;AAsyCN;AAnyCI;EACE,UAAA;EACA,+CAAA;AAqyCN;AAhyCE;EAjCF;IAkCI,+BAAA;EAmyCF;AACF;;AA/xCE;EACE,gDAAA;AAkyCJ;AA/xCE;EACE,wCAAA;EACA,2CAAA;EACA,0BAAA;AAiyCJ;AA9xCE;EACE,wCAAA;AAgyCJ;AA7xCE;EACE,0BAAA;AA+xCJ;AA7xCI;EACE,+CAAA;AA+xCN;AA3xCE;EACE,2CAAA;AA6xCJ;;AAzxCA;EACE,4BAAA;EACA,gCAAA;AA4xCF;AA1xCE;EACE,wBAAA;AA4xCJ;AAzxCE;EACE,yCAAA;AA2xCJ;AAxxCE;EACE,2BAAA;AA0xCJ;;AAtxCA;EACE,YAAA;AAyxCF;;AAnxCE;;;EACE,yBAAA;AAwxCJ;AArxCE;;;EACE,yCAAA;AAyxCJ;AAtxCE;;;EACE,2BAAA;AA0xCJ;;AAtxCA;EACE,wBAAA;EACA,0BAAA;AAyxCF;;AAhxCE;EACE,oCAAA;EACA,eAAA;AAmxCJ;;AA/wCA;EACE,wBAAA;AAkxCF;;AA/wCA;;EAEE,wCAAA;AAkxCF;;AA/wCA;EACE,yCAAA;EACA,0BAAA;EACA,+CAAA;EACA,+BAAA;AAkxCF;;AA/wCA;EACE,kBAAA;AAkxCF;;AA/wCA;EACE,wBAAA;AAkxCF;;AA/wCA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;AAkxCF;AAhxCE;EACE,mBAAA;EACA,2BAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;AAkxCJ;AA/wCE;EACE,kCAAA;EACA,uBAAA;EACA,iCAAA;EACA,yBAAA;EACA,kCAAA;EACA,YAAA;EACA,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,+BAAA;EACA,oCAAA;UAAA,4BAAA;AAixCJ;AA9wCE;EACE,uCAAA;EACA,yCAAA;EACA,gCAAA;EACA,+CAAA;AAgxCJ;AA9wCI;EACE,mDAAA;EACA,+CAAA;AAgxCN;AA9wCM;EACE,wBAAA;AAgxCR;;AA1wCA;EACE,kCAAA;EACA,uBAAA;EACA,2CAAA;EACA,2BAAA;AA6wCF;AA3wCE;EACE,0EAAA;AA6wCJ;AA1wCE;EACE,0EAAA;AA4wCJ;;AAtwCE;;;;;EAKE,kCAAA;AAywCJ;AArwCI;EACE,8BAAA;AAuwCN;AApwCI;EACE,6BAAA;AAswCN;AAnwCI;EACE,2BAAA;AAqwCN;AAjwCE;EACE,qBAAA;AAmwCJ;AAhwCE;EACE,2BAAA;AAkwCJ;;AA9vCA;EACE,2BAAA;AAiwCF;;AA9vCA;EACE,iDAAA;EACA,2BAAA;EACA,oBAAA;EACA,gCAAA;AAiwCF;;AA9vCA;EACE,oDAAA;EACA,yCAAA;EACA,+BAAA;AAiwCF;;AA9vCA;EACE,uBAAA;AAiwCF;;AA9vCA;EACE,8BAAA;AAiwCF;;AA9vCA;EACE,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,kCAAA;AAiwCF;;AA7vCE;EADF;IAEI,wBAAA;EAiwCF;AACF;AA/vCE;EACE,gCAAA;AAiwCJ;;AA5vCE;EADF;IAEI,sBAAA;IACA,oBAAA;EAgwCF;AACF;;AA5vCE;EADF;IAEI,2BAAA;EAgwCF;AACF;;AA5vCE;EADF;IAEI,+BAAA;EAgwCF;AACF;;AA5vCA;EACE,0BAAA;AA+vCF;;AA5vCA;EACE,yDAAA;AA+vCF;;AA5vCA;EACE,wBAAA;EACA,iCAAA;EACA,oBAAA;EACA,aAAA;AA+vCF;AA7vCE;EACE,wBAAA;AA+vCJ;;AA3vCA;EACE,WAAA;AA8vCF;;AA3vCA;EACE,0BAAA;EACA,gCAAA;EACA,6BAAA;AA8vCF;;AA3vCA;EACE,8CAAA;AA8vCF;;AA3vCA;;;EAGE,wCAAA;AA8vCF;;AA3vCA;EACE,wCAAA;AA8vCF;;AA3vCA;EACE,sDAAA;AA8vCF;;AA3vCA;EACE,sBAAA;AA8vCF;;AA3vCA;EACE,oDAAA;EACA,sCAAA;EACA,eAAA;EACA,2BAAA;AA8vCF;;AA3vCA;EACE,0BAAA;AA8vCF;AA3vCI;EACE,wCAAA;AA6vCN;;AAxvCA;EACE,2CAAA;AA2vCF;;AAxvCA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AA2vCF;;AAxvCA;EACE,6CAAA;EACA,+CAAA;AA2vCF;;AAxvCA;EACE,2BAAA;AA2vCF;;AAxvCA;;;EAGE,2BAAA;AA2vCF;;AAxvCA;EACE,aAAA;AA2vCF;;AAxvCA;EACE,sBAAA;EACA,aAAA;EACA,uBAAA;AA2vCF;AAzvCE;EACE,2BAAA;EACA,6BAAA;EACA,8BAAA;EACA,sBAAA;AA2vCJ;AAzvCI;EACE,kBAAA;AA2vCN;AAxvCI;EACE,+BAAA;EACA,gCAAA;AA0vCN;AArvCQ;;;;EAEE,sBAAA;AAyvCV;;AAlvCA;EACE,sBAAA;EACA,aAAA;EACA,uBAAA;AAqvCF;AAnvCE;EACE,2BAAA;EACA,6BAAA;EACA,8BAAA;EACA,sBAAA;AAqvCJ;AAnvCI;EACE,kBAAA;AAqvCN;AAjvCE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AAmvCJ;AAjvCI;EACE,2BAAA;EACA,WAAA;AAmvCN;AAjvCM;EACE,6CAAA;EACA,8CAAA;AAmvCR;AAjvCQ;EACE,uCAAA;AAmvCV;AAjvCU;EACE,kBAAA;EACA,UAAA;AAmvCZ;;AA3uCA;EACE,mCAAA;EACA,8BAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;AA8uCF;;AA3uCA;EACE,8BAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;AA8uCF;;AA3uCA;;EAEE,sCAAA;EACA,8BAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;AA8uCF;;AA3uCA;EAEE,8BAAA;EACA,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,eAAA;AA6uCF;;AA1uCA;EACE,sBAAA;EACA,wBAAA;AA6uCF;;AA1uCA;EACE,8BAAA;EACA,sCAAA;EACA,gBAAA;EACA,mBAAA;AA6uCF;;AA1uCA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,2BAAA;AA6uCF;AA3uCE;EACE,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,qCAAA;AA6uCJ;;AAzuCA;EACE,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,0BAAA;EACA,eAAA;EACA,8BAAA;EACA,sCAAA;EACA,gBAAA;EACA,4BAAA;AA4uCF;;AAzuCA;EACE,+CAAA;EACA,yDAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AA4uCF;;AAzuCA;EACE,aAAA;AA4uCF;;AAzuCA;EACE,SAAA;EACA,UAAA;AA4uCF;;AAzuCA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;AA4uCF;AA1uCE;EACE,gBAAA;EACA,WAAA;AA4uCJ;AA1uCI;EACE,6CAAA;AA4uCN;;AAtuCE;EACE,kBAAA;EACA,sCAAA;EACA,cAAA;AAyuCJ;;AAruCA;;EAEE,2BAAA;AAwuCF;;AAruCA;EACE,0DAAA;AAwuCF;;AAruCA;EACE,6CAAA;AAwuCF;;AAruCA;EACE,kCAAA;AAwuCF;;AAruCA;EACE,YAAA;AAwuCF;AAtuCE;EACE,0BAAA;EACA,mBAAA;EACA,YAAA;AAwuCJ;AAtuCI;EACE,YAAA;AAwuCN;;AAluCA;;EAEE,yBAAA;AAquCF;AAnuCE;;EACE,0BAAA;AAsuCJ;;AAluCA;;;;;EAKE,yBAAA;AAquCF;AAnuCE;;;;;EACE,0BAAA;AAyuCJ;;AAruCA;;EAEE,yBAAA;AAwuCF;AAtuCE;;EACE,0BAAA;AAyuCJ;;AApuCE;EACE,qCAAA;AAuuCJ;;AAjuCE;;EAEE,sBAAA;AAouCJ;;AAhuCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAmuCF;;AAhuCA;EACE,wCAAA;AAmuCF;AAjuCE;EACE,gCAAA;AAmuCJ;AAhuCE;EACE,eAAA;EACA,gDAAA;AAkuCJ;AAhuCI;EACE,qBAAA;AAkuCN;AA/tCI;EACE,oCAAA;AAiuCN;;AA5tCA;EACE,iDAAA;AA+tCF;;AA5tCA;EACE,mCAAA;AA+tCF;;AA3tCE;EACE,6BAAA;AA8tCJ;;AAxtCE;EACE,aAAA;AA2tCJ;AAxtCE;EACE,wCAAA;AA0tCJ;;AAttCA;EACE,2BAAA;EACA,uBAAA;AAytCF;;AAttCA;EACE,6CAAA;EACA,+CAAA;AAytCF;;AAttCA;EACE,0BAAA;AAytCF;AAvtCE;EACE,uBAAA;AAytCJ;AAvtCI;EACE,2BAAA;AAytCN;AAttCI;EACE,2BAAA;AAwtCN;;AAntCA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AAstCF;;AAntCA;EACE,cAAA;EACA,aAAA;AAstCF;;AAntCA;EACE,WAAA;AAstCF;;AAntCA;EACE,gBAAA;EACA,6BAAA;AAstCF;;AAntCA;EACE,gBAAA;EACA,yBAAA;EACA,cAAA;AAstCF;;AAntCA;EACE,2BAAA;EACA,kBAAA;EACA,UAAA;AAstCF;;AAntCA;EACE,eAAA;EACA,mBAAA;AAstCF;;AAntCA;EACE,0BAAA;AAstCF;;AAntCA;EACE,kBAAA;AAstCF;;AAntCA;EACE,gBAAA;EACA,wCAAA;EACA,+BAAA;EACA,mEAAA;EACA,uFAAA;AAstCF;;AAntCA;EACE,YAAA;AAstCF;;AAntCA;;EAEE,+DAAA;AAstCF;;AAjtCE;EACE,sBAAA;AAotCJ;AAltCI;EACE,kCAAA;AAotCN;;AA/sCA;EACE,mBAAA;AAktCF;;AA/sCA;;EAEE,gBAAA;EACA,2BAAA;AAktCF;;AA9sCA;;EAEE,0BAAA;AAitCF;;AA7sCA;EACE,iDAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAgtCF;;AA7sCA;EACE,aAAA;EACA,sBAAA;AAgtCF;AA9sCE;EACE,gDAAA;EACA,kCAAA;EACA,8BAAA;EACA,gCAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAgtCJ;AA9sCI;EACE,YAAA;AAgtCN;AA5sCE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,+CAAA;EACA,yDAAA;EACA,kBAAA;EACA,UAAA;AA8sCJ;AA5sCI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AA8sCN;AA5sCM;EACE,4BAAA;AA8sCR;AA5sCQ;EACE,uBAAA;AA8sCV;AA1sCM;EACE,eAAA;AA4sCR;;AArsCE;EACE,gDAAA;EACA,kCAAA;EACA,8BAAA;EACA,gCAAA;EACA,yBAAA;EACA,cAAA;AAwsCJ;AAtsCI;EACE,YAAA;AAwsCN;AApsCE;EACE,WAAA;EACA,0DAAA;EACA,yBAAA;EACA,kBAAA;AAssCJ;AAlsCQ;EACE,0DAAA;EACA,iCAAA;AAosCV;AAlsCU;EACE,iDAAA;EACA,gCAAA;AAosCZ;;AAzrCE;EACE,eAAA;EACA,gBAAA;AA4rCJ;AAxrCM;;;EAGE,8CAAA;EACA,+CAAA;EACA,WAAA;AA0rCR;AAvrCM;EACE,oDAAA;EACA,6CAAA;AAyrCR;AAprCM;EACE,2CAAA;EACA,8CAAA;EACA,+CAAA;AAsrCR;AAnrCM;EACE,eAAA;EACA,sCAAA;EACA,8BAAA;AAqrCR;AAlrCM;EACE,oDAAA;EACA,6CAAA;AAorCR;AAjrCM;EACE,aAAA;EACA,eAAA;AAmrCR;AA/qCM;EACE,yCAAA;AAirCR;AA/qCQ;EACE,+CAAA;EACA,kBAAA;AAirCV;AA/qCU;EACE,+CAAA;EACA,8CAAA;EACA,+CAAA;EACA,gBAAA;AAirCZ;AA/qCY;EACE,+CAAA;AAirCd;AA9qCY;EACE,2CAAA;EACA,qBAAA;AAgrCd;;AArqCE;EACE,yCAAA;EACA,6CAAA;AAwqCJ;;AAnqCE;EACE,yCAAA;EACA,8CAAA;AAsqCJ;;AAjqCE;EACE,0BAAA;EACA,0BAAA;EACA,gDAAA;EACA,kCAAA;EACA,8BAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAoqCJ;AAlqCI;EACE,YAAA;AAoqCN;AAhqCE;EACE,0DAAA;EACA,eAAA;AAkqCJ;AAhqCI;EACE,0BAAA;EACA,0BAAA;AAkqCN;AAhqCM;EACE,aAAA;AAkqCR;AAhqCQ;EACE,QAAA;EACA,aAAA;EACA,2BAAA;EACA,UAAA;EACA,cAAA;AAkqCV;AA9pCM;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;AAgqCR;AA9pCQ;EACE,oBAAA;EACA,qBAAA;AAgqCV;AA7pCQ;EACE,qBAAA;EACA,YAAA;AA+pCV;AA3pCM;EACE,mBAAA;EACA,cAAA;AA6pCR;AA1pCU;EACE,wBAAA;EACA,6CAAA;EACA,iCAAA;AA4pCZ;AAvpCM;EACE,sBAAA;AAypCR;AAvpCQ;EACE,aAAA;EACA,uBAAA;EACA,wBAAA;EACA,+BAAA;AAypCV;AAvpCU;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AAypCZ;AAvpCY;EACE,sBAAA;EACA,uBAAA;AAypCd;AAtpCY;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAwpCd;AAtpCc;EACE,kBAAA;EACA,WAAA;AAwpChB;AAtpCgB;EACE,eAAA;EACA,0BAAA;AAwpClB;AAhpCM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAkpCR;AAhpCQ;EACE,qBAAA;AAkpCV;AA/oCQ;EACE,YAAA;EACA,aAAA;EACA,eAAA;AAipCV;AA/oCU;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAipCZ;AA/oCY;EACE,aAAA;EACA,uBAAA;EACA,4BAAA;AAipCd;AA/oCc;EACE,4BAAA;AAipChB;AA7oCY;EACE,kBAAA;AA+oCd;AA7oCc;EACE,eAAA;EACA,0BAAA;AA+oChB;AA3oCY;EACE,sBAAA;EACA,uBAAA;AA6oCd;AAzoCU;EACE,oBAAA;EACA,YAAA;AA2oCZ;AAroCQ;EACE,YAAA;EACA,aAAA;EACA,aAAA;AAuoCV;AApoCQ;EACE,YAAA;EACA,eAAA;AAsoCV;AApoCU;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAsoCZ;AApoCY;EACE,kBAAA;EACA,WAAA;AAsoCd;AApoCc;EACE,eAAA;EACA,0BAAA;AAsoChB;AAloCY;EACE,sBAAA;EACA,uBAAA;AAooCd;AAhoCU;EACE,oBAAA;EACA,YAAA;AAkoCZ;;AAznCE;EACE,oBAAA;EACA,qBAAA;AA4nCJ;AAznCE;EACE,gDAAA;EACA,kCAAA;EACA,8BAAA;EACA,8BAAA;EACA,yBAAA;EACA,cAAA;AA2nCJ;AAznCI;EACE,YAAA;AA2nCN;AAvnCE;EAEE,YAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,0DAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAwnCJ;AAtnCI;EACE,WAAA;EACA,iDAAA;AAwnCN;AArnCI;EACE,wCAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,mBAAA;EACA,WAAA;AAunCN;AApnCI;EACE,sBAAA;EACA,2BAAA;AAsnCN;AAlnCE;EACE,aAAA;EACA,yBAAA;AAonCJ;AAjnCE;EACE,gBAAA;AAmnCJ;;AA/mCA;EACE,gBAAA;EACA,4BAAA;EACA,+BAAA;AAknCF;;AA/mCA;EACE,aAAA;EACA,oDAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;AAknCF;AAhnCE;EACE,gBAAA;EACA,aAAA;AAknCJ;AA9mCE;EACE,gBAAA;EACA,aAAA;AAgnCJ;AA5mCE;EACE,gBAAA;EACA,aAAA;AA8mCJ;;AA1mCA;EACE,aAAA;EACA,oDAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;AA6mCF;AA3mCE;EACE,gBAAA;EACA,aAAA;AA6mCJ;AA1mCE;EACE,gBAAA;EACA,aAAA;AA4mCJ;;AAxmCA;EACE,aAAA;EACA,oDAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;AA2mCF;;AAxmCA;EACE,aAAA;EACA,oDAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AA2mCF;;AAxmCA;EACE,aAAA;EACA,sBAAA;AA2mCF;AAzmCE;EACE,gDAAA;EACA,kCAAA;EACA,8BAAA;EACA,gCAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AA2mCJ;AAzmCI;EACE,YAAA;AA2mCN;AAvmCE;EACE,aAAA;EACA,SAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,+CAAA;EACA,yDAAA;EACA,kBAAA;EACA,UAAA;AAymCJ;AAvmCI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAymCN;AAvmCM;EACE,4BAAA;AAymCR;AAvmCQ;EACE,uBAAA;AAymCV;AArmCM;EACE,eAAA;AAumCR;AAnmCI;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;AAqmCN;AAjmCI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AAmmCN;AAjmCM;EACE,0BAAA;AAmmCR;AAjmCQ;EACE,uBAAA;AAmmCV;AA/lCM;EACE,eAAA;AAimCR;;AA3lCA;EACE,aAAA;EACA,sBAAA;AA8lCF;AA5lCE;EACE,gDAAA;EACA,kCAAA;EACA,8BAAA;EACA,gCAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AA8lCJ;AA5lCI;EACE,YAAA;AA8lCN;AA1lCE;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;AA4lCJ;AA1lCI;EACE,YAAA;EACA,aAAA;EACA,+CAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AA4lCN;AA1lCM;EACE,kBAAA;EACA,gDAAA;EACA,WAAA;EACA,8BAAA;AA4lCR;AAzlCM;EACE,kBAAA;EACA,iDAAA;EACA,WAAA;EACA,6BAAA;EACA,mBAAA;AA2lCR;AAtlCI;EACE,6BAAA;EAEA,0BAAA;EACA,mBAAA;EACA,UAAA;AAulCN;AArlCM;EACE,kBAAA;EACA,gDAAA;EACA,+BAAA;EACA,8BAAA;AAulCR;;AAjlCA;EACE,aAAA;EACA,oDAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AAolCF;AAllCE;EACE,gBAAA;EACA,aAAA;AAolCJ;AAjlCE;EACE,gBAAA;EACA,aAAA;AAmlCJ;AAhlCE;EACE,gBAAA;EACA,aAAA;AAklCJ;AA9kCE;EACE,gBAAA;EACA,aAAA;AAglCJ;;AA5kCA;EACE,aAAA;EACA,oDAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AA+kCF;AA7kCE;EACE,gBAAA;EACA,aAAA;AA+kCJ;AA5kCE;EACE,gBAAA;EACA,aAAA;AA8kCJ;AA3kCE;EACE,gBAAA;EACA,aAAA;AA6kCJ;;AAzkCA;EACE,aAAA;EACA,oDAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AA4kCF;AA1kCE;EACE,gBAAA;EACA,aAAA;AA4kCJ;AAzkCE;EACE,gBAAA;EACA,aAAA;AA2kCJ;;AAtkCE;EACE,+BAAA;AAykCJ;;AAnkCE;EACE,2BAAA;AAskCJ;AAnkCE;EACE,2BAAA;AAqkCJ;;AAjkCA;EACE,0BAAA;AAokCF;AAlkCE;EACE,qCAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAokCJ;AAlkCI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AAokCN;AAlkCM;EACE,YAAA;EACA,mBAAA;AAokCR;AAlkCQ;EACE,eAAA;EACA,2CAAA;AAokCV;AAhkCM;EACE,2CAAA;AAkkCR;;AA1jCI;EACE,gCAAA;EACA,8BAAA;EACA,kCAAA;AA6jCN;AA3jCM;EACE,kCAAA;AA6jCR;AA3jCQ;EACE,+CAAA;EACA,mCAAA;EACA,2BAAA;EACA,gBAAA;EACA,gCAAA;EACA,yCAAA;AA6jCV;AA3jCU;EACE,+CAAA;AA6jCZ;AA1jCU;EACE,WAAA;AA4jCZ;AAvjCM;EACE,4BAAA;AAyjCR;AApjCQ;;;EAGE,gCAAA;AAsjCV;AAjjCI;EACE,kBAAA;AAmjCN;AAhjCI;EACE,0DAAA;EACA,WAAA;AAkjCN;AAhjCM;EACE,0DAAA;EACA,sBAAA;AAkjCR;AA9iCI;EACE,2BAAA;AAgjCN;AA7iCI;EACE,2BAAA;AA+iCN;;AAziCE;EACE,6CAAA;AA4iCJ;AA1iCI;EACE,+CAAA;AA4iCN;;AApiCI;;;EAGE,6CAAA;EACA,+CAAA;AAuiCN;AAjiCI;;;EAGE,6CAAA;EACA,+CAAA;AAmiCN;AA9hCI;EACE,2BAAA;AAgiCN;;AAxhCM;EACE,sBAAA;AA2hCR;AAxhCM;EACE,sBAAA;AA0hCR;;AAphCA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAuhCF;;AAphCA;EACE,oBAAA;EACA,4BAAA;EACA,kBAAA;AAuhCF;AArhCE;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,aAAA;EACA,oDAAA;EAEA,kBAAA;EACA,SAAA;AAshCJ;AAphCI;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAshCN;AAphCM;EACE,6CAAA;EACA,yCAAA;EACA,2CAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;AAshCR;AAlhCI;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,0BAAA;AAohCN;AAlhCM;EACE,aAAA;EACA,mBAAA;EACA,+CAAA;EACA,8BAAA;EACA,2CAAA;AAohCR;AAlhCQ;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;AAohCV;;AA//BA;EACE,WAAA;EACA,kBAAA;EACA,+BAAA;AAkgCF;AAhgCE;EACE,yBAAA;AAkgCJ;AAhgCI;EACE,oBAAA;EACA,uBAAA;EACA,WAAA;AAkgCN;AAhgCM;EACE,sBAAA;AAkgCR;AAhgCQ;EACE,0BAAA;AAkgCV;AAhgCU;EACE,0BAAA;AAkgCZ;;AAz/BA;EACE,qCAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AA4/BF;;AAz/BA;;EAEE,WAAA;AA4/BF;;AAz/BA;EACE,kBAAA;AA4/BF;;AAz/BA;EACE,4BAAA;AA4/BF;;AAz/BA;EACE,+CAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AA4/BF;AA1/BE;EACE,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AA4/BJ;AA1/BI;EACE,YAAA;EACA,YAAA;EACA,sBAAA;AA4/BN;AAx/BE;EACE,eAAA;EACA,eAAA;EACA,aAAA;AA0/BJ;AAx/BI;EACE,YAAA;EACA,aAAA;EACA,oBAAA;AA0/BN;;AAr/BA;EACE,+CAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAw/BF;AAt/BE;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;AAw/BJ;AAt/BI;EACE,YAAA;EACA,aAAA;EACA,oBAAA;AAw/BN;;AAn/BA;EACE,aAAA;EACA,oDAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;AAs/BF;AAp/BE;;EAEE,WAAA;EACA,+CAAA;EACA,qBAAA;AAs/BJ;;AAl/BA;EACE,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AAq/BF;;AAl/BA;EACE,iBAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;AAq/BF;;AA/+BM;EACE,sBAAA;AAk/BR;;AA5+BA;EACE,WAAA;EACA,6CAAA;EACA,qBAAA;AA++BF;;AA5+BA;EACE,qBAAA;AA++BF;;AA5+BA;EACE,iBAAA;AA++BF;AA7+BE;EACE,kBAAA;AA++BJ;AA5+BE;EACE,gBAAA;EACA,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,kCAAA;EACA,mBAAA;EACA,oBAAA;AA8+BJ;AA5+BI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AA8+BN;AA1+BE;EACE,kCAAA;EACA,iBAAA;AA4+BJ;AAz+BE;EACE,gCAAA;EACA,qCAAA;EACA,mBAAA;EACA,sBAAA;AA2+BJ;;AAv+BA;EACE,sBAAA;EACA,sBAAA;EACA,oCAAA;EACA,eAAA;AA0+BF;;AAv+BA;EACE,4BAAA;AA0+BF;;AAv+BA;EACE,6BAAA;EACA,8BAAA;AA0+BF;;AAv+BA;EACE,qBAAA;AA0+BF;;AAv+BA;EACE,oBAAA;AA0+BF;;AAv+BA;EACE,mBAAA;EACA,qCAAA;EACA,WAAA;AA0+BF;;AAv+BA;EACE,mBAAA;EACA,oCAAA;EACA,WAAA;AA0+BF;;AAv+BA;;;EAGE,4BAAA;AA0+BF;;AAr+BA;EACE,2BAAA;EACA,kBAAA;AAw+BF;;AAr+BA;EACE,2BAAA;EACA,kBAAA;AAw+BF;;AAl+BA;EACE,cAAA;EACA,QAAA;EACA,qCAAA;EACA,8BAAA;AAq+BF;;AAl+BA;EACE,QAAA;AAq+BF;;AAl+BA;EACE,cAAA;EACA,iBAAA;EACA,QAAA;EACA,qCAAA;EACA,8BAAA;AAq+BF;;AAh+BA;EACE,iBAAA;AAm+BF;AAj+BE;EACE,gDAAA;EACA,kCAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAm+BJ;;AA99BE;EACE,0BAAA;AAi+BJ;AA79BI;EACE,0BAAA;AA+9BN;AA19BI;EACE,0BAAA;AA49BN;AAx9BE;EACE,aAAA;AA09BJ;;AAr9BE;EACE,8BAAA;EACA,sCAAA;EACA,8BAAA;EACA,WAAA;AAw9BJ;AAr9BE;EACE,sBAAA;EACA,uBAAA;AAu9BJ;AAr9BI;EACE,qBAAA;EACA,+BAAA;AAu9BN;AAn9BE;EACE,aAAA;AAq9BJ;AAh9BM;EACE,kBAAA;EACA,uBAAA;EACA,0BAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AAk9BR;AA58BM;EACE,kBAAA;EACA,uBAAA;EACA,+CAAA;EACA,0BAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA88BR;AA38BM;EACE,kBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA68BR;;AAp8BM;EACE,0BAAA;EACA,+BAAA;EACA,YAAA;AAu8BR;;AA97BM;EACE,kBAAA;EACA,uBAAA;EACA,0BAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AAi8BR;AA37BM;EACE,kBAAA;EACA,uBAAA;EACA,+CAAA;EACA,0BAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA67BR;AA17BM;EACE,kBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA47BR;;AAt7BA;EACE,sCAAA;AAy7BF;;AAt7BA;EACE,sBAAA;AAy7BF;;AAt7BA;EACE,6BAAA;AAy7BF;;AAt7BA;EACE,aAAA;EACA,wBAAA;AAy7BF;;AAn7BE;;EACE,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAu7BJ;;AAh7BE;EACE,2BAAA;AAm7BJ;AAj7BE;EACE,mDAAA;AAm7BJ;AAh7BE;EACE,0DAAA;AAk7BJ;;AA76BE;EACE,yCAAA;EACA,2DAAA;AAg7BJ;;AA56BA;EACE,qCAAA;EACA,wCAAA;EACA,4BAAA;AA+6BF;;AA56BA;EACE,yBAAA;AA+6BF;;AA36BA;EACE,qCAAA;EACA,wCAAA;EACA,4BAAA;AA86BF;;AA36BA;EACE,mCAAA;EACA,wCAAA;EACA,4BAAA;AA86BF;;AA36BA;;EAEE,sBAAA;AA86BF;;AAz6BA;EACE,8BAAA;EACA,0BAAA;AA46BF;;AAx6BA;EACE,aAAA;AA26BF;;AAv6BA;;;;EAIM,uCAAA;AA06BN;;AAr6BA;EACE,wBAAA;AAw6BF;;AAr6BA;EACE,aAAA;AAw6BF;;AAr6BA;EACE,oBAAA;EACA,sBAAA;AAw6BF;;AAp6BE;EACE,wCAAA;AAu6BJ;;AAn6BA;EACE,sBAAA;AAs6BF;;AAn6BA;;;EAGE,0BAAA;AAs6BF;;AAl6BA;EACE,eAAA;AAq6BF;AAp6BE;EACE,oBAAA;AAs6BJ;AAp6BI;EACE,0BAAA;AAs6BN;;AAh6BA;EACE,8BAAA;AAm6BF;;AA95BE;EACE,iBAAA;AAi6BJ","sourcesContent":[":root {\n  --rsbs-backdrop-bg: rgba(0, 0, 0, 0.6);\n  --rsbs-bg: var(--backgroundColor);\n  --rsbs-handle-bg: var(--borderAndLineColor);\n  --rsbs-max-w: auto;\n  --rsbs-ml: env(safe-area-inset-left);\n  --rsbs-mr: env(safe-area-inset-right);\n  --rsbs-overlay-rounded: 16px;\n}\n","@import \"base/reset.scss\";\n@import \"components/boxfull.scss\";\n@import \"components/crud.scss\";\n@import \"components/dialog.scss\";\n@import \"components/dashboard.scss\";\n@import \"components/datatable.scss\";\n@import \"components/input.scss\";\n@import \"components/schedulesBox.scss\";\n@import \"components/skeleton-global.scss\";\n@import \"components/custom-form-box.scss\";\n@import \"components/roles-pages.scss\";\n@import \"components/layout-pages.scss\";\n@import \"components/role-selector.scss\";\n@import \"components/create-labels-form-box.scss\";\n@import \"components/new-custom-dialog.scss\";\n// @import \"iuvity-ui-components/dist/resources/index.css\";\n@import \"./root.css\";\n@import \"primeicons/primeicons.css\";\n@import \"iuvity-ui-components/dist/resources/phone.styles.css\";\n\n:root {\n  --dividerColor: #EAEAEA;\n}\n\n#root {\n  height: 100%;\n}\n\n* {\n  user-select: none !important;\n}\n\nheader {\n  position: fixed;\n  width: 100vw;\n  top: 0;\n  z-index: 1001;\n}\n\n.p-sidebar {\n  margin-left: -22rem;\n  position: fixed !important;\n  z-index: 1000 !important;\n  min-height: calc(100vh - 80px);\n  top: 80px;\n\n  &.active {\n    margin-left: 0;\n    top: 80px;\n  }\n\n  &.transition {\n    transition: all ease 1s;\n  }\n}\n\n.p-sidebar .p-sidebar-header {\n  padding: 2rem 2rem 1.5rem !important;\n}\n\n.p-sidebar .p-sidebar-content {\n  padding: 0rem 1.5rem !important;\n}\n\n.p-sidebar .p-sidebar-content .p-panelmenu .p-panelmenu-panel:last-child {\n  padding-bottom: 0;\n}\n\n.p-sidebar+.boxfull-module_boxFullContainer__9jypm,\n.p-sidebar+.transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 {\n  margin-top: 80px !important;\n}\n\nbody:has(#environment-messages-alert-show) {\n\n  .p-sidebar+.boxfull-module_boxFullContainer__9jypm,\n  .p-sidebar+.transactionalsubheader-module_transactionalSubheaderContainer__MgCB8,\n  .dashboard-internal-container,\n  main {\n    margin-top: 147px !important;\n  }\n}\n\n#environment-messages-alert-show {\n  z-index: 1000;\n}\n\nbody:has(#environment-messages-alert-hide) {\n\n  .p-sidebar+.boxfull-module_boxFullContainer__9jypm,\n  .p-sidebar+.transactionalsubheader-module_transactionalSubheaderContainer__MgCB8,\n  .dashboard-external-container,\n  .dashboard-internal-container {\n    margin-top: 80px !important;\n  }\n}\n\n.p-menuitem-text {\n  font-family: var(--fontBarlowSemiBold) !important;\n}\n\n.role-selector-items {\n  .p-menuitem-text {\n    font-family: var(--fontBarlowMedium) !important;\n  }\n}\n\n.p-panelmenu-panel {\n  &:first-of-type {\n    display: none;\n  }\n}\n\n.p-dialog-mask:has(.mandatory-changepwd-dialog, .dialog-form) {\n  z-index: 1000 !important;\n}\n\n.loading-container {\n  z-index: 1200;\n}\n\n.footer a {\n  color: var(--labelsAndTextColor);\n}\n\n.fade-in {\n  animation: fadeIn 0.3s;\n  -webkit-animation: fadeIn 0.3s;\n  -moz-animation: fadeIn 0.3s;\n  -o-animation: fadeIn 0.3s;\n  -ms-animation: fadeIn 0.3s;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@-moz-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@-o-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@-ms-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.grecaptcha-badge {\n  bottom: 40vh !important;\n  z-index: 3 !important;\n}\n\n.p-inputtext[type=\"password\"]::placeholder {\n  font-family: var(--fontBarlowMedium);\n  letter-spacing: 0;\n}\n\n@media screen and (max-width: 48rem) {\n\n  .swiper-pagination-fraction,\n  .swiper-pagination-custom,\n  .swiper-horizontal>.swiper-pagination-bullets,\n  .swiper-pagination-bullets.swiper-pagination-horizontal {\n    bottom: 10rem !important;\n  }\n}\n\n@media screen and (max-width: 30rem) {\n  .speeddial-container {\n    z-index: -1;\n  }\n\n  .p-toast-top-right {\n    margin: 0 auto;\n    left: 0;\n    right: 0;\n  }\n}\n\n[data-rsbs-scroll] {\n  overflow: hidden !important;\n}\n\n.speeddial:focus {\n  outline: none;\n  border: 2px solid var(--focusColor);\n}\n\n.header-logo {\n  height: 2rem;\n  width: 12.125rem;\n}\n\n.lan-btn {\n  padding: 0.25rem;\n  font-family: var(--fontBarlowMedium) !important;\n  color: var(--cardBackgroundColorOneShade80);\n}\n\n.p-accordion-content {\n  padding: 0 !important;\n}\n\n// TODO: remove this when the issue is fixed\n.ui-input-password .p-password.input-password .pi-eye,\n.ui-input-password .p-password.input-password .pi-eye-slash {\n  cursor: pointer;\n  right: 0.5rem;\n  top: 1rem !important;\n}\n\n.ui-input-password .p-password.input-password {\n  padding-top: 0 !important;\n}\n\n.ui-input-password .p-password.input-password {\n  input {\n    padding-top: 0.5rem !important;\n  }\n}\n\n.label-container {\n  margin-bottom: 0 !important;\n}\n\n.iu-icon-success {\n  color: var(--successColor) !important;\n  font-size: 3rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.iu-icon-informative {\n  color: var(--infoColor) !important;\n  font-size: 3rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.iu-icon-dashboard {\n  color: var(--secondaryColor) !important;\n  font-size: 1.25rem !important;\n}\n\n.iu-icon-dashboard-arrow {\n  color: var(--secondaryColor) !important;\n  font-size: 1.25rem !important;\n  font-weight: 600;\n  float: right;\n}\n\n.mafy {\n  margin-top: 2.5rem !important;\n  margin-bottom: 2.5rem !important;\n}\n\n.p-toast-top-right {\n  top: 107px !important;\n  right: 32px !important;\n  z-index: 5000 !important;\n}\n\n.p-checkbox .p-checkbox-box.p-highlight,\n.p-checkbox .p-checkbox-box.p-highlight:not(.p-disabled):hover {\n  background: var(--secondaryColor) !important;\n  border-color: var(--secondaryColor) !important;\n}\n\n.p-multiselect.p-multiselect-chip .p-multiselect-token {\n  background-color: lightgray !important;\n  color: black !important;\n}\n\ninput[type=\"color\"] {\n  border: none;\n}\n\n.approvers-c {\n  align-items: center !important;\n  display: flex !important;\n  gap: 1.5rem !important;\n  flex-wrap: wrap !important;\n  justify-content: center !important;\n  height: auto !important;\n}\n\n.approvers-card {\n  flex-direction: 1 0 30% !important;\n  height: 14.563rem !important;\n  width: 19.375rem !important;\n  position: relative !important;\n\n  .p-card-subtitle {\n    font-weight: bold !important;\n    text-transform: uppercase !important;\n  }\n\n  * {\n    span {\n      font-family: var(--fontBarlowRegular);\n      font-size: var(--font-size-sm);\n      color: var(--labelsAndTextColor);\n      padding: 0;\n    }\n  }\n}\n\n.ap-button {\n  background: transparent !important;\n  border-radius: 50% !important;\n  height: 2rem !important;\n  padding: 0.75rem 0 !important;\n  position: absolute !important;\n  right: 1.5rem !important;\n  width: 2rem !important;\n  top: 1.5rem !important;\n\n  &.ap-button:enabled {\n    border-color: var(--successColor) !important;\n    color: var(--successColor) !important;\n  }\n\n  &.ap-button:disabled {\n    background: transparent !important;\n    border-color: #99e5b8 !important;\n    color: #99e5b8 !important;\n  }\n\n  &.ap-button:focus {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n\n  &.ap-button:hover {\n    background-color: transparent !important;\n  }\n}\n\n.ap-selector-btn-c {\n  align-items: center !important;\n  display: flex !important;\n  justify-content: flex-end !important;\n\n  &__cancel {\n    margin-right: 1.5rem;\n  }\n}\n\n.chips-c {\n  display: flex !important;\n  flex-direction: column !important;\n\n  * {\n    margin: 0.75rem 0rem !important;\n    width: fit-content !important;\n  }\n\n  *:first-of-type {\n    margin-top: 0 !important;\n  }\n\n  *:last-of-type {\n    margin-bottom: 0 !important;\n  }\n}\n\n.p-chip-text {\n  padding-right: 0.75rem !important;\n}\n\n.ap-chip {\n  width: fit-content !important;\n}\n\n.p-picklist-list-wrapper {\n  width: 18.75rem !important;\n}\n\n.profile-container {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 0rem 1.5rem;\n  height: 100% !important;\n  width: fit-content !important;\n  cursor: pointer;\n\n  .p_header_title {\n\n    h2,\n    h6 {\n      text-align: right;\n    }\n  }\n\n  .p-avatar {\n    background-color: var(--cardBackgroundColorOne);\n    border-radius: var(--space-s);\n\n    img {\n      width: 65%;\n      height: 65%;\n    }\n\n    &:hover {\n      opacity: 1;\n      background-color: var(--cardBackgroundColorOne);\n    }\n  }\n\n\n  @media screen and (min-width: 992px) {\n    margin-right: 0.5rem !important;\n  }\n}\n\n.op_panelmenu {\n  * {\n    font-family: var(--fontDosisSemiBold) !important;\n  }\n\n  .p-panelmenu-header-link {\n    background-color: transparent !important;\n    color: var(--labelsAndTextColor) !important;\n    padding: 0.5rem !important;\n  }\n\n  .p-panelmenu-content {\n    background-color: transparent !important;\n  }\n\n  .p-menuitem-link {\n    padding: 0.5rem !important;\n\n    &:hover {\n      background-color: rgb(232, 232, 232) !important;\n    }\n  }\n\n  .p-menuitem-text {\n    color: var(--labelsAndTextColor) !important;\n  }\n}\n\n.p-picklist-list {\n  height: 15.625rem !important;\n  margin-right: 0.75rem !important;\n\n  &::-webkit-scrollbar {\n    width: 0.5rem !important;\n  }\n\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px grey !important;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: grey !important;\n  }\n}\n\n.p-multiselect-label {\n  gap: 0.25rem;\n}\n\n.p-multiselect-items-wrapper,\n.p-dropdown-items-wrapper,\n.p-dialog-content {\n  &::-webkit-scrollbar {\n    width: 0.75rem !important;\n  }\n\n  &::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 4px grey !important;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: grey !important;\n  }\n}\n\n.p-multiselect-label {\n  display: flex !important;\n  flex-wrap: wrap !important;\n}\n\n// .p-multiselect-panel.p-component.p-connected-overlay-enter-done {\n//   position: fixed;\n//   display: block !important;\n// }\n\n.sc-menu-btn {\n  &:hover {\n    background-color: rgb(232, 232, 232);\n    cursor: pointer;\n  }\n}\n\n.p-dropdown-panel {\n  z-index: 2300 !important;\n}\n\n#DetailBackButton,\n#PageBackButton {\n  font-size: var(--font-size-tablet-title);\n}\n\n.p-multiselect .p-multiselect-label.p-placeholder {\n  color: var(--placeholderColor) !important;\n  padding-left: 0 !important;\n  font-family: var(--fontBarlowMedium) !important;\n  padding: 0.5rem 0rem !important;\n}\n\n.p-menunavbar {\n  left: 0 !important;\n}\n\n#dialogScroll1 {\n  z-index: 1101 !important;\n}\n\n.upload-container {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 95%;\n\n  .upload-input-container {\n    align-items: center;\n    background-color: lightgray;\n    border-radius: 0.25rem !important;\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    padding: 0rem 1rem;\n    width: 100%;\n  }\n\n  .upload-input {\n    background-color: white !important;\n    border-color: lightgray;\n    border-radius: 0.25rem !important;\n    margin: 0.5rem !important;\n    padding: 0.25rem 0.5rem !important;\n    height: 40px;\n    max-width: none !important;\n    width: 25rem !important;\n    box-shadow: none !important;\n    outline: 0 none !important;\n    outline-offset: 0 !important;\n    pointer-events: none !important;\n    user-select: none !important;\n  }\n\n  .upload-wrapper .p-fileupload .p-button {\n    background: var(--mainColor) !important;\n    border-color: var(--mainColor) !important;\n    border-radius: 0.5rem !important;\n    color: var(--cardBackgroundColorOne) !important;\n\n    &.p-disabled {\n      background-color: var(--mainColorTint60) !important;\n      border-color: var(--mainColorTint60) !important;\n\n      .p-button-icon {\n        display: none !important;\n      }\n    }\n  }\n}\n\n.p-multiselect {\n  background: transparent !important;\n  border: none !important;\n  border-bottom: 1px solid #ced4da !important;\n  border-radius: 0 !important;\n\n  &:hover {\n    border-bottom: var(--border-size-s) solid var(--secondaryColor) !important;\n  }\n\n  &:not(.p-disabled).p-focus {\n    border-bottom: var(--border-size-s) solid var(--secondaryColor) !important;\n  }\n}\n\n.upload-tabview {\n\n  .p-tabview,\n  .p-tabview-nav,\n  .p-tabview-nav-container,\n  .p-tabview-nav-link,\n  .p-tabview-panels {\n    background: transparent !important;\n  }\n\n  .p-tabview-nav {\n    .p-tabview-title {\n      font-size: 1.375rem !important;\n    }\n\n    &.p-unselectable-text {\n      margin-right: 1rem !important;\n    }\n\n    * {\n      border-radius: 0 !important;\n    }\n  }\n\n  .p-tabview-panels {\n    padding: 0 !important;\n  }\n\n  .p-tabview-nav-link:focus {\n    box-shadow: none !important;\n  }\n}\n\n.p-multiselect:not(.p-disabled).p-focus {\n  box-shadow: none !important;\n}\n\n.ntd {\n  font-family: var(--fontBarlowSemiBold) !important;\n  font-weight: 400 !important;\n  margin: 0 !important;\n  text-decoration: none !important;\n}\n\n.p-multiselect-filter {\n  color: var(--textsAndComponentTitleColor) !important;\n  font-size: var(--font-size-sm) !important;\n  padding: 0rem 0.5rem !important;\n}\n\n.rd-only {\n  border: none !important;\n}\n\n.p-datatable .p-column-filter.p-fluid.p-column-filter-menu>button {\n  margin-left: 0.5rem !important;\n}\n\n.btn-filter-clear {\n  background-color: transparent !important;\n  border: none !important;\n  font-weight: 400 !important;\n  color: var(--mainColor) !important;\n}\n\n.subheadertitle-module_title__nczSu>div {\n  @media screen and (max-width: 30rem) {\n    left: -1.2rem !important;\n  }\n\n  .pr-3 {\n    padding-right: 0.5rem !important;\n  }\n}\n\n.t-subheader-content {\n  @media screen and (max-width: 30rem) {\n    width: 100% !important;\n    margin: 0 !important;\n  }\n}\n\n.boxfull-module_boxFullContainer__9jypm {\n  @media screen and (max-width: 30rem) {\n    margin: 0 0.3rem !important;\n  }\n}\n\n.p-tabview .p-tabview-nav .p-unselectable-text {\n  @media screen and (max-width: 30rem) {\n    margin-right: 1.5rem !important;\n  }\n}\n\n// ************POINTS OF ATTENTION************\n.points__tabdescription {\n  margin-top: var(--space-m);\n}\n\n.points-subtitle {\n  padding: 0 var(--space-base) var(--space-base) !important;\n}\n\n.p-selectbutton {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 1rem !important;\n  padding: 10px;\n\n  .p-focus {\n    outline: none !important;\n  }\n}\n\n.p-selectbutton .p-button.p-highlight {\n  color: gray;\n}\n\n.p-selectbutton .p-button {\n  padding: 1.8rem !important;\n  border-radius: 0.5rem !important;\n  background-color: transparent;\n}\n\n.p-buttonset .p-button {\n  box-shadow: 0 3px 6px var(--shadow) !important;\n}\n\n.p-buttonset .p-button:hover,\n.p-buttonset .p-button:focus,\n.p-buttonset .p-button::after {\n  background-color: transparent !important;\n}\n\n.p-buttonset .p-button:not(:focus) {\n  background-color: transparent !important;\n}\n\n.p-buttonset .p-button:not(:last-child)::after {\n  border: 2px solid var(--borderAndLineColor) !important;\n}\n\n.scrollbar-container {\n  height: 80% !important;\n}\n\n.p-select-card-label {\n  color: var(--textsAndComponentTitleColor) !important;\n  font-family: var(--fontBarlowSemiBold);\n  font-size: 1rem;\n  font-weight: 900 !important;\n}\n\n#SelectScheduleContainer {\n  padding: 2rem 0 !important;\n\n  #deleted-button-selectcard {\n    .p-button-icon.p-c.iu.iu-icon-delete::before {\n      font-size: var(--font-size-tablet-title);\n    }\n  }\n}\n\n.container-treeboxes .treeboxes-child .treeboxes-item {\n  min-height: var(--breakpoint-xs) !important;\n}\n\n.box-hours {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 1rem;\n  padding: 0 1rem;\n}\n\n.schedule-card-selected.p-treenode-selectable {\n  background-color: var(--mainColor) !important;\n  color: var(--cardBackgroundColorOne) !important;\n}\n\n.subheaderactions-module_actions__otXOo .access-button {\n  max-width: 16rem !important;\n}\n\n#uploadNewFiles,\n#downloadTemplate,\n#downloadGeneral {\n  max-width: 12rem !important;\n}\n\n.pointsofattention-fields .upload-wrapper .p-fileupload .p-disabled .p-button-icon {\n  display: none;\n}\n\n.picklist-points {\n  width: 100% !important;\n  display: flex;\n  justify-content: center;\n\n  &--container {\n    max-width: 80rem !important;\n    padding-left: var(--space-xl);\n    padding-right: var(--space-xl);\n    width: 100% !important;\n\n    &__title {\n      padding-left: 4rem;\n    }\n\n    &__component {\n      padding-left: var(--space-base);\n      padding-right: var(--space-base);\n\n      .p-picklist-source-wrapper,\n      .p-picklist-target-wrapper {\n\n        .p-picklist-source,\n        .p-picklist-target {\n          width: 100% !important;\n        }\n      }\n    }\n  }\n}\n\n.schedules-points {\n  width: 100% !important;\n  display: flex;\n  justify-content: center;\n\n  &--container {\n    max-width: 80rem !important;\n    padding-left: var(--space-xl);\n    padding-right: var(--space-xl);\n    width: 100% !important;\n\n    &__title {\n      padding-left: 4rem;\n    }\n  }\n\n  &--fileupload {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n\n    &-container {\n      max-width: 80rem !important;\n      width: 100%;\n\n      .card {\n        padding-left: var(--padding-level-thirty-two);\n        padding-right: var(--padding-level-thirty-two);\n\n        .p-fileupload-content {\n          height: calc(var(--breakpoint-xss) / 2);\n\n          .p-fileupload-files {\n            position: relative;\n            top: -12px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.coordinates_title {\n  margin: var(--space-m) 0 !important;\n  font-size: 1.375rem !important;\n  color: var(--mainColor);\n  font-family: var(--fontDosisSemiBold);\n  font-weight: 400;\n}\n\n.env_title {\n  font-size: 1.375rem !important;\n  color: var(--mainColor);\n  font-family: var(--fontDosisSemiBold);\n  font-weight: 400;\n}\n\n.colors_title,\n.logotype_title {\n  margin: var(--space-m) 2rem !important;\n  font-size: 1.375rem !important;\n  color: var(--mainColor);\n  font-family: var(--fontDosisSemiBold);\n  font-weight: 400;\n}\n\n.info_osp_title {\n  // margin: var(--space-m) 2rem !important;\n  font-size: 1.375rem !important;\n  color: var(--mainColor);\n  font-family: var(--fontDosisSemiBold);\n  font-weight: 400;\n  padding: 0 3rem;\n}\n\n.map {\n  width: 100% !important;\n  height: 100vh !important;\n}\n\n#firstHeadingMap {\n  font-size: var(--font-size-md);\n  font-family: var(--fontBarlowSemiBold);\n  font-weight: 400;\n  margin-bottom: 1rem;\n}\n\n#bodyContentMap {\n  width: 295px;\n  display: flex;\n  justify-content: space-between;\n  margin: 0.5rem 0 !important;\n\n  p {\n    width: 100%;\n    text-align: left;\n    font-size: var(--font-size-sm);\n    font-family: var(--fontBarlowRegular);\n  }\n}\n\n.myBtn {\n  background: transparent;\n  border: transparent;\n  color: #389bab;\n  color: var(--mainColor);\n  padding: 0.5rem 0 0.5rem 0;\n  cursor: pointer;\n  font-size: var(--font-size-md);\n  font-family: var(--fontBarlowSemiBold);\n  font-weight: 400;\n  margin-right: var(--space-m);\n}\n\n.gm-style-iw {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  box-shadow: 0px 3px 6px #CCCCCC80;\n  border: 1px solid #CCCCCC;\n  border-radius: 8px;\n  opacity: 1;\n}\n\n.gm-style-iw-tc {\n  display: none;\n}\n\n.gm-style .gm-style-iw-c {\n  top: 30px;\n  left: 10px;\n}\n\n.create-points-buttons {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  &__button-container {\n    max-width: 80rem;\n    width: 100%;\n\n    .p-button.p-component:last-of-type {\n      margin-right: var(--padding-level-thirty-two);\n    }\n  }\n}\n\n.table-header-title {\n  h3 {\n    font-size: 1.25rem;\n    font-family: var(--fontBarlowSemiBold);\n    color: #333333;\n  }\n}\n\n#phoneId-phone,\n#phoneId- {\n  margin-bottom: 0 !important;\n}\n\n.p-button.p-component.selectButtonColor {\n  background-color: var(--cardBackgroundColorOne) !important;\n}\n\n.p-button.p-component.p-highlight {\n  border: 2px solid var(--mainColor) !important;\n}\n\n.p-breadcrumb ul li.p-disabled .p-menuitem-link .p-menuitem-text {\n  color: var(--mainColor) !important;\n}\n\n#tenant-colorPicker {\n  height: 27px;\n\n  &>input {\n    max-width: 40px !important;\n    border-bottom: none;\n    height: 100%;\n\n    &:hover {\n      cursor: auto;\n    }\n  }\n}\n\n\n#input-primarycolor,\n#input-secondarycolor {\n  width: 16.4rem !important;\n\n  &--edit {\n    width: 14.75rem !important;\n  }\n}\n\n#input-tenant-id,\n#input-tenant-name,\n#input-tenant-alias,\n#input-tenant-shortname,\n#input-tenant-tenantcode {\n  width: 20.4rem !important;\n\n  &--edit {\n    width: 14.75rem !important;\n  }\n}\n\n#dropdown-tenant-status,\n#dropdown-tenant-parentid {\n  width: 20.4rem !important;\n\n  &--edit {\n    width: 14.75rem !important;\n  }\n}\n\n.input-tenant {\n  .block {\n    margin: 0 0.25rem 0.5rem 0 !important;\n  }\n}\n\n.section_edit_app_env {\n\n  .subheaderactions-module_actions__otXOo,\n  .boxfull-module_boxFullContainer__9jypm {\n    margin: 0 0 !important;\n  }\n}\n\n.tenant-tooltip {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 0.5rem;\n}\n\n#overlay_panel {\n  transform: translate(0, 10px) !important;\n\n  .p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link span.p-panelmenu-icon:first-child {\n    color: var(--labelsAndTextColor);\n  }\n\n  .change-lang-link {\n    cursor: pointer;\n    padding: 0.5rem var(--padding-level-twenty-four);\n\n    p {\n      padding: 0 !important;\n    }\n\n    &:hover {\n      background-color: rgb(232, 232, 232);\n    }\n  }\n}\n\n.p-divider-vertical::before {\n  border-left-color: var(--dividerColor) !important;\n}\n\n.p-invalid {\n  color: var(--errorColor) !important;\n}\n\n.style-calendar {\n  button {\n    margin-left: -49px !important;\n  }\n}\n\n// Oculta el badge de ordenación de la tabla de roles\n.roles-management-boxfull {\n  .p-datatable .p-sortable-column .p-sortable-column-badge {\n    display: none;\n  }\n\n  .p-datatable .p-sortable-column.p-highlight {\n    background-color: var(--backgroundColor);\n  }\n}\n\n.text-area-scroll {\n  overflow-y: auto !important;\n  height: 89px !important;\n}\n\n.app-card-selected.p-treenode-selectable {\n  background-color: var(--mainColor) !important;\n  color: var(--cardBackgroundColorOne) !important;\n}\n\n#SelectAppContainer {\n  padding: 2rem 0 !important;\n\n  .scrollbar-container {\n    height: 100% !important;\n\n    .p-panelmenu-icon.pi.pi-chevron-right::before {\n      content: \"\\e90d\" !important;\n    }\n\n    .segments-items .p-panelmenu .p-panelmenu-header>a .p-panelmenu-icon.pi.pi-chevron-down:before {\n      content: \"\\e90e\" !important;\n    }\n  }\n}\n\n.tag-tenant-name {\n  position: absolute;\n  margin-top: 4px;\n  margin-left: 17px;\n  color: black;\n  width: max-content;\n  text-transform: none;\n}\n\n.select-tenant .p-treeselect-items-wrapper .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {\n  color: inherit;\n  display: flex;\n}\n\n.select-tenant .p-treeselect-items-wrapper .p-tree {\n  width: 100%;\n}\n\n.select-tenant .p-treeselect-items-wrapper .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:focus {\n  box-shadow: none;\n  background-color: transparent;\n}\n\n.select-tenant .p-treeselect-items-wrapper .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:enabled:hover {\n  background: none;\n  border-color: transparent;\n  color: #343a40;\n}\n\n.select-tenant .p-treeselect-items-wrapper .p-tree .p-tree-container .p-treenode .p-treenode-content {\n  box-shadow: none !important;\n  border-radius: 0px;\n  padding: 0;\n}\n\n.select-tenant .p-treeselect-items-wrapper .p-tree .p-tree-container .p-treenode {\n  max-width: 100%;\n  padding-bottom: 0px;\n}\n\n.select-tenant.p-connected-overlay-enter-done>div.p-treeselect-items-wrapper {\n  border-radius: 0 0 8px 8px;\n}\n\n.select-tenant.p-connected-overlay-enter-done>div.p-treeselect-header {\n  border-radius: 0px;\n}\n\n#input-tenant-parentid {\n  background: none;\n  border-radius: var(--border-radius-none);\n  border: var(--border-size-none);\n  border-bottom: var(--border-size-s) solid var(--borderAndLineColor);\n  padding: var(--padding-level-zero) var(--padding-level-zero) var(--padding-level-eight);\n}\n\n#input-tenant-parentid>div.p-treeselect-label-container>div {\n  padding: 0px;\n}\n\n#input-tenant-parentid:focus,\n#input-tenant-parentid:hover {\n  border-bottom: var(--border-size-s) solid var(--secondaryColor);\n}\n\n\n#location-points {\n  .fields-box {\n    width: 100% !important;\n\n    div {\n      align-items: flex-start !important;\n    }\n  }\n}\n\n#input-tenant-parent-read-only {\n  border-bottom: none\n}\n\n.tooltip-inputtexttenantcode,\n.tooltip-inputtextparentid {\n  margin-top: -9px;\n  margin-left: 0px !important;\n\n}\n\n.tooltip-inputtextparentid i.icon-tooltip-icon,\n.tooltip-dropdownparentid i.icon-tooltip-icon {\n  font-size: 1rem !important;\n}\n\n\n.app-selector-subtitle {\n  font-family: var(--fontDosisSemiBold), sans-serif;\n  color: var(--mainColor);\n  font-size: 1.375rem;\n  margin-bottom: 1rem;\n}\n\n.settings-container {\n  display: flex;\n  flex-direction: column;\n\n  .title {\n    font-family: var(--fontDosisSemiBold) !important;\n    color: var(--mainColor) !important;\n    font-size: 1.375rem !important;\n    margin-bottom: 1.5rem !important;\n    align-self: flex-start;\n    text-transform: uppercase;\n    padding-top: 0;\n\n    &:hover {\n      cursor: auto;\n    }\n  }\n\n  .card-container {\n    display: flex;\n    gap: 2rem;\n    justify-content: center;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    width: 100%;\n    padding: 1rem 1.5rem;\n    /* UI Properties */\n    background: #ffffff 0% 0% no-repeat padding-box;\n    box-shadow: 0px 3px 6px #cccccc80;\n    border-radius: 8px;\n    opacity: 1;\n\n    .card-content {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      text-decoration: none;\n\n      .access-button.p-button-vertical {\n        max-width: 6.1rem !important;\n\n        .p-button-label.p-c {\n          width: 100px !important;\n        }\n      }\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.last-changes-container {\n  .title {\n    font-family: var(--fontDosisSemiBold) !important;\n    color: var(--mainColor) !important;\n    font-size: 1.375rem !important;\n    margin-bottom: 1.5rem !important;\n    text-transform: uppercase;\n    padding-top: 0;\n\n    &:hover {\n      cursor: auto;\n    }\n  }\n\n  .table-container {\n    width: 100%;\n    background-color: var(--cardBackgroundColorOne) !important;\n    border: 1px solid #CCCCCC;\n    border-radius: 8px;\n\n    .p-datatable-thead {\n      tr {\n        th {\n          background-color: var(--cardBackgroundColorOne) !important;\n          padding: 1.5rem 0.5rem !important;\n\n          .p-column-header-content {\n            font-family: var(--fontBarlowSemiBold) !important;\n            color: var(--labelsAndTextColor);\n          }\n        }\n      }\n    }\n  }\n\n}\n\n\n#overlay_panel {\n  .p-overlaypanel-content {\n    padding-left: 0;\n    padding-right: 0;\n\n    div {\n\n      &>h2,\n      p,\n      button {\n        padding-left: var(--padding-level-twenty-four);\n        padding-right: var(--padding-level-twenty-four);\n        color: #333;\n      }\n\n      .p-divider {\n        width: calc(100% - var(--padding-level-forty-eight));\n        margin-left: var(--padding-level-twenty-four);\n      }\n    }\n\n    .overlay-language-box {\n      &>div:first-of-type {\n        color: var(--cardBackgroundColorOneShade80);\n        padding-left: var(--padding-level-twenty-four);\n        padding-right: var(--padding-level-twenty-four);\n      }\n\n      .overlay-language-box__lang-selector-title {\n        padding-left: 0;\n        font-family: var(--fontBarlowSemiBold);\n        font-size: var(--font-size-xl);\n      }\n\n      .p-divider {\n        width: calc(100% - var(--padding-level-forty-eight));\n        margin-left: var(--padding-level-twenty-four);\n      }\n\n      .p-panelmenu .p-panelmenu-header>a {\n        padding: 1rem;\n        margin-top: 0px;\n        // margin-bottom: 1rem;\n      }\n\n      .p-panelmenu-panel {\n        background-color: var(--mainColorShade10);\n\n        &.lang-item {\n          background-color: var(--cardBackgroundColorOne);\n          margin-bottom: 0px;\n\n          a {\n            background-color: var(--cardBackgroundColorOne);\n            padding-left: var(--padding-level-twenty-four);\n            padding-right: var(--padding-level-twenty-four);\n            border-radius: 0;\n\n            &:hover {\n              background-color: rgb(232, 232, 232) !important;\n            }\n\n            span {\n              color: var(--cardBackgroundColorOneShade80);\n              flex: none !important;\n            }\n          }\n        }\n      }\n    }\n\n  }\n}\n\nbody:has(.overlaypanel-demo) {\n  .profile-container.p-myprofile {\n    background-color: var(--mainColorShade30);\n    box-shadow: 0 0 0 8px var(--mainColorShade30);\n  }\n}\n\nbody:has(#overlay_panel_role_selector) {\n  .role-selector-container {\n    background-color: var(--mainColorShade30);\n    box-shadow: 0 0 0 13px var(--mainColorShade30);\n  }\n}\n\n.client-list-main {\n  .title {\n    max-width: 100% !important;\n    margin: 0 128px !important;\n    font-family: var(--fontDosisSemiBold) !important;\n    color: var(--mainColor) !important;\n    font-size: 1.375rem !important;\n    margin-bottom: 1rem !important;\n    align-self: flex-start;\n    text-transform: uppercase;\n    padding-top: 0;\n\n    &:hover {\n      cursor: auto;\n    }\n  }\n\n  .client-list-container {\n    background-color: var(--cardBackgroundColorTwo) !important;\n    padding: 2rem 0;\n\n    .client-list-content {\n      max-width: 100% !important;\n      margin: 0 128px !important;\n\n      .client-list-box {\n        display: flex;\n\n        .card-content-divider {\n          width: 0;\n          height: 139px;\n          border: 0.9px solid #707070;\n          opacity: 1;\n          margin: 0 1rem;\n        }\n      }\n\n      .client-list-actions {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        column-gap: 2rem;\n        margin-bottom: 1rem;\n\n        .subheaderactions-module_actions__otXOo {\n          margin: 0 !important;\n          padding: 0 !important;\n        }\n\n        .p-togglebutton.p-button {\n          border-radius: 0.5rem;\n          min-width: 0;\n        }\n      }\n\n      .swiper {\n        padding: 0 0 0.5rem;\n        margin-left: 0;\n\n        .swiper-pagination {\n          .swiper-pagination-bullet.swiper-pagination-bullet-active {\n            width: 1.5rem !important;\n            background-color: var(--mainColor) !important;\n            border-radius: 0.25rem !important;\n          }\n        }\n      }\n\n      .swiper-wrapper {\n        width: 100% !important;\n\n        .swiper-slide {\n          display: flex;\n          width: 168px !important;\n          height: 139px !important;\n          margin-right: 1.5rem !important;\n\n          .card-content {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            cursor: pointer;\n\n            img {\n              width: 48px !important;\n              height: 48px !important;\n            }\n\n            .p-card-content {\n              display: flex;\n              flex-direction: column;\n              align-items: center;\n              gap: 0.5rem;\n\n              .card-title {\n                text-align: center;\n                color: #333;\n\n                &:hover {\n                  cursor: pointer;\n                  text-decoration: underline;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .card-content-c {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: 1.5rem;\n\n        a {\n          text-decoration: none;\n        }\n\n        .card-content {\n          width: 168px;\n          height: 139px;\n          cursor: pointer;\n\n          .p-card-content {\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            gap: 0.5rem;\n\n            .card-icon {\n              display: flex;\n              justify-content: center;\n              color: var(--secondaryColor);\n\n              i {\n                font-size: 2.5rem !important;\n              }\n            }\n\n            .card-title {\n              text-align: center;\n\n              &:hover {\n                cursor: pointer;\n                text-decoration: underline;\n              }\n            }\n\n            img {\n              width: 48px !important;\n              height: 48px !important;\n            }\n          }\n\n          .p-card-body {\n            padding: 1rem 1.5rem;\n            height: 100%;\n          }\n        }\n      }\n\n      .card-content-app {\n        .p-card-body {\n          width: 168px;\n          height: 139px;\n          padding: 1rem;\n        }\n\n        .card-content {\n          width: 168px;\n          cursor: pointer;\n\n          .p-card-content {\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            gap: 0.5rem;\n\n            .card-title {\n              text-align: center;\n              color: #333;\n\n              &:hover {\n                cursor: pointer;\n                text-decoration: underline;\n              }\n            }\n\n            img {\n              width: 48px !important;\n              height: 48px !important;\n            }\n          }\n\n          .p-card {\n            padding: 1rem 1.5rem;\n            height: 100%;\n          }\n        }\n      }\n    }\n  }\n}\n\n.base-role-list-container {\n  .subheaderactions-module_actions__otXOo {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  .title {\n    font-family: var(--fontDosisSemiBold) !important;\n    color: var(--mainColor) !important;\n    font-size: 1.375rem !important;\n    margin-bottom: 1rem !important;\n    text-transform: uppercase;\n    padding-top: 0;\n\n    &:hover {\n      cursor: auto;\n    }\n  }\n\n  .role-list {\n    // width: 480px;\n    height: 93px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    background-color: var(--cardBackgroundColorOne) !important;\n    border: 1px solid #CCCCCC;\n    border-radius: 8px;\n    padding: 1rem;\n    margin-top: 1rem;\n    cursor: pointer;\n\n    .role-title {\n      color: #333;\n      font-family: var(--fontBarlowSemiBold) !important;\n    }\n\n    .role-subtitle {\n      font-family: var(--fontDosis) !important;\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      font-size: 0.875rem;\n      color: #333;\n    }\n\n    .role-status {\n      flex-direction: column;\n      justify-content: flex-start;\n    }\n  }\n\n  .see-more {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  #see-more-icon::before {\n    content: \"\\e90b\";\n  }\n}\n\n#iconname-icon::before {\n  content: \"\\e90b\";\n  font-size: 1.5rem !important;\n  color: var(--text-color-333333);\n}\n\n.config-grid-3 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(200px, 1fr));\n  column-gap: 4rem;\n  row-gap: 2.5rem;\n  box-sizing: border-box;\n  margin: 2.5rem 0 1.5rem;\n\n  .settings-container {\n    grid-column: 2/3;\n    grid-row: 1/2;\n  }\n\n\n  .base-role-list-container {\n    grid-column: 1/1;\n    grid-row: 1/3;\n  }\n\n\n  .last-changes-container {\n    grid-column: 2/3;\n    grid-row: 2/3;\n  }\n}\n\n.config-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(200px, 1fr));\n  column-gap: 5rem;\n  row-gap: 2.5rem;\n  box-sizing: border-box;\n  margin: 2.5rem 0 1.5rem;\n\n  .base-role-list-container {\n    grid-column: 1/2;\n    grid-row: 1/3;\n  }\n\n  .last-changes-container {\n    grid-column: 2/3;\n    grid-row: 1/2;\n  }\n}\n\n.config-grid-1 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(200px, 1fr));\n  column-gap: 5rem;\n  row-gap: 2.5rem;\n  box-sizing: border-box;\n  margin: 2.5rem 0 1.5rem;\n}\n\n.config-grid-dash {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(200px, 1fr));\n  column-gap: 5rem;\n  row-gap: 2.5rem;\n  box-sizing: border-box;\n  margin: 2.5rem 0;\n}\n\n.texts-messages-container {\n  display: flex;\n  flex-direction: column;\n\n  .title {\n    font-family: var(--fontDosisSemiBold) !important;\n    color: var(--mainColor) !important;\n    font-size: 1.375rem !important;\n    margin-bottom: 1.5rem !important;\n    align-self: flex-start;\n    text-transform: uppercase;\n    padding-top: 0;\n\n    &:hover {\n      cursor: auto;\n    }\n  }\n\n  .card-container {\n    display: flex;\n    gap: 1rem;\n    justify-content: space-around;\n    align-items: center;\n    flex-wrap: wrap;\n    width: 100%;\n    padding: 1rem 1.5rem;\n    /* UI Properties */\n    background: #ffffff 0% 0% no-repeat padding-box;\n    box-shadow: 0px 3px 6px #cccccc80;\n    border-radius: 8px;\n    opacity: 1;\n\n    .card-content {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n\n      .access-button.p-button-vertical {\n        max-width: 6.1rem !important;\n\n        .p-button-label.p-c {\n          width: 100px !important;\n        }\n      }\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n\n    .card-content-divider {\n      width: 0px;\n      height: 55px;\n      border: 1px solid #B2B2B2;\n      opacity: 1;\n    }\n\n\n    .card-content-btn {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      border-left: #333333;\n\n      .access-button.p-button-vertical {\n        max-width: 100% !important;\n\n        .p-button-label.p-c {\n          width: 150px !important;\n        }\n      }\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.digital-channel-container {\n  display: flex;\n  flex-direction: column;\n\n  .title {\n    font-family: var(--fontDosisSemiBold) !important;\n    color: var(--mainColor) !important;\n    font-size: 1.375rem !important;\n    margin-bottom: 1.5rem !important;\n    align-self: flex-start;\n    text-transform: uppercase;\n    padding-top: 0;\n\n    &:hover {\n      cursor: auto;\n    }\n  }\n\n  .card-container {\n    display: flex;\n    justify-content: center;\n    gap: 1rem 1.75rem;\n    flex-wrap: wrap;\n\n    .card-content {\n      width: 180px;\n      height: 110px;\n      background: #FFFFFF 0% 0% no-repeat padding-box;\n      border: 1px solid #CCCCCC;\n      border-radius: 16px;\n      opacity: 1;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      cursor: pointer;\n      padding: 1.5rem 2.5rem;\n\n      .card-title {\n        text-align: center;\n        font-family: var(--fontBarlowRegular) !important;\n        color: #333;\n        font-size: 0.875rem !important;\n      }\n\n      .card-value {\n        text-align: center;\n        font-family: var(--fontBarlowSemiBold) !important;\n        color: #333;\n        font-size: 1.25rem !important;\n        margin-top: 0.25rem;\n      }\n    }\n\n\n    .card-content:last-child {\n      background-color: transparent;\n      // box-shadow: 0px 3px 6px #CCCCCC80;\n      border: 1px dashed #999999;\n      border-radius: 16px;\n      opacity: 1;\n\n      .card-value {\n        text-align: center;\n        font-family: var(--fontBarlowRegular) !important;\n        color: var(--text-color-333333);\n        font-size: 0.875rem !important;\n      }\n    }\n  }\n}\n\n.config-grid-dash-menu {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(200px, 1fr));\n  column-gap: 5rem;\n  row-gap: 2.5rem;\n  box-sizing: border-box;\n  margin: 2.5rem 0;\n\n  .digital-channel-container {\n    grid-column: 1/2;\n    grid-row: 2/3;\n  }\n\n  .settings-container {\n    grid-column: 2/3;\n    grid-row: 1/2;\n  }\n\n  .texts-messages-container {\n    grid-column: 1/2;\n    grid-row: 1/2;\n  }\n\n\n  .last-changes-container {\n    grid-column: 2/3;\n    grid-row: 2/2;\n  }\n}\n\n.config-grid-dash-menu-3 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(200px, 1fr));\n  column-gap: 5rem;\n  row-gap: 2.5rem;\n  box-sizing: border-box;\n  margin: 2.5rem 0;\n\n  .digital-channel-container {\n    grid-column: 1/2;\n    grid-row: 2/3;\n  }\n\n  .texts-messages-container {\n    grid-column: 1/2;\n    grid-row: 1/2;\n  }\n\n  .last-changes-container {\n    grid-column: 2/3;\n    grid-row: 1/3;\n  }\n}\n\n.config-grid-dash-menu-2 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(200px, 1fr));\n  column-gap: 5rem;\n  row-gap: 2.5rem;\n  box-sizing: border-box;\n  margin: 2.5rem 0;\n\n  .digital-channel-container {\n    grid-column: 2/3;\n    grid-row: 1/2;\n  }\n\n  .texts-messages-container {\n    grid-column: 1/2;\n    grid-row: 1/2;\n  }\n}\n\n.p-breadcrumb {\n  .p-menuitem-text {\n    font-family: inherit !important;\n  }\n}\n\n// FLECHAS DEL MENU UP & DOWN\n.p-panelmenu .p-panelmenu-content .p-menuitem .p-menuitem-link .p-panelmenu-icon.pi.pi-fw {\n  &.pi-angle-right:before {\n    content: \"\\e90d\" !important;\n  }\n\n  &.pi-angle-down:before {\n    content: \"\\e90e\" !important;\n  }\n}\n\n.environment-messages-alert {\n  border-radius: 0 0 8px 8px;\n\n  .p-message {\n    background-color: var(--warningColor);\n    width: 100vw;\n    max-width: none;\n    margin-top: auto;\n    position: relative;\n    margin-bottom: 0;\n    border-width: 0;\n    border-radius: 0 0 8px 8px;\n\n    .p-message-wrapper {\n      min-height: auto;\n      padding-top: 6px;\n      padding-bottom: 6px;\n\n      .p-message-icon {\n        height: 40px;\n        margin-bottom: 15px;\n\n        &::before {\n          font-size: 40px;\n          color: var(--cardBackgroundColorOneShade80);\n        }\n      }\n\n      .p-message-detail {\n        color: var(--cardBackgroundColorOneShade80);\n      }\n    }\n  }\n}\n\n.segments-items {\n  .p-panelmenu {\n    .p-panelmenu-panel {\n      border-radius: 0.5rem !important;\n      margin: 0 2rem 1rem !important;\n      background: transparent !important;\n\n      .p-panelmenu-content {\n        background: transparent !important;\n\n        .p-menuitem .p-menuitem-link {\n          background-color: var(--cardBackgroundColorOne);\n          box-shadow: 0 3px 6px var(--shadow);\n          padding: 0.65rem !important;\n          margin-top: 10px;\n          border-radius: 0.5rem !important;\n          color: var(--textsAndComponentTitleColor);\n\n          &:hover {\n            background-color: var(--cardBackgroundColorOne);\n          }\n\n          .p-menuitem-text {\n            color: #333;\n          }\n        }\n      }\n\n      .p-menuitem-text {\n        padding: 0.1rem 0 !important;\n      }\n\n      .p-component.p-panelmenu-header {\n\n        a.p-panelmenu-header-link,\n        a.p-panelmenu-header-link,\n        a.p-panelmenu-header-link {\n          padding: 0.65rem 1rem !important;\n        }\n      }\n    }\n\n    .p-panelmenu-panel:not(:first-child) .p-panelmenu-header>a {\n      border-radius: 8px;\n    }\n\n    .p-panelmenu-header>a {\n      background-color: var(--cardBackgroundColorOne) !important;\n      color: #333;\n\n      &:hover {\n        background-color: var(--cardBackgroundColorOne) !important;\n        color: #333 !important;\n      }\n    }\n\n    .p-panelmenu-header>a .p-panelmenu-icon.pi.pi-chevron-right:before {\n      content: \"\\e90e\" !important;\n    }\n\n    .p-panelmenu-header>a .p-panelmenu-icon.pi.pi-chevron-down:before {\n      content: \"\\e90f\" !important;\n    }\n  }\n}\n\n.segment-item-selected {\n  .p-menuitem-link {\n    background-color: var(--mainColor) !important;\n\n    .p-menuitem-text {\n      color: var(--cardBackgroundColorOne) !important;\n    }\n  }\n}\n\n.segment-item-main-selected {\n  .p-component.p-panelmenu-header.p-highlight {\n\n    a.p-panelmenu-header-link,\n    a.p-panelmenu-header-link,\n    a.p-panelmenu-header-link {\n      background-color: var(--mainColor) !important;\n      color: var(--cardBackgroundColorOne) !important;\n    }\n  }\n\n  .p-component.p-panelmenu-header {\n\n    a.p-panelmenu-header-link,\n    a.p-panelmenu-header-link,\n    a.p-panelmenu-header-link {\n      background-color: var(--mainColor) !important;\n      color: var(--cardBackgroundColorOne) !important;\n    }\n  }\n\n  .p-toggleable-content {\n    .p-menuitem-link {\n      margin-top: 1rem !important;\n    }\n  }\n}\n\n.segment-item-1 {\n  .p-component.p-panelmenu-header {\n    .p-panelmenu-header-link {\n      .p-panelmenu-icon.pi.pi-chevron-right:before {\n        content: \"\" !important;\n      }\n\n      .p-panelmenu-icon.pi.pi-chevron-down:before {\n        content: \"\" !important;\n      }\n    }\n  }\n}\n\n#icon-close-message {\n  position: relative;\n  right: 72px;\n  align-self: center;\n  font-size: 25px;\n  cursor: pointer;\n}\n\n.main-content {\n  padding-bottom: 73px;\n  min-height: 100vh !important;\n  position: relative;\n\n  .footer-container {\n    width: 100%;\n    height: 73px;\n    background-color: var(--cardBackgroundColorTwo) !important;\n    display: grid;\n    grid-template-columns: repeat(3, minmax(100px, 1fr));\n    // padding: 0 4rem !important;\n    position: absolute;\n    bottom: 0;\n\n    .section-1 {\n      display: flex;\n      grid-column: 2/3;\n      grid-row: 1/2;\n      justify-content: center;\n      align-items: center;\n      column-gap: 2.5rem;\n      width: 100%;\n\n      .custom-link {\n        font-family: var(--fontBarlowBold) !important;\n        font-size: var(--font-size-sm) !important;\n        color: var(--labelsAndTextColor) !important;\n        width: 150px;\n        text-decoration: underline;\n        text-align: center;\n      }\n    }\n\n    .section-2 {\n      display: grid;\n      grid-column: 3/4;\n      grid-row: 1/2;\n      align-content: center;\n      justify-content: flex-end;\n      row-gap: 0.5rem !important;\n\n      div {\n        display: flex;\n        align-items: center;\n        font-family: var(--fontBarlowMedium) !important;\n        font-size: 0.625rem !important;\n        color: var(--labelsAndTextColor) !important;\n\n        img {\n          height: 12px;\n          margin-left: 0.2rem;\n          margin-top: 0.17rem;\n        }\n      }\n    }\n\n    // @media screen and (max-width: 48rem) {\n    //   .section-1 {\n    //     grid-column: 1/4;\n    //     grid-row: 1/2;\n    //     margin-top: 1rem !important;\n    //   }\n\n    //   .section-2 {\n    //     grid-column: 1/4;\n    //     grid-row: 2/3;\n    //     margin-top: 1rem !important;\n    //   }\n    // }\n  }\n}\n\n#SelectAppContainer {\n  width: 100%;\n  position: relative;\n  min-height: 15.75rem !important;\n\n  .envs-items {\n    margin: 0 2rem !important;\n\n    .p-tree {\n      margin: 0 !important;\n      box-sizing: content-box;\n      width: 100%;\n\n      .p-tree-container {\n        width: 100% !important;\n\n        .p-treenode {\n          max-width: none !important;\n\n          .p-treenode-content {\n            min-width: auto !important;\n          }\n        }\n      }\n\n    }\n  }\n}\n\n.client-title {\n  font-family: var(--fontDosisSemiBold);\n  font-size: 1.375rem;\n  color: var(--mainColor);\n  text-transform: uppercase;\n  display: block;\n  padding: 2.5rem 0 0;\n  transition: color 0.5s;\n}\n\n.client-subtitle,\n.selectapp-subtitle {\n  color: #333;\n}\n\n.selectapp-title {\n  margin-top: 2.5rem;\n}\n\n.show-pagination {\n  padding: 0 0 2rem !important;\n}\n\n.skeleton-clients-container {\n  background-color: var(--cardBackgroundColorTwo);\n  height: 250px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 2rem 0;\n\n  .card-actions {\n    max-width: 100%;\n    margin: 0 128px;\n    display: flex;\n    margin-bottom: 1rem;\n\n    .actions {\n      width: 312px;\n      height: 38px;\n      background-color: #fff;\n    }\n  }\n\n  .skeleton {\n    max-width: 100%;\n    margin: 0 128px;\n    display: flex;\n\n    .card-skeleton {\n      width: 168px;\n      height: 139px;\n      margin-right: 1.5rem;\n    }\n  }\n}\n\n.skeleton-menu-container {\n  background-color: var(--cardBackgroundColorTwo);\n  height: 203px;\n  display: flex;\n  align-items: center;\n  padding: 2rem 0;\n  margin-top: 2.5rem;\n\n  .skeleton {\n    width: 100%;\n    margin: 0 128px;\n    display: flex;\n    justify-content: center;\n\n    .card-skeleton {\n      width: 168px;\n      height: 139px;\n      margin-right: 1.5rem;\n    }\n  }\n}\n\n.skeleton-widgets-container {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(200px, 1fr));\n  column-gap: 4rem;\n  row-gap: 2.5rem;\n  box-sizing: border-box;\n  height: 356px;\n  max-width: 100%;\n  margin: 2.5rem 128px 1.5rem;\n\n  .card-1,\n  .card-2 {\n    width: 100%;\n    background-color: var(--cardBackgroundColorTwo);\n    border-radius: 0.5rem;\n  }\n}\n\n.skeleton-items-container {\n  height: 40px;\n  border-radius: 0.5rem;\n  margin: 0 2rem 1rem;\n  background: #fff;\n}\n\n.select-role-description {\n  margin: auto 2rem;\n  text-align: center;\n  font-family: var(--fontBarlowMedium);\n  color: #333;\n}\n\n.p-sidebar-content {\n  .p-panelmenu.p-component {\n    .p-panelmenu-panel {\n      .p-panelmenu-header>a {\n        padding: 0.625rem 1rem;\n      }\n    }\n  }\n}\n\n#labelNewApplication {\n  color: #333;\n  font: 'normal normal normal 16px/24px Barlow';\n  margin-bottom: 1.5rem;\n}\n\n#objetiveApplicationLabel {\n  margin-bottom: 1.5rem;\n}\n\ndiv.wrapper-form-application {\n  margin-left: 2rem;\n\n  .form-container .form {\n    display: flow-root;\n  }\n\n  p.subtitle {\n    margin-top: 2rem;\n    margin-left: 2rem;\n    font-family: var(--fontDosisSemiBold);\n    font-size: 1.375rem;\n    color: var(--mainColor) !important;\n    font-weight: normal;\n    display: inline-flex;\n\n    i {\n      cursor: pointer;\n      margin-left: 10px;\n      font-size: 1.25rem;\n    }\n  }\n\n  .help-name-application {\n    color: var(--mainColor) !important;\n    font-size: 1.5rem;\n  }\n\n  p.text-description-name {\n    color: var(--labelsAndTextColor);\n    font-family: var(--fontBarlowRegular);\n    font-size: 0.875rem;\n    line-height: 1.3125rem;\n  }\n}\n\n#HelpAppNameText {\n  color: #333 !important;\n  line-height: 1.3125rem;\n  font-family: var(--fontBarlowMedium);\n  font-size: 1rem;\n}\n\n.container-buttons-app {\n  margin-right: 0px !important;\n}\n\n#wrapper-applications {\n  padding-left: 3rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.section_edit_app_env {\n  margin-left: 2.375rem;\n}\n\n.wrapper-environment-button {\n  padding-bottom: 1rem;\n}\n\n.description-delete-app {\n  line-height: 1.5rem;\n  font-family: var(--fontBarlowRegular);\n  color: #333;\n}\n\n.description-new-environment {\n  line-height: 1.5rem;\n  font-family: var(--fontBarlowMedium);\n  color: #333;\n}\n\n#input-clonename,\n.input-clone-fields,\n#input-name-env {\n  width: 18.4375rem !important;\n}\n\n\n// INICIO - CAMBIO DEL ICONO DE EXPAND/COLLAPSE DEL MENU LATERAL\n.p-sidebar .p-sidebar-content .p-panelmenu .p-panelmenu-panel .p-panelmenu-header>a .p-panelmenu-icon.pi.pi-chevron-right:before {\n  content: \"\\e90d\" !important;\n  font-size: 0.75rem;\n}\n\n.p-sidebar .p-sidebar-content .p-panelmenu .p-panelmenu-panel .p-panelmenu-header>a .p-panelmenu-icon.pi.pi-chevron-down:before {\n  content: \"\\e90e\" !important;\n  font-size: 0.75rem;\n}\n\n// CIERRE - CAMBIO DEL ICONO DE EXPAND/COLLAPSE DEL MENU LATERAL\n\n// INICIO - AJUSTES DEL PAGINATOR\n.p-paginator .p-paginator-current {\n  margin-left: 0;\n  order: 3;\n  font-family: var(--fontBarlowRegular);\n  font-size: var(--font-size-sm);\n}\n\n.p-dropdown.p-component.p-inputwrapper.p-inputwrapper-filled {\n  order: 2;\n}\n\n.p-paginator-right-content {\n  margin-left: 0;\n  margin-right: 8px;\n  order: 1;\n  font-family: var(--fontBarlowRegular);\n  font-size: var(--font-size-sm);\n}\n\n// CIERRE - AJUSTES DEL PAGINATOR\n\n.user-title-info {\n  margin-left: 4rem;\n\n  .title {\n    font-family: var(--fontDosisSemiBold) !important;\n    color: var(--mainColor) !important;\n    font-size: 1.375rem !important;\n    align-self: flex-start;\n    text-transform: uppercase;\n    padding-top: 0;\n  }\n}\n\n.tenant-accordions {\n  .p-resizable-column.p-align-left:first-child {\n    max-width: 65px !important;\n  }\n\n  .p-selectable-row {\n    .p-align-left:first-child {\n      max-width: 65px !important;\n    }\n  }\n\n  .p-accordion-content {\n    .p-datatable {\n      padding: 1.5rem !important;\n    }\n  }\n\n  #iconColumns {\n    display: none;\n  }\n}\n\n.application-roles-table {\n  .application-roles-title {\n    margin-bottom: 1rem !important;\n    font-family: var(--fontBarlowSemiBold);\n    font-size: var(--font-size-md);\n    color: #333;\n  }\n\n  .boxfull-module_content__8-IMh.boxfull-module_primary__eCXMZ {\n    margin: 0 0 !important;\n    padding: 0 0 !important;\n\n    .p-datatable {\n      padding: 0 !important;\n      padding-left: 1.5rem !important;\n    }\n  }\n\n  .p-datatable-header {\n    display: none;\n  }\n\n  .p-selectable-row {\n    .p-editable-column.p-align-left {\n      .p-row-editor-init.p-link {\n        position: absolute;\n        left: 1040px !important;\n        color: var(--warningColor);\n        border: 1px solid;\n        border-radius: 2rem;\n        background-color: transparent;\n        width: 1.75rem;\n        height: 1.75rem;\n      }\n    }\n\n    // Agregar posicion a los botones de save y cancel al editar una fila\n    .p-editable-column.p-cell-editing.p-align-left {\n      .p-row-editor-save.p-link {\n        position: absolute;\n        left: 1000px !important;\n        background-color: var(--cardBackgroundColorOne);\n        color: var(--successColor);\n        border: 1px solid;\n        border-radius: 2rem;\n        width: 1.75rem;\n        height: 1.75rem;\n      }\n\n      .p-row-editor-cancel.p-link {\n        position: absolute;\n        left: 1040px !important;\n        background-color: var(--cardBackgroundColorOne);\n        color: var(--errorColor);\n        border: 1px solid;\n        border-radius: 2rem;\n        width: 1.75rem;\n        height: 1.75rem;\n      }\n    }\n  }\n}\n\n.roles-row-disabled {\n  .p-datatable-thead {\n    tr {\n      th:first-child {\n        cursor: default !important;\n        pointer-events: none !important;\n        opacity: 0.6;\n      }\n    }\n  }\n}\n\n.management-roles-table {\n  .p-selectable-row {\n    .p-editable-column.p-align-left {\n      .p-row-editor-init.p-link {\n        position: absolute;\n        left: 1110px !important;\n        color: var(--warningColor);\n        border: 1px solid;\n        border-radius: 2rem;\n        background-color: transparent;\n        width: 1.75rem;\n        height: 1.75rem;\n      }\n    }\n\n    // Agregar posicion a los botones de save y cancel al editar una fila\n    .p-editable-column.p-cell-editing.p-align-left {\n      .p-row-editor-save.p-link {\n        position: absolute;\n        left: 1070px !important;\n        background-color: var(--cardBackgroundColorOne);\n        color: var(--successColor);\n        border: 1px solid;\n        border-radius: 2rem;\n        width: 1.75rem;\n        height: 1.75rem;\n      }\n\n      .p-row-editor-cancel.p-link {\n        position: absolute;\n        left: 1110px !important;\n        background-color: var(--cardBackgroundColorOne);\n        color: var(--errorColor);\n        border: 1px solid;\n        border-radius: 2rem;\n        width: 1.75rem;\n        height: 1.75rem;\n      }\n    }\n  }\n}\n\nstrong {\n  font-family: var(--fontBarlowSemiBold);\n}\n\n.p-toast-detail {\n  word-break: break-word;\n}\n\n.p-inputtext.p-component.block.p-invalid.p-invalid-delete {\n  margin-top: 0.5rem !important;\n}\n\n.p-multiselect-panel.p-component.p-connected-overlay-enter-done {\n  height: 265px;\n  z-index: 1999 !important;\n}\n\n// Ajuste textos de columna Tabla Roles\n.roles-column.p-align-left,\n.general-content-column.p-align-left {\n  div:first-child:not(.p-column-header-content) {\n    display: -webkit-box;\n    line-clamp: 2;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n// Estilos para las funciones generadoras de props por default\n// para Tablas y Columnas. !IMPORTANT. DO NOT REMOVE!\n.basic-table-style {\n  .p-datatable-tbody > tr > td {\n    background: none !important;\n  }\n  .basic-table-row-background {\n    background-color: var(--backgroundColor) !important;\n  }\n\n  .datatable-original-background {\n    background-color: var(--cardBackgroundColorOne) !important;\n  }\n}\n\n.p-datatable-tbody > tr > .general-actions-column {\n  .general-actions-datatable {\n    background: var(--cardBackgroundColorOne);\n    box-shadow: var(--cardBackgroundColorOne) 0px 0px 0px 500px;\n  }\n}\n\n.p-row-editor-init {\n  color: var(--warningColor) !important;\n  background-color: transparent !important;\n  border: 1px solid !important;\n}\n\n.p-row-editor-init-icon:before {\n  content: \\e936 !important;\n}\n\n\n.p-row-editor-save {\n  color: var(--successColor) !important;\n  background-color: transparent !important;\n  border: 1px solid !important;\n}\n\n.p-row-editor-cancel {\n  color: var(--errorColor) !important;\n  background-color: transparent !important;\n  border: 1px solid !important;\n}\n\n.wrapper-title-new-user,\n.wrapper-form {\n  margin: 0px !important\n}\n\n// CLASE PARA LOS ICONOS DE LOS TOOLTIPS DEL DROPDOWN\n// DE LA FUNCIONALIDAD TEXTOS Y MENSAJES FRONT\n.tooltip-dropdown-styles::before {\n  font-size: var(--font-size-md);\n  color: var(--successColor);\n}\n\n// Oculta la barra de scroll del toggleColumn\n#overlay_panel_datatable::-webkit-scrollbar {\n  display: none;\n}\n\n// Readonly styles in InputTextarea of Texts and Messages Pages\n#input-label-esvalue-readonly:hover,\n#input-label-esvalue-readonly:enabled:focus,\n#input-label-envalue-readonly:hover,\n#input-label-envalue-readonly:enabled:focus {\n      border-color: var(--borderAndLineColor);\n}\n\n// Permite customizar zIndex de las modales de creación de Labels\n// para evitar invisibilidad de los multiselects y dropdowns\ndiv:has(.overlay-createlabelsbutton) {\n  z-index: 1001 !important;\n}\n\ndiv.tableroles > div.p-datatable-wrapper > table > thead > tr > th:nth-child(1){\n  display: none;\n}\n\n#validate-labels-table {\n  margin: 0 !important;\n  width: 100% !important;\n}\n\n.tenant-accordions {\n  .p-accordion:not(:first-of-type) {\n    padding-left: var(--padding-level-forty);\n  }\n}\n\n#align-box-empty-template {\n  width: 100% !important;\n}\n\n#permissions-customformcomponent,\n#functionalities-customformcomponent,\n#agents-customformcomponent {\n  margin: 0 128px !important;\n}\n\n// Corrección márgenes laterales de páginas\n#margin-fixed-bgscreen {\n  margin: 0 128px;\n  .boxfull-module_boxFullContainer__9jypm {\n    margin: 0 !important;\n    // Caso especial boxfull_module dentro de boxfull_module\n    .boxfull-module_boxFullContainer__9jypm {\n      margin: 0 128px !important;\n    }\n  }\n}\n\n// Posición del icono de copy to clipboard EditAdminApp\n#copy-button-admin-add {\n  transform: translate(0,-15px);\n}\n\n// Reporte de auditoría\n.audit-report-multiselect-class .p-multiselect-label-container {\n  .p-multiselect-label {\n    padding-left: 0px;\n  }\n}",".second-box {\n    &__personal-data {\n        margin-top: 1rem;\n        font-family: var(--fontDosisSemiBold);\n        font-size: var(--font-size-desktop-subtitle);\n        color: var(--mainColor);\n    }\n\n    &__location-data {\n        margin-top: 1rem;\n        font-family: var(--fontDosisSemiBold);\n        font-size: var(--font-size-desktop-subtitle);\n        color: var(--mainColor);\n    }\n\n    .dt-appr-c {\n        justify-content: flex-start;\n\n        .dt-ap-col {\n            width: 50%;\n        }\n    }\n}\n\n.boxTitle {\n    margin-bottom: var(--padding-level-sixteen);\n    font-family: var(--fontDosisSemiBold);\n    font-size: var(--font-size-desktop-subtitle);\n    color: var(--mainColor);\n}\n\n.custom-form-box-container,\n.picklist-points--container__title,\n.schedules-points--container__title,\n.picklist-points--view__title {\n    .boxTitle {\n        margin-bottom: 0px;\n    }\n}",".sk-appr-c {\n  padding: 0 10%;\n  margin-bottom: 1rem !important;\n}\n\n.dt-appr-c {\n  align-items: flex-start;\n  display: flex;\n  justify-content: center;\n  padding: 1.5rem 3rem;\n  gap: 4rem;\n\n  .dt-ap-col {\n    align-items: flex-start;\n    display: flex;\n    flex-direction: column;\n\n    .dt-ap-item {\n      align-items: center;\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-start;\n      margin-bottom: 2rem;\n\n      &:last-of-type {\n        margin-bottom: 0;\n      }\n\n      .item-title {\n        align-self: flex-start;\n        color: var(--labelsAndTextColor);\n        font-family: var(--fontBarlowRegular);\n        font-size: var(--font-size-sm);\n        margin-bottom: 0.5rem;\n      }\n\n      .item-value {\n        align-self: flex-start;\n        color: var(--textsAndComponentTitleColor);\n        font-family: var(--fontBarlowMedium);\n        font-size: var(--font-size-md);\n      }\n    }\n  }\n}\n\n.flow-badge {\n  background: var(--cardBackgroundColorTwo) 0% 0% no-repeat padding-box !important;\n  border-radius: 0.25rem !important;\n  display: inline-block;\n  padding: 0.5rem !important;\n  width: fit-content;\n  background: var(--cardBackgroundColorTwo);\n  border-radius: 4px;\n  font-size: 0.875rem;\n  font-weight: 700;\n  padding: 0.25rem 0.5rem;\n  height: auto;\n  font-family: var(--fontBarlowBold);\n\n  &.ACTIVE {\n    color: var(--successColor) !important;\n  }\n\n  &.INACTIVE {\n    color: var(--errorColor) !important;\n  }\n\n  &.true {\n    color: var(--successColor) !important;\n  }\n\n  &.false {\n    color: var(--errorColor) !important;\n  }\n}\n",".confirmdialog-cancel {\n  &.p-confirm-dialog {\n    max-width: 25rem;\n    width: 25rem;\n    height: auto;\n\n    .p-dialog-content {\n      text-align: left;\n      overflow-x: hidden !important;\n\n      &::-webkit-scrollbar {\n        width: 0.5rem !important;\n      }\n\n      &::-webkit-scrollbar-track {\n        box-shadow: inset 0 0 5px grey !important;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: grey !important;\n      }\n    }\n\n    .p-dialog-footer {\n      display: flex;\n      justify-content: flex-end;\n      flex-wrap: nowrap;\n      flex-direction: row;\n      align-items: flex-end;\n      padding: 1.375rem;\n\n      .p-button-label {\n        display: inline-block !important;\n        width: fit-content !important;\n      }\n\n      .p-button {\n        padding: 1rem 2rem;\n      }\n    }\n  }\n}\n\n.trx-m-f {\n  background-color: white;\n  .p-dialog-content { \n    overflow-x: hidden !important;\n    margin-right: 0.5rem !important;\n  \n    &::-webkit-scrollbar {\n      width: 0.5rem !important;\n    }\n  \n    &::-webkit-scrollbar-track {\n      box-shadow: inset 0 0 3px grey !important;\n    }\n  \n    &::-webkit-scrollbar-thumb {\n      background: grey !important;\n    }\n  } \n}\n\n.dialog-form {\n  background-color: #ffffff;\n  overflow: hidden !important;\n\n  .p-dialog-content {\n    margin-right: 0.5rem !important;\n    overflow-x: hidden !important;\n  }\n}\n\n#im-type-dropdown {\n  z-index: 2000 !important;\n}\n\n.inactivity-reject-button {\n  visibility: hidden;\n}\n\n.p-dialog-mask.body-mask-black {\n  background: black !important;\n}",".app-item {\n  align-items: center;\n  border-bottom: 1px solid var(--cardBackgroundColorOneShade10);\n  cursor: pointer;\n  display: flex;\n  font-size: var(--font-size-lg);\n  padding: 1.5rem 2rem;\n  transition: background-color 0.3s ease-in;\n\n  &:last-of-type {\n    border-bottom: none;\n  }\n\n  &:hover {\n    background-color: rgb(231, 231, 231);\n  }\n}\n\n.pt {\n  padding-top: 0.5rem !important;\n}\n\n.st-btn {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 0.5rem 0rem !important;\n  height: fit-content !important;\n\n  .p-button-icon {\n    font-size: 2rem !important;\n  }\n\n  &:focus-visible,\n  &:focus {\n    outline: none !important;\n    box-shadow: none !important;\n  }\n}\n\n.st-label {\n  color: white;\n  font-family: var(--fontBarlowRegular);\n  font-size: var(--font-size-xs);\n}\n\n.t-subheader-content {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  justify-content: center;\n  margin: 1rem 3.75rem 0 1.5rem;\n}\n\n.form-container {\n  .form {\n    &.md {\n\n      .pointsofattention-fields,\n      .agents-fields,\n      .app-fields,\n      .translation-fields {\n\n        #input-label-name,\n        #input-label-code,\n        #input-label-pointServiceImage {\n          width: 20rem !important;\n          max-width: 100% !important;\n        }\n\n        #input-label-description,\n        #input-label-url,\n        #input-label-publickey,\n        #input-label-version {\n          width: 100% !important;\n        }\n\n        #dropdown-pointServiceType,\n        #dropdown-version,\n        #dropdown-status {\n          max-width: 90% !important;\n        }\n\n        #dropdown-tenantid,\n        #dropdown-segment,\n        #dropdown-currentversion,\n        #dropdown-installedversion {\n          max-width: 90% !important;\n        }\n\n        #input-label-key,\n        #input-label-translationvalue,\n        #dropdown-type,\n        #dropdown-translationlanguage,\n        #multiselect-functionality {\n          width: 20rem !important;\n          max-width: 100% !important;\n        }\n      }\n\n      .app-fields {\n        .label-container {\n          button {\n            margin-left: 0 !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n.form {\n  align-items: flex-start;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  width: 25rem;\n\n  .p-inputtext,\n  .ui-dropdown-wrapper,\n  .p-multiselect {\n    max-width: 20rem !important;\n    width: 20rem !important;\n  }\n\n  .p-input-icon {\n    &:last-of-type {\n      margin-bottom: 0 !important;\n    }\n  }\n\n  &.sm {\n    width: 20rem;\n  }\n\n  &.md {\n    width: 30rem;\n\n    .p-inputtext,\n    .p-dropdown,\n    .p-multiselect {\n      width: 25rem !important;\n      max-width: 25rem !important;\n    }\n  }\n\n  &.lg {\n    width: 35rem;\n\n    .p-inputtext,\n    .p-dropdown,\n    .p-multiselect {\n      width: 30rem !important;\n      max-width: 30rem !important;\n    }\n  }\n\n  &.left {\n    align-items: flex-start;\n  }\n\n  &.center {\n    align-items: center;\n  }\n\n  .rd-only {\n    border: none !important;\n  }\n}\n\n.lb {\n  width: fit-content !important;\n}\n\n.p-sidebar {\n  box-shadow: none !important;\n  width: 20.25rem;\n\n  .p-sidebar-header {\n    background-color: var(--mainColor) !important;\n    border: none !important;\n  }\n\n  .p-sidebar-content {\n    padding: 1.25rem !important;\n\n    .p-panelmenu .p-toggleable-content {\n      .p-panelmenu-content {\n        background-color: var(--mainColorShade10);\n\n        .p-submenu-list {\n          padding-left: 0;\n\n          &:first-child {\n            margin-top: var(--padding-level-eight);\n          }\n\n          .p-menuitem {\n            margin-bottom: var(--padding-level-eight);\n\n            .p-menuitem-link {\n              padding: 0.625rem 1rem 0.625rem var(--padding-level-forty);\n\n              .p-menuitem-text {\n                font-family: var(--fontBarlowMedium) !important;\n                line-height: 1.5;\n              }\n  \n              &:has(.pi-angle-down) {\n                background-color: var(--mainColorShade30);\n              }\n            }\n\n            .p-toggleable-content {\n              .p-submenu-list {\n                .p-menuitem-link {\n                  padding-left: var(--padding-level-sixty-four);\n\n                  .p-menuitem-text {\n                    line-height: 1.5;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .p-panelmenu .p-menuitem-text {\n      line-height: 1.5;\n    }\n\n    .p-panelmenu.p-component {\n      height: calc(100vh - 200px);\n      display: flex;\n      flex-direction: column;\n\n      .p-panelmenu-panel {\n        background-color: var(--mainColor);\n        margin-bottom: var(--padding-level-sixteen);\n        \n        &:last-of-type {\n          .p-component.p-panelmenu-header {\n            .p-panelmenu-header-link {\n              margin-bottom: 0 !important;\n            }\n          }\n        }\n      }\n    }\n\n    &.one-child {\n      .p-panelmenu-panel:nth-last-child(2) {\n        margin-bottom: auto;\n      }\n    }\n\n    &.two-childs {\n      .p-panelmenu-panel:nth-last-child(3) {\n        margin-bottom: auto;\n      }\n    }\n\n    &.three-childs {\n      .p-panelmenu-panel:nth-last-child(4) {\n        margin-bottom: auto;\n      }\n    }\n  }\n}\n\n.sb-header-logo {\n  height: 1.5rem;\n  width: auto;\n}\n\n.sb-header-btn {\n  align-items: center;\n  border: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-end;\n  outline: none;\n  width: 100%;\n  background-color: var(--mainColor);\n  color: var(--cardBackgroundColorOne) !important;\n}\n\n.sb-header-text-c {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  justify-content: center;\n  margin-left: 0.5rem;\n  text-align: start;\n}\n\n.sidepanel__close-icon-container {\n  width: 2.5rem;\n  height: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .sb-header-icon {\n    color: var(--cardBackgroundColorOne) !important;\n    font-weight: bold !important;\n  }\n\n  &:hover {\n    background-color: var(--backgroundHoverButtonHeader);\n    border-radius: 50%;\n  }\n}\n\n.sb-header-title {\n  color: var(--mainColor);\n  font: var(--fontBarlowExtraBold);\n  font-size: var(--font-size-md);\n  font-weight: bold;\n}\n\n.sb-header-subtitle {\n  color: var(--mainColor);\n  font: var(--fontBarlowMedium);\n  font-size: var(--font-size-md);\n}\n\n.dash-c {\n  align-items: stretch;\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  flex-basis: 0;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n}\n\n.dash-content-c {\n  // align-items: flex-start;\n  display: grid;\n  // flex: 1;\n  // flex-direction: column;\n  width: auto;\n}\n\n.dash-c-header {\n  align-items: center;\n  display: flex;\n  gap: 2.5rem;\n  justify-content: space-between;\n  padding: 2.5rem 0 2rem;\n  width: 100%;\n\n  .title {\n    padding-top: 0;\n  }\n}\n\n.dash-c-header-welcome {\n  .title {\n    color: var(--mainColor) !important;\n    font-family: var(--fontDosisBold);\n    font-size: 1.25rem !important;\n  }\n  .subtitle {\n    font-family: var(--fontDosisSemiBold);\n    font-size: 1.75rem !important;\n    color: #333;\n  }\n}\n\n.dash-c-header-us-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n\n  p {\n    font-size: 0.875rem !important;\n    color: #666;\n  }\n}\n\n.dash-c-header-extras {\n  align-items: center;\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n\n  .dash-extra-tools {\n    align-items: center;\n    display: flex;\n    gap: 3rem;\n    justify-content: center;\n    top: 121px;\n    left: 768px;\n    width: 253px;\n    height: 87px;\n    /* UI Properties */\n    background: #ffffff 0% 0% no-repeat padding-box;\n    box-shadow: 0px 3px 6px #cccccc80;\n    border-radius: 8px;\n    opacity: 1;\n\n    .btn-tool {\n      align-items: center;\n      display: flex;\n      flex-direction: column;\n      gap: 0.25rem;\n      justify-content: center;\n\n      .info-text {\n        color: var(--mainColor) !important;\n        font: var(--fontDosisRegular) !important;\n        font-size: 0.875rem !important;\n        font-weight: bold !important;\n      }\n\n      .tool-icon {\n        height: 1.7rem !important;\n      }\n    }\n  }\n\n  .dash-extra-more-info {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 0.5rem;\n    top: 121px;\n    left: 1037px;\n    width: 126px;\n    height: 87px;\n    /* UI Properties */\n    border: 1px dashed var(---666666);\n    box-shadow: 0px 3px 6px #00000029;\n    border: 1px dashed #666666;\n    border-radius: 6px;\n    opacity: 1;\n\n    .info-icon {\n      color: var(--mainColor) !important;\n      font-size: 1.2rem;\n      font-weight: bold !important;\n    }\n\n    .info-text {\n      color: var(--mainColor) !important;\n      font: var(--fontDosisRegular) !important;\n      font-size: 0.875rem !important;\n      font-weight: bold !important;\n    }\n  }\n}\n\n.dash-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 0 2.5rem;\n  justify-self: center;\n\n  .title {\n    color: var(--mainColor) !important;\n    font: var(--fontDosisBold) !important;\n    font-size: 1.375rem !important;\n    font-weight: bold !important;\n\n    &:hover {\n      cursor: auto;\n    }\n  }\n\n  .card-container {\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    justify-content: flex-start;\n    margin-top: 1rem;\n\n    .card-dash {\n      align-items: center;\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem !important;\n      justify-content: center;\n      top: 352px;\n      left: 364px;\n      width: 247px;\n      height: 243px;\n      /* UI Properties */\n      background: #ffffff 0% 0% no-repeat padding-box;\n      box-shadow: 0px 3px 6px #cccccc80;\n      border-radius: 8px;\n      opacity: 1;\n\n      .p-card-body {\n        height: 100% !important;\n\n        .p-card-content {\n          height: 100% !important;\n          display: flex !important;\n          flex-direction: column !important;\n          justify-content: space-between !important;\n\n          .iu-icon-right {\n            align-self: flex-end;\n          }\n        }\n      }\n\n      .dash-card-title {\n        color: var(--mainColor) !important;\n        font: var(--fontBarlowBold) !important;\n        font-size: 1.25rem !important;\n        margin-top: 1.5rem !important;\n\n        &:hover {\n          cursor: pointer;\n          text-decoration: underline;\n        }\n      }\n\n      .dash-card-content {\n        font: var(--fontBarlowRegular) !important;\n        margin-bottom: auto !important;\n        margin-top: 1rem !important;\n        font-size: 14px !important;\n      }\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n// .dash-content-footer {\n//   margin: 1rem 0rem 2rem 0rem;\n//   align-self: center;\n//   align-items: center;\n//   display: flex;\n//   justify-content: center;\n//   justify-self: center;\n//   top: 687px;\n//   left: 364px;\n//   width: 90%;\n//   height: 40px;\n//   /* UI Properties */\n//   font-weight: bold;\n//   background: var(--unnamed-color-ffab35) 0% 0% no-repeat padding-box;\n//   background: #ffab35 0% 0% no-repeat padding-box;\n//   border-radius: 8px 8px 0px 0px;\n//   opacity: 1;\n// }\n\n.form-container {\n  align-items: center;\n  background-color: var(--cardBackgroundColorTwo);\n  border-radius: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 35rem;\n\n  &.md {\n    width: 40rem;\n  }\n\n  &.lg {\n    width: 45rem;\n  }\n\n  &.left {\n    align-items: flex-start;\n  }\n\n  &.center {\n    align-items: center;\n  }\n}\n\n.form-btngroup-footer {\n  align-items: center;\n  align-self: flex-end;\n  display: flex;\n  justify-content: center;\n}\n\n.p-mask-sidebar.active {\n  position: absolute !important;\n  top: -80px;\n  height: calc(100vh + 80px);\n  width: 100vw;\n  background-color: rgba(0, 0, 0, 0.65);\n  z-index: 2;\n}\n\np.us-info-time-ip {\n  color: var(--cardBackgroundColorOneShade80) !important;\n}",".dt-header-icon {\n  font-size: 1.5rem !important;\n\n  &.active {\n    color: var(--mainColor);\n  }\n}\n\n.dt-c {\n  box-shadow: 0px 3px 6px var(--shadow);\n\n  h3,\n  .p-column-title {\n    font-weight: bold !important;\n  }\n}\n\n.act-btn {\n  align-items: center !important;\n  display: flex;\n  height: 1.75rem !important;\n  justify-content: center !important;\n  padding: 0.75rem 0 !important;\n  width: 1.75rem !important;\n}\n\n.act-icon {\n  font-size: 0.875rem;\n\n  &.detail {\n    color: var(--successColor);\n  }\n\n  &.edit {\n    color: var(--infoColor);\n  }\n\n  &.error {\n    color: var(--errorColor);\n  }\n\n  &.clone {\n    color: var(--errorColor);\n  }\n\n  &.import {\n    color: var(--errorColor);\n  }\n\n  &.export {\n    color: var(--errorColor);\n  }\n}\n\n.tablefilter-mc {\n  display: flex;\n  justify-content: flex-start;\n  column-gap: 2rem;\n  margin-inline: auto;\n  width: 100%;\n\n  .p-button {\n    background-color: transparent !important;\n    border: none !important;\n    color: var(--mainColor);\n    padding: 0.5rem !important;\n    transition: background-color .3s ease-in !important;\n\n    &:hover {\n      background-color: rgba(241, 240, 240, 0.8) !important;\n      color: var(--mainColor);\n    }\n  }\n}\n\n.multiactions-c {\n  .access-button {\n    max-width: 10rem !important;\n  }\n}\n\n.subheader-buttons {\n  display: flex;\n  justify-content: flex-end;\n  column-gap: 2rem;\n  margin-inline: auto;\n  width: 100%;\n\n  .subheaderactions-module_actions__otXOo {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  .hover {\n    &:hover {\n      background-color: rgba(241, 240, 240, 0.8) !important;\n      color: var(--mainColor);\n    }\n  }\n}\n\n.subheader-buttons-roles {\n  display: flex;\n  justify-content: flex-end;\n  column-gap: 2rem;\n  margin-inline: auto;\n  width: 100%;\n\n  .access-button {\n    max-width: 18rem !important;\n  }\n\n  .subheaderactions-module_actions__otXOo {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  .hover {\n    &:hover {\n      background-color: rgba(241, 240, 240, 0.8) !important;\n      color: var(--mainColor);\n    }\n  }\n}\n\n.tablefilter-mc2 {\n  display: flex;\n  justify-content: space-between;\n  column-gap: 2rem;\n  margin-inline: auto;\n  width: 100%;\n\n  .p-button {\n    background-color: transparent !important;\n    border: none !important;\n    color: var(--mainColor);\n    padding: 0.5rem !important;\n    transition: background-color .3s ease-in !important;\n\n    .subheaderactions-module_actions__otXOo {\n      margin: 0 !important;\n      padding: 0 !important;\n    }\n  }\n\n  .hover {\n    &:hover {\n      background-color: rgba(241, 240, 240, 0.8) !important;\n      color: var(--mainColor);\n    }\n  }\n}\n\n.p-datatable .p-datatable-header {\n  @media screen and (max-width: 30rem) {\n    height: 4.75rem !important;\n  }\n\n  &:hover {\n    cursor: auto;\n  }\n\n  #iconRefresh {\n    &:hover {\n      color: var(--secondaryColorShade30) !important;\n      cursor: pointer;\n    }\n  }\n\n  #iconColumns {\n    color: initial !important;\n    &:hover {\n      color: var(--secondaryColorShade30) !important;\n      cursor: pointer;\n    }\n  }\n}\n\n.subheaderactions-module_actions__otXOo {\n    @media screen and (max-width: 30rem) {\n      .p-button-vertical {\n        flex-direction: row !important;\n      }\n      .p-button .p-button-icon-top {\n        margin-right: 0.5rem !important;\n        margin-bottom: 0 !important;\n      }\n      .access-button.p-button-vertical {\n        max-width: 10rem !important;\n      }\n  }\n}\n\n.p-column-filter-overlay {\n  .p-multiselect-token-label {\n    max-width: 185px;\n    white-space: initial;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n#userpagetabview-applications-datatable,\n.userpagetabview-roles-datatable {\n  .p-datatable-wrapper {\n    table {\n      thead {\n        .p-frozen-column {\n          width:0 !important;\n          min-width:0 !important;\n          max-width:0 !important;\n        }\n\n        th:last-of-type {\n          width: 130px !important;\n          min-width: 130px !important;\n          max-width: 130px !important;\n\n          .p-column-header-content {\n            transform: translate(-25px);\n          }\n        }\n      }\n  \n      tbody {\n        tr {\n          .p-frozen-column {\n              padding-right: 0 !important;\n              justify-self: flex-end !important;\n\n          .general-actions-datatable {\n              height: 32px;\n              width: 32px;\n\n              button {\n                height: 100% !important;\n                width: 100% !important;\n                transform: translate(8.5px);\n              }\n            }\n          }\n\n          td:last-of-type {\n            padding-left: 0 !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n#text-and-messages-front-datatable {\n  .p-datatable-wrapper {\n    .p-datatable-table {\n      .p-datatable-tbody {\n        .p-datatable-emptymessage {\n          #align-box-empty-template {\n            width: calc(100vw - 304px) !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n.big-screen {\n  #text-and-messages-front-datatable {\n    .p-datatable-wrapper {\n      .p-datatable-table {\n        .p-datatable-tbody {\n          .p-datatable-emptymessage {\n            #align-box-empty-template {\n              width: calc(100vw - 700px) !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// PERMITE AJUSTAR EL TEMPLATE DE TABLA VACIA\n// AÑADIR EL IDEMPTYTEMPLATE EN LAS CUSTOM PROPS\n// DE LA FUNCION TABLEBASICPROPS\n#admin-tenants-empty-box {\n  width: calc(100vw - 304px) !important;\n}\n\n.big-screen {\n  #admin-tenants-empty-box {\n    width: calc(100vw - 700px) !important;\n  }\n}",".inputlabel {\n\n    &.h4 {\n      &.text-upper {\n        text-transform: uppercase;\n      }\n      font-family: var(--fontDosisSemiBold);\n      font-size: var(--font-size-desktop-subtitle);\n      color: var(--mainColor);\n    }\n    \n    &.title {\n      font-family: var(--fontDosisBold);\n      font-size: 1.5rem;\n      color: var(--mainColor);\n      text-transform: uppercase;\n    }\n\n    &.subtitle {\n      font-family: var(--fontBarlowRegular);\n      font-size: var(--font-size-sm);\n      color: var(--labelsAndTextColor);\n    }\n\n    &.subtitle_userdetail {\n      font-family: var(--fontDosisSemiBold);\n      font-size: var(--font-size-desktop-subtitle);\n      color: var(--mainColor);\n    }\n  \n    &.label {\n      align-self: center;\n      font-family: var(--fontBarlowRegular);\n      font-size: var(--font-size-xs);\n      color: var(--labelsAndTextColor);\n    }\n}\n  \n.background-input {\n    background-color: var(--backgroundColor) !important;\n    padding: 0 !important;\n}\n\n.p-inputnumber-input.p-inputtext {\n    background: var(--cardBackgroundColorOne) !important;\n}\n\n.p-dropdown-label.p-placeholder {\n  color: var(--placeholderColor) !important\n}\n",".schedules {\n\n    &-days-container {\n        margin-bottom: var(--space-xxl);\n\n        .p-selectbutton {\n            flex-direction: row !important;\n            flex-wrap:wrap;\n            justify-content: center;\n            gap: 0 !important;\n\n            .p-button {\n                min-width: 2rem;\n                border-radius: 0 !important;\n                padding: 1rem !important;\n            }\n        }\n\n        .p-buttonset .p-button:first-of-type {\n            border-radius: 10px 0px 0 10px !important;\n        }\n\n        .p-buttonset .p-button:last-of-type {\n            border-radius: 0px 10px 10px 0 !important;\n        }\n\n        .p-selectbutton.p-buttonset.p-component {\n            .p-button.p-component.p-highlight {\n                background-color: var(--cardBackgroundColorOneShade10) !important;\n            }\n        }\n    }\n\n    &-scrollbar {\n        display: flex;\n        justify-content: center;\n        height: 80%;\n    }\n}",".schedules-points {\n    &--container {\n        &-box-one {\n            #SelectScheduleContainer {\n                display: flex;\n                flex-direction: column;\n\n                .points-subtitle {\n                    padding-left: var(--space-xl) !important;\n                }\n\n                .dropdowns-container {\n                    width: 55%;\n                    align-self: center;\n                    margin-top: var(--space-s);\n\n                    .skeleton-global-points {\n                        width: 70%;\n                        padding: var(--space-xxl);\n                    }\n                }\n\n                .schedules-load-button {\n                    width: 50%;\n                    align-self: center;\n\n                    .button-container {\n                        display: flex;\n                        justify-content: flex-end;\n                        width: 100%;\n                    }\n                }\n            }\n        }\n\n        &-box-two {\n            #SelectScheduleContainer {\n                display: flex;\n                flex-direction: column;\n\n                .points-subtitle {\n                    padding-left: var(--space-xl) !important;\n                }\n            }\n        }\n    }\n\n    &--view {\n        &-box-two {\n            display: flex;\n            justify-content: center;\n            height: calc(var(--breakpoint-xs) + var(--space-l));\n\n            &__selectdays{\n                max-width: var(--breakpoint-sm);\n\n                #SelectScheduleContainer {\n                    height: 100%;\n\n                    .scrollbar-container.ps.ps--active-y {\n                        height: 90% !important;\n                    }\n\n                    .points-subtitle {\n                        padding-left: var(--space-xl) !important;\n                    }\n                }\n            }\n        }\n    }\n}",".custom-form-box-container {\n    .fields-main-container {\n        display: flex;\n        justify-content: center;\n        .fields-box {\n            max-width: 75%;\n            justify-content: space-between;\n        }   \n    }\n}\n\n// Box - Roles management - Protocols Page\n.custom-form-box__protocols-actions {\n    .custom-form-box-container {\n        .fields-main-container {\n            .fields-box {\n                width: 100%;\n\n                div:first-child,\n                div:last-child {\n                    small {\n                        margin-bottom: 0 !important;\n                    }\n                }\n\n                div:nth-child(2) {\n                    .ibp-inputtextarea-field + small {\n                        margin-bottom: 0 !important;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Box - Roles management - Protocols CLONE Page\n.custom-form-box__protocols-actions-clone {\n    .custom-form-box-container {\n        .fields-main-container {\n            padding-bottom: 0 !important;\n\n            .fields-box {\n                width: 100%;\n\n                div:nth-child(2) {\n                    .ibp-inputtextarea-field + small {\n                        margin-bottom: 0 !important;\n                    }\n                }\n    \n                div:nth-child(3) {\n                    position: relative;\n                    top: -30px;\n                    margin-bottom: 0 !important;\n\n                    &>small {\n                        margin-bottom: 0 !important;\n                    }\n                }\n            }\n        }\n    }\n}",".roles-management-main-section {\n    .roles-page-title {\n        &__detail {\n            &--text {\n                margin-top: var(--space-l);\n                text-transform: none;\n                font-family: var(--fontBarlowMedium);\n                font-size: var(--font-size-md);\n                color: var(--cardBackgroundColorOneShade80);\n            }\n        }\n    }\n\n    .roles-actions-boxfull {\n        .tablefilter-mc2 {\n            justify-content: flex-end;\n        }\n    }\n\n    .form-section {\n        .boxfull-module_boxFullContainer__9jypm {\n            margin: 0 !important;\n    \n            &>div:first-of-type {\n                padding-top: 0 !important;\n                padding-left: 0;\n                padding-right: 0;\n            }\n\n            .text-area-readonly:hover,\n            .text-area-readonly:enabled:focus {\n                border-color: var(--borderAndLineColor);\n            }\n        }\n    }\n    \n    .actions-roles-description-box {\n    \n        &__container {\n            &--title {\n                .boxTitle--roles {\n                    margin-bottom: var(--padding-level-twenty-four);\n                    margin-left: var(--padding-level-thirty-two);\n                }\n            }\n        }\n    }\n\n    .admin-roles-tabview {\n        .p-tabview-nav-container {\n            display: none;\n          }\n\n        .p-tabview-panels {\n            padding-top: 0;\n\n            .p-accordion.p-component {\n                .p-accordion-tab {\n                    margin-bottom: var(--space-base);\n                }\n            }\n        }\n    }\n\n    .roles-management-buttons {\n        &__button-container {\n            margin: 0 128px var(--padding-level-thirty-two) !important;\n        }\n    }\n\n    .boxfull-module_boxFullContainer__9jypm  {\n        .new-reactive-button {\n            padding: var(--padding-level-eight);\n            margin: 8px 0;\n\n            button {\n                height: 34px !important;\n                width: 34px !important;\n                padding: 0 !important;\n                border-radius: 50%;\n                border: var(--infoColor) 1px solid !important;\n                background-color: white !important;\n            }\n\n            &:hover {\n                text-decoration: underline var(--mainColor);\n                \n                button {\n                    background-color: var(--mainColorTint90) !important;\n                }\n            }\n        }\n    }\n\n    #functionalities-accordion-multiple {\n        .p-accordion-content {\n            .p-datatable {\n                .p-column-header-content {\n                    .ibp-checkbox-field {\n                        margin-top: 5px;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.role-actions-datatable {\n    div:first-of-type {\n        gap: 1rem !important;\n    }\n}\n\n#adminRolesContainer {\n    .p-tree-container {\n        .p-treenode-content.role-card-selected.p-treenode-selectable {\n            background: var(--mainColor) !important;\n            color: var(--cardBackgroundColorOne) !important;\n        }\n\n        .p-treenode-content .p-treenode-label{\n            color: var(--cardBackgroundColorOneShade80);\n        }\n\n        .role-card-selected .p-treenode-content .p-treenode-label{\n            color: var(--cardBackgroundColorOne);\n        }\n    }\n}\n\n#roles-tooltip-box {\n    .help-name-application {\n        color: var(--successColor);\n        font-size: 1.5rem;\n    }\n}",".transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 {\n    max-width: 100% !important;\n    margin: 0 128px !important;\n\n    .subheadertitle-module_subheaderTitle__7cmNY {\n        .subheadertitle-module_title__nczSu > div {\n            position: relative;\n            left: -20px;\n        }\n    }\n\n    .t-subheader-content {\n        span {\n            position: relative;\n            left: 15px;\n        }\n    }\n}\n\n.subheaderactions-module_actions__otXOo {\n    max-width: 100% !important;\n    margin: 0 128px !important;\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.boxfull-module_boxFullContainer__9jypm {\n    max-width: 100% !important;\n    margin: 0 128px !important;\n\n    &>div {\n        margin-left: 0 !important;\n        margin-right: 0 !important;\n    }\n\n    .boxfull-module_content__8-IMh {\n        .p-tabview {\n            .p-tabview-panels {\n                .p-tabview-panel {\n                    .boxfull-module_boxFullContainer__9jypm {\n                        margin: 0 !important;\n\n                        .subheaderactions-module_actions__otXOo {\n                            margin: 0 !important;\n                        }\n                    }\n\n                    .subheaderactions-module_actions__otXOo {\n                        margin: 0 !important;\n                    }\n                }\n\n            }\n        }\n    }\n}\n\n// Esta clase aparece cuando el ancho de pantalla es superior a 1920px.\n// Las subclases atienden de manera transversal, los márgenes de las cajas\n// contenidas dentro de esta clase y que se ordenan de forma vertical.\n// Esta implementación se debe tomar como referencia para cada una de las\n// páginas que se construyan a continuación (Wed, Jan-24-2024)\n\n.big-screen {\n    height: 0;\n\n    .transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 {\n        margin-left: calc(128px + 352px) !important;\n    }\n\n    .multiactions-c {\n        margin-left: calc(128px + 352px) !important;\n    }\n\n    .multiactions-c + .boxfull-module_boxFullContainer__9jypm {\n        margin-left: calc(128px + 352px) !important;\n    }\n\n    .transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 + .subheaderactions-module_actions__otXOo {\n        margin-left: calc(128px + 352px) !important;\n\n        & + .boxfull-module_boxFullContainer__9jypm {\n            margin-left: calc(128px + 352px) !important;\n\n            & + .boxfull-module_boxFullContainer__9jypm {\n                margin-left: calc(128px + 352px) !important;\n            }\n        }\n    }\n\n    .transactionalsubheader-module_transactionalSubheaderContainer__MgCB8 + .boxfull-module_boxFullContainer__9jypm,\n    .layout-pagedescription-box + .boxfull-module_boxFullContainer__9jypm {\n        margin-left: calc(128px + 352px) !important;\n    }\n\n    .custom-form-box-container {\n        margin-left: 352px;\n    }\n\n    .action-page-description {\n        margin-left: calc(128px + 352px) !important;\n    }\n\n    .footer-container {\n        padding-left: 320px !important;\n    }\n\n    .dashboard-external-container,\n    .section_detail_audit_report {\n        margin-left: calc(325px);\n    }\n\n    .dashboard-internal-container,\n    #wrapper-auditory-report {\n        margin-left: calc(325px);\n    }\n    \n    .role-main-container {\n        margin-left: calc(128px + 352px) !important;\n    }\n\n    #wrapper-applications,\n    #wrapper-applications-export,\n    #wrapper-applications-import,\n    #margin-fixed-bgscreen {\n        margin-left: calc(128px + 352px) !important;\n    }\n}",".role-selector-container {\n    cursor: pointer;\n\n    .rol-icon-box {\n        .iu.iu-icon-user {\n            color: var(--cardBackgroundColorOne);\n    \n            &::before {\n                font-size: 20px;\n            }\n        }\n    \n        .iu.iu-icon-down,\n        .iu.iu-icon-up {\n            color: var(--cardBackgroundColorOne);\n    \n            &::before {\n                font-size: 12px;\n            }\n        }\n    }\n\n    .role-text-container {\n        .label-container {\n            padding-bottom: 4px;\n        }\n\n        .label-container label,\n        span {\n            color: var(--cardBackgroundColorOne);\n        }\n    }\n}\n\n#overlay_panel_role_selector {\n    z-index: 1003 !important;\n    transform-origin: 0 !important;\n    transform: translate(55px) !important;\n    margin-top: 25px;\n    --overlayArrowLeft: 271px !important;\n\n    .p-overlaypanel-content {\n        padding-left: 0;\n        padding-right: 0;\n\n        .overlay-content-box {\n            &__role-selector-title {\n                color: var(--cardBackgroundColorOneShade80);\n                padding-left: var(--padding-level-twenty-four);\n                padding-right: var(--padding-level-twenty-four);\n            }\n\n            .p-divider {\n                width: calc(100% -  var(--padding-level-forty-eight));\n                margin-left: var(--padding-level-twenty-four);\n                // margin-right: var(--padding-level-twenty-four);\n            }\n\n            .p-component.p-panelmenu-header{\n                    background-color: var(--cardBackgroundColorOne);\n    \n                .p-panelmenu-header-link{\n                    border-radius: 0;\n                    background-color: var(--cardBackgroundColorOne);\n                    padding-left: var(--padding-level-twenty-four);\n                    padding-top: var(--padding-level-sixteen);\n                    padding-bottom: var(--padding-level-sixteen);\n    \n                    .p-menuitem-text {\n                        color: var(--cardBackgroundColorOneShade80);\n                        text-align: start;\n                    }\n    \n                    &:hover {\n                        background-color: var(--cardBackgroundColorTwo);\n                    }\n                }\n            }\n\n            .role-selector-items {\n                .p-panelmenu-panel {\n                    .p-toggleable-content {\n                        .p-panelmenu-content {\n                            background: var(--cardBackgroundColorOne);\n                        }\n                    }\n                }\n            }\n        }\n\n    }\n}",".create-labels-form-box {\n    .boxfull-module_boxFullContainer__9jypm {\n        margin-left: 0 !important;\n        margin-right: 0 !important;\n    }\n}",".new-product-page-dialog,\n.new-property-component-dialog,\n.new-functionality-component-dialog,\n.edit-property-page-dialog,\n.new-transactions-page-dialog,\n.new-mappedfield-page-dialog,\n.new-quicklinks-page-dialog {\n    &:has(.create-labels-form-box) {\n        #pr_id_1_content {\n            padding-left: 0;\n            padding-right: 0;\n        }\n    }\n\n    .boxfull-module_content__8-IMh.boxfull-module_tertiary__iL2gt {\n        padding: 0 !important;\n\n        .form-container {\n            .form {\n                &>div:first-of-type {\n                    justify-content: center !important;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
